(function ($) {
    var $body = $('body'),
        $doc = $(document),
        $html = $('html'),
        $win = $(window);

    $doc.ready(() => {
        $doc.ajaxStart(() => {
            halo.isAjaxLoading = true;
        });

        $doc.ajaxStop(() => {
            halo.isAjaxLoading = false;
        });

        halo.ready();
    });
      window.onscroll = function() {
        $(".card-media").each(function (i, el) {
         if($(this).hasClass('autoplay')){
           $(el).find('video').get(0).play();
         }
        });
     }
    // window.onload = function() { 
    //     halo.init();
    // }
  $( document ).ready(function() {
    halo.init(); 
  });
    var halo = {
        haloTimeout: null,
        isAjaxLoading: false,

        ready: function (){
            this.loaderScript();
            this.loaderProductBlock();
            
            if (navigator.userAgent.match(/OS X.*Safari/) && ! navigator.userAgent.match(/Chrome/)) {
                document.body.classList.add('safari')
            } else {
                document.body.classList.add('chrome')
            }

            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            if (isIOS) document.body.classList.add('iOS')

          if ($body.hasClass('template-product')) {
                this.loaderRecommendationsBlock();
                this.scrollToReview();
                
                //play video
                $(document).on('click', '.productView-images .video-play', function () {
                  var container = $(this).closest('.productView-video.mp4');
                  var videoElement = container.find('video').get(0);

                  //fix The play() request was interrupted by a call to pause() start
                  $('video').each(function () {
                      if (!this.paused) {
                          this.pause();
                      }
                  });
                  
                  $('.video-play').show();
                  $('.modal-close').hide();
                  // fix The play() request was interrupted by a call to pause() ends
                  
                  $(this).hide();
                  container.find('.modal-close').show();
                  if (videoElement) {
                      videoElement.play().catch(function(error) {
                          console.error('Error trying to play the video:', error);
                      });
                  }
                });
                
                // pause video
                $(document).on('click', '.productView-images .modal-close', function () {
                  var container = $(this).closest('.productView-video.mp4');
                  var videoElement = container.find('video').get(0);
                  if (videoElement && !videoElement.paused) {
                      videoElement.pause();
                  }
                  container.find('.modal-close').hide();
                  container.find('.video-play').show();
                });
                
                // pause video if clicked outside
                $(document).on('click', function (event) {
                  if (!$(event.target).closest('.productView-video.mp4').length) {
                      $('.productView-video.mp4').each(function () {
                          var video = $(this).find('video').get(0);
                          if (video && !video.paused) {
                              video.pause();
                              video.currentTime = 0;
                          }
                          $(this).find('.modal-close').hide();
                          $(this).find('.video-play').show();
                      });
                  }
                });

            }

            if($('[data-product-tab-block]').length) {
                this.clickedActiveProductTabs();
            }

            if ($body.hasClass('product-card-layout-07')) {
                this.calculateTranslateYHeight()
            }
            
            window.sharedFunctions = {
                setLocalStorageProductForWishlist: this.setLocalStorageProductForWishlist,
                checkNeedToConvertCurrency: this.checkNeedToConvertCurrency,
                productBlockSilder: this.productBlockSilder,    
                productBlockScroller: this.productBlockScroller,
                calculateTranslateYHeight: this.calculateTranslateYHeight,
            }
        },
        
        init: function () {
            this.initMultiTab();
            this.initMultiTabMobile();
            this.productBlockInfiniteScroll();
            this.initGlobalCheckbox();
            this.initColorSwatch();
            this.initAddToCart();
            this.initQuickShop();
            this.initQuickCart();
            this.initNotifyInStock();
            this.initCompareProduct();
            this.initWishlist();
            this.initAskAnExpert();
            this.initHeader();
            this.initStickyHeaderHeight();
            this.headerLanguageCurrency();
            this.headerMasonry();
            this.initLiveChat();
            this.headerSidebarSearch();
            this.headerStickySearchForm();
            this.initCountdown();
            this.collectionCountdown();
            this.handleScrollDown();
            this.initVideoPopup();
            this.swapHoverVideoProductCard();
            this.initDynamicBrowserTabTitle();
            this.initWarningPopup();
            this.clickIconScrollSection();
            this.specialBanner();
            this.initScrollTop();
            this.initBrandsPage();
           // this.initCustomCartTabs();
            this.initCustomTabs();
            this.updateGDFreeShippingBar();
            this.updateExclusiveProduct();
            this.checkExclusiveProductInCart();
            this.checkExclusiveProductEligibility();
            this.restrictGiftBagQuantity();

            if ($('.search-for-mobile-search-container').length) {
                this.initMobileSearch();
            }

            // this.initChatSearchPopup();

            if ($('.home-faq-section').length) {
                this.initHomeFAQ();
            }
            if ($('.blog-slider-section').length) {
                this.initFeaturedBlogs();
            }
            if ($('.scrolling-text-section').length) {
                this.initScrollingText();
            }
            if ($('.footer-08').length) {
                this.initFooter08();
            }
            this.initMobileLoginInfo();

          console.log("init function");
         
            if ($('.lookbook-carousel').length) {
                this.lookbookCarousel();
            }

            // Init Quick View 
            if (window.quick_view.show || window.quick_view.show_mb) {
                this.initQuickView();
            }

            // Init Mobile Menu 
            if (window.innerWidth < 1025) {
                this.menuSidebarMobile();
                this.menuSidebarMobileToggle();
            }

            // Check Lazyload Done
            const loadingImages = document.querySelectorAll('.media--loading-effect img')
            const productGrid = document.getElementById('main-collection-product-grid')

            if (loadingImages.length > 0 || productGrid) {
                this.initLazyloadObserver(loadingImages, productGrid);
            }

            if($body.hasClass('show_effect_close')) {
                this.backgroundOverlayHoverEffect();
                this.backgroundOverlayHoverEffect1();
            }

            if (window.innerWidth > 1024) {
                this.productMenuSlider();
            }

            if($body.hasClass('template-cart')) {
                this.updateGiftWrapper();
                this.checkInMainCart();
                this.looklabView();
            }
            
            if($body.hasClass('template-product')) {
                this.initVideoImageHeight();
                this.initProductView($('.halo-productView'));
                this.initProductBundle();
                this.articleGallery();
                this.toggleSidebarMobile(); 
                this.initCollapseSidebarBlock();    
                this.initCategoryActive();
                this.initProductReviewSection();
                this.productCustomInformation();
                this.iconZoomClickMobile();
                this.looklabView();
                this.lookLabAddItem();
                this.lookLabSearchProductCard();
                this.lookLabAddAllItemInCart();
                this.looklabProductVariantSwitch();
                this.looklabCheckVariantInCart();
                this.availableInLooks();
              
            }

            if($body.hasClass('template-blog') || $body.hasClass('template-article')) {
                this.initCollapseSidebarBlock();
                this.initCategoryActive();
                this.toggleSidebarMobile();
                this.initBlogMasonry();
                this.productBlockSilderSidebar();
                this.productBlockSilderArticle();
            }

            if($body.hasClass('template-article')) {
                this.articleGallery();
            }

            if($body.hasClass('template-collection') || $body.hasClass('template-search')) {
                this.initCollapseSidebarBlock();
                this.initCategoryActive();
                this.toggleSidebarMobile();
                this.productBlockSilderSidebar();
                this.initInfiniteScrolling();
                this.initQuickShopProductList();
            }

            if($body.hasClass('template-list-collections')) {
                this.toggleSidebarMobile();
                this.productBlockSilderSidebar();
            }
            if($body.hasClass('template-collection') && $('.collection-express-order').length) {
                this.toggleVariantsForExpressOrder();
                this.initExpressOrderAddToCart();
            }
          if ($body.hasClass("template-collection")) {
             
               //this.initSidebar();
              if ($("[data-filter-type-tag]").length) {
                this.filterSidebar();
                this.hide_filter();
              }
             }

            if ($body.hasClass("dspg-page-brands")) {
              this.initBrandsPage();
            }

            if ($body.hasClass("template-page")) {
              this.initReturnModule();
            }
            if ($('.product-recs-slider').length) {
                this.initProductRecs();
            }
            
            if ($('.color-recs-slider').length) {
                this.initColorSlider();
            }
            if ($('#morelikethis').length) {
                this.initMoreLikeThis();
            }
            
            halo.checkScrollLayoutForRecenlyViewed();

            let checkMenuMobile;
            window.innerWidth > 1024 ? checkMenuMobile = true : checkMenuMobile = false;

            $win.on('resize', () => {
                this.headerSidebarSearch();
                this.specialBanner();
                this.specialBannerSlider();
                if (window.innerWidth > 1024) {
                    document.body.classList.remove('menu_open')
                } else if (checkMenuMobile) {
                    checkMenuMobile = false;
                    this.menuSidebarMobile()
                    this.menuSidebarMobileToggle()
                    this.initMultiTab()
                    this.initMultiTabMobile()
                }
            });
          $(document).on("mousemove", this.autoplayRandomVideos);
        },
        
        checkNeedToConvertCurrency: function () {
            return (window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
        },

        loaderScript: function() {
            var load = function(){
                var script = $('[data-loader-script]');

                if (script.length > 0) {
                    script.each((index, element) => {
                        var $this = $(element),
                            link = $this.data('loader-script'),
                            top = element.getBoundingClientRect().top;

                        if (!$this.hasClass('is-load')){
                            if (top < window.innerHeight + 100) {
                                halo.buildScript(link);
                                $('[data-loader-script="' + link + '"]').addClass('is-load');
                            }
                        }
                    })
                }
            }
            
            load();
            window.addEventListener('scroll', load);
        },

        buildScript: function(name) {
            var loadScript = document.createElement("script");
            loadScript.src = name;
            document.body.appendChild(loadScript);
        },

        buildStyleSheet: function(name, $this) {
            if (name == '') return;
            const loadStyleSheet = document.createElement("link");
            loadStyleSheet.rel = 'stylesheet';
            loadStyleSheet.type = 'text/css';
            loadStyleSheet.href = name;
            $this.parentNode.insertBefore(loadStyleSheet, $this);
        },

        loaderProductBlock: function() {
            var isAjaxLoading = false;

            $doc.ajaxStart(() => {
                isAjaxLoading = true;
            });

            $doc.ajaxStop(() => {
                isAjaxLoading = false;
            });

            const handler = (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const $block = $(entry.target);
                        if ($block.hasClass('ajax-loaded')) return;

                        var url = $block.data('collection'),
                            layout = $block.data('layout'),
                            limit = $block.data('limit'),
                            image_ratio = $block.data('image-ratio'),
                            swipe = $block.data('swipe'),
                            sectionId = $block.attr('sectionId');
                            hasCountdown = $block.attr('hasCountdown');

                        if(url != null && url != undefined) {
                            $.ajax({
                                type: 'get',
                                url: window.routes.root + '/collections/' + url,
                                cache: false,
                                data: {
                                    view: 'ajax_product_block',
                                    constraint: 'limit=' + limit + '+layout=' + layout + '+sectionId=' + sectionId + '+imageRatio=' + image_ratio + '+swipe=' + swipe + '+hasCountdown=' + hasCountdown
                                },
                                beforeSend: function () {
                                    $block.addClass('ajax-loaded');
                                },
                                success: function (data) {
                                    if (url != '') {
                                        if (layout == 'grid') {
                                            $block.find('.products-grid').html(data);
                                        } else if (layout == 'slider'){
                                            $block.find('.products-carousel').html(data);
                                        } else if (layout == 'scroll') {
                                            $block.find('.products-flex').html(data);
                                        }
                                    }
                                },
                                complete: function () {
                                    if (layout == 'slider') {
                                        halo.productBlockSilder($block);
                                    }

                                    if (layout == 'scroll') {
                                        const enableHover = $block.find('[data-enable-hover]').attr('data-enable-hover')
                                        if (enableHover === 'true') {
                                            halo.productBlockScroller($block);
                                        }
                                    }

                                    if ($block.hasClass('special-banner__product') && layout == 'grid' && window.innerWidth < 1200) {
                                        $block.find('.special-banner__products--grid').addClass('products-carousel');
                                        halo.productBlockSilder($block);
                                    }
                                    
                                    if(window.compare.show){
                                        var $compareLink = $('[data-compare-link]');

                                        halo.setLocalStorageProductForCompare($compareLink);
                                    }

                                    halo.swapHoverVideoProductCard();

                                    if(window.wishlist.show){
                                        halo.setLocalStorageProductForWishlist();
                                    }

                                    if (halo.checkNeedToConvertCurrency()) {
                                        Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                                    };

                                    if (window.review.show && $('.shopify-product-reviews-badge').length > 0 && window.SPR != null && typeof window.SPR.registerCallbacks === 'functions') {
                                        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                                    }

                                }
                            });
                        } else {
                            $block.addClass('ajax-loaded');

                            if (layout == 'slider') {
                                halo.productBlockSilder($block);
                            }

                            if (halo.checkNeedToConvertCurrency()) {
                                Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                            };
                        }
                    }
                })
            }

            this.productBlock = document.querySelectorAll('[data-product-block]');

            const config = {
                threshold: 0.1,
            }

            this.observer = new IntersectionObserver(handler, config);
            this.productBlock.forEach(block => {
                this.observer.observe(block);
            });
        },

        loaderRecommendationsBlock: function(){
            halo.buildRecommendationBlock();
        },

        scrollToReview: function() {
            var $scope = $('.productView-tab');

            if($scope.length){
                $doc.on('click', '.productView-details .halo-productReview', (event)  => {
                    event.preventDefault();

                    $('body,html').animate({
                        scrollTop: $scope.offset().top 
                    }, 1000);
                    var activeTab = $scope.find('[href="#tab-review"]');
                    var activeTabCustom = $scope.find('[href="#tab-customer-reviews"]');
                    var activeTabMb = $scope.find('[href="#tab-review-mobile"]');
                    var activeTabCustomMb = $scope.find('[href="#tab-customer-reviews-mobile"]');
                    if (!activeTab.hasClass('is-open') || !activeTabMb.hasClass('is-open') || !activeTabCustom.hasClass('is-open') || !activeTabCustomMb.hasClass('is-open')) {
                        activeTab[0]?.click();
                        activeTabMb[0]?.click();
                        activeTabCustom[0]?.click();
                        activeTabCustomMb[0]?.click();
                    }
                })
            }
        },

        headerMasonry: function(){
          var menu_dropdown__wrapper = document.querySelector('.menu-dropdown__wrapper [data-masonry]');
          var msnry = new Masonry( menu_dropdown__wrapper, {
             columnWidth: '.grid-sizer',
             itemSelector: '[data-gridItem]'
          }); 
            // $('.menu-dropdown__wrapper [data-masonry]').masonry({
            //   columnWidth: '.grid-sizer',
            //   itemSelector: '[data-gridItem]'
            // });
        },

        initLiveChat: function () {
            var $item_globe = $('.live-wrapper-icon');
            $item_globe.on('click', function (e) {
                $(this).parent().toggleClass('live_help--active');          
            });

            $body.on('click', function (e) {
                if(($('.live_help').hasClass('live_help--active')) && ($(event.target).closest('.live_help').length === 0)){
                    e.preventDefault();
                    $('.live_help').removeClass('live_help--active');
                }
            });
        },

        initHeader: function() {
            const headerAll = document.querySelectorAll('[class*="section-header"]')
            if (headerAll) {
                let index = headerAll.length + 20;
                headerAll.forEach((element) => {
                    if (element.classList.contains('section-header-mobile')) return;
                    element.setAttribute('data-index', index);
                    element.style.zIndex = index;
                    index--
                })

                const headerBasicTransparent = document.querySelector('.header-basic--transparent')
                if (headerBasicTransparent && document.body.classList.contains('template-index')) {
                    const height = headerBasicTransparent.offsetHeight,
                        navTransparent = document.querySelector('.header-navigation[class*="--transparent"]')
                    if (navTransparent) {
                        navTransparent.style.top = `${height}px`
                        navTransparent.classList.add('has-top')
                    }
                }
            }
        },
         initStickyHeaderHeight: function() {
            // Expose the live sticky header height as --sticky-header-height so sticky elements
            // below it (e.g. collection filters) sit flush under it on every device
            const headerGroup = document.querySelector('.sticky-header-group');
            if (!headerGroup) return;

            const setStickyHeaderHeight = () => {
                const height = headerGroup.offsetHeight;
                if (height > 0) {
                    document.documentElement.style.setProperty('--sticky-header-height', `${height}px`);
                }
            };

            setStickyHeaderHeight();

            if ('ResizeObserver' in window) {
                new ResizeObserver(setStickyHeaderHeight).observe(headerGroup);
            } else {
                window.addEventListener('resize', setStickyHeaderHeight);
                window.addEventListener('load', setStickyHeaderHeight);
            }
        },
        headerLanguageCurrency: function() {
            if (!document.querySelector('.header-language_currency')) return;
            const header = document.querySelectorAll('[class*="section-header-"]')

            document.addEventListener('click', (event) => {
                const $target = event.target;
                const $headerLanguageCurrency = $target.closest('.header-language_currency');
                const languageCurrency = $headerLanguageCurrency?.querySelector('.top-language-currency');
                const dropdownCurrency = $headerLanguageCurrency?.querySelector('.dropdown-currency');
                const dropdownLanguage = $headerLanguageCurrency?.querySelector('.dropdown-language');

                if ($target.matches('.header-language_currency') || $target.closest('.header-language_currency')) {
                    if ($target.matches('.icon-languageCurrency') || $target.closest('.icon-languageCurrency')) {
                        languageCurrency?.classList.toggle('show')
                    }
                    else if (($target.matches('.top-language-currency') || $target.closest('.top-language-currency')) && !document.querySelector('.icon-languageCurrency')) {
                        languageCurrency?.classList.toggle('show')
                    }

                    if ($target.matches('.halo-top-currency') || $target.closest('.halo-top-currency')) {
                        dropdownLanguage?.classList.remove('show')
                        dropdownCurrency?.classList.toggle('show')
                    }
                    
                    if ($target.matches('.halo-top-language') || $target.closest('.halo-top-language')) {
                        dropdownCurrency?.classList.remove('show')
                        dropdownLanguage?.classList.toggle('show')
                    }

                    if ($target.matches('.dropdown-menu .dropdown-item')) {
                        dropdownCurrency?.classList.remove('show')
                        dropdownLanguage?.classList.remove('show')
                    }
                }
                else {
                    header.forEach(element => {
                        element.querySelector('.top-language-currency')?.classList.remove('show')
                        element.querySelector('.dropdown-currency')?.classList.remove('show')
                        element.querySelector('.dropdown-language')?.classList.remove('show')
                    })
                }
            })
        },

        headerSidebarSearch: function() {
            var headerSearchPC = $('.header-top .header__search .search_details'),
                headerSearchMB = $('#search-form-mobile .halo-sidebar-wrapper .search_details'),
                headerwraperSearchPC = $('.header-top .header__search'),
                headerwraperSearchMB = $('#search-form-mobile .halo-sidebar-wrapper'),
                searchDetails = $('.search_details'),
                predictiveSearchPC =  $('.header-top .header__search predictive-search'),
                predictiveSearchMB = $('#search-form-mobile .halo-sidebar-wrapper predictive-search');
 
             if (predictiveSearchPC.length === 0) predictiveSearchPC =  $('.header-top .header__search .search_details');
             if (predictiveSearchMB.length === 0) predictiveSearchMB =  $('#search-form-mobile .halo-sidebar-wrapper .search_details');
            if (window.innerWidth < 1025) {
                if($('.header').hasClass('header-01')){
                    predictiveSearchPC.appendTo(headerwraperSearchMB);
                }
                searchDetails.attr('open','true');
                $('[data-search-mobile]').on('click', (event) => {
                    event.preventDefault();
                    $('body').addClass('open_search_mobile');
                });
                $('[data-search-close-sidebar], .background-overlay').on('click', (event) => {
                    event.preventDefault();
                    $('body').removeClass('open_search_mobile');
                });
            }else{
                if($('.header').hasClass('header-01')){
                    predictiveSearchMB.appendTo(headerwraperSearchPC);
                }
                searchDetails.removeAttr('open');

                $('.search-modal__close-button').on('click', (event) => {
                    $('.search_details').removeAttr('open');
                    $('body').removeClass('open_search_menu');
                });

                // Click Search Icon On Header Nav And Sticky Menu
                $('[data-search-menu]').on('click', (event) => {
                    event.preventDefault();
                    $('body').addClass('open_search_menu');
                });
            }
        },

        headerStickySearchForm: function() {
            var iconSearchSlt = '[data-search-sticky-form]';
            var iconSearchMenu = '[data-search-menu-sticky-form] .icon-search';
            var iconSearchMenuCustom = '[data-search-menu-sticky-form] .icon-search-custom';

            if ($(window).width() > 1025) {
                $(document).off('click.toggleSearch', iconSearchSlt).on('click.toggleSearch', iconSearchSlt, function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    $('body').addClass('sticky-search-open');
                    $('.search_details').attr('open','true');
                });

                $(document).off('click.hideSearch').on('click.hideSearch', function(event) {
                    var formSearch = $('.search-modal__form'),
                        quickSearch = $('.quickSearchResultsWrap');
                    if ($('body').hasClass('sticky-search-open') && !formSearch.has(event.target).length && !quickSearch.has(event.target).length) {
                        $('body').removeClass('sticky-search-open');
                        $('[class*="section-header-"]').removeClass('sticky-search-menu-open');
                        $('.search_details').removeAttr('open');
                    }
                });

                // Click Search Icon On Header Nav And Sticky Menu
                $(document).off('click.toggleSearch', iconSearchMenu).on('click.toggleSearch', iconSearchMenu, function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    $(event.target).closest('[class*="section-header-"]').addClass('sticky-search-menu-open');
                    $(event.target).closest('.section-header-navigation').css('z-index', '101');
                    $('.search_details').attr('open','true');
                });

                // Click Search Icon On Header Hamburger - Search Dropdown Style Layout Custom
                $(document).off('click.toggleSearch', iconSearchMenuCustom).on('click.toggleSearch', iconSearchMenuCustom, function(event) {
                    $(event.target).closest('[class*="section-header-"]').addClass('sticky-search-menu-custom-open');
                });

                $(document).off('click.hideSearchSticky').on('click.hideSearchSticky', function(event) {
                    // var formSearch = $('.header-navigation .search-modal__form'),
                    //     quickSearch = $('.header-navigation .quickSearchResultsWrap');
                    // if ($('[class*="section-header-"]').hasClass('sticky-search-menu-open') && !formSearch.has(event.target).length && !quickSearch.has(event.target).length) {
                    //     const header = $(iconSearchMenu).closest('.section-header-navigation');
                    //     const index = header.data('index');

                    //     $('[class*="section-header-"]').removeClass('sticky-search-menu-open');
                        
                    //     header.css('z-index', index);
                    //     $('.header-navigation .search_details').removeAttr('open');
                    //     if(quickSearch.hasClass('is-show')) {
                    //         quickSearch.removeClass('is-show').addClass('hidden')
                    //     }
                    // }
                    // if (($(event.target).closest('.search-modal__content').length === 0)){
                    //     $('body').removeClass('open_search_menu');
                    //     $('[class*="section-header-"]').removeClass('sticky-search-menu-custom-open');
                    // }
                });
            }
        },

         initBrandsPage: function () {
          var brandsList = $("[data-brands-list]"),
            brand = brandsList.find(".brand");
    
          brand.each(function () {
            var self = $(this),
              brandTitle = self.data("azbrands"),
              character = self
                .find("ul.brand-grid li:eq(0) a")
                .text()
                .charAt(0)
                .toLowerCase(),
              alphabet = brandsList.prev(),
              alphabetChild = alphabet.children();
    
            alphabetChild.each(function () {
              var aElm = $(this).find("a");
    
              if (aElm.text().trim().toLowerCase() == brandTitle) {
                if (!aElm.hasClass("readonly")) aElm.addClass("readonly");
                return;
              }
            });
          });
    
          var vendorItem = brandsList.prev().find(".vendor-letter a.readonly");
    
          vendorItem.on("click", function () {
            var selfText = $(this).text().trim().toLowerCase();
    
            brand.hide().filter(function (e) {
              var title = $(this).data("azbrands");
    
              if (title == selfText) {
                $(this).show();
                return;
              }
            });
    
            $(".azbrandstable .all-brand a").click(function () {
              brand.show();
            });
          });
    
          var allVendor = brandsList.prev().find("a.readonly");
    
          allVendor.on("click", function () {
            brandsList.prev().find("a").removeClass("active");
    
            var self = $(this);
    
            if (!self.hasClass("active")) {
              self.addClass("active");
            }
    
            var offsetTop = brandsList.prev(".azbrandstable").offset().top - 100;
    
            $("body,html").animate(
              {
                scrollTop: offsetTop,
              },
              600
            );
          });
        },

       autoplayRandomVideos: function () {
          if (!halo.isRVPLoaded) {
            var videoItemsCount = $(".card-media video").length,
              videoRowClasses = [];
    
            $(".prows").each(function (i, el) {
              var rcls = $(el).data("prow"),
                rvlen = $(`${rcls} video`).length;
              if (rvlen > 0) {
                videoRowClasses.push(rcls);
              }
            });
            console.log(getUniqe(videoRowClasses));
    
            if (videoRowClasses.length) {
              videoRowClasses = getUniqe(videoRowClasses);
              $.each(videoRowClasses, function (i, cls) {
                randomVideoPlay(cls);
              });
            }
    
            function randomVideoPlay(cls) {
              return;
                  setTimeout(
                    function (cls) {
                      var videoItems = $(`${cls} video`),
                        randomItems = videoItems
                          .sort(() => Math.random() - Math.random())
                          .slice(0, 1);
                      $.each(randomItems, function (i, el) {
                       console.log('el',el);
                        $(this).parents(".card-product__wrapper").addClass("direct-play");
                        $(this).parents(".card-media").addClass("autoplay");
                        var playPromise = $(el).get(0).play();

                          if (playPromise !== undefined) {
                            playPromise.then(_ => {
                             
                              $(el).get(0).play();
                            })
                            .catch(error => {
                            
                            });
                          }
                      });
                    },
                    500,
                    cls
                  );
                }
        
                function getUniqe(list) {
                  return list.filter(function (x, i, a) {
                    return a.indexOf(x) == i;
                  });
                }
                halo.isRVPLoaded = true;
              }
            },

      filterSidebar: function () {
            this.queryParams();
            this.ajaxFilterTags();
            this.ajaxFilterClearTags();
            this.ajaxFilterClearAll();
          },

        ajaxFilterTags: function () {
            $body
              .off("click.filterTags")
              .on(
                "click.filterTags",
                ".sidebar-tags .list-tags a, .refined .selected-tag",
                function (e) {
                 
                  e.preventDefault();
                  e.stopPropagation();
      
                  var newTags = [];
      
                  if (Shopify.queryParams.constraint) {
                    newTags = Shopify.queryParams.constraint.split("+");
                  }
      
                  //one selection or multi selection
                  if (
                    !window.enable_sidebar_multiple_choice &&
                    !$(this).prev().is(":checked")
                  ) {
                    //remove other selection first
                    var otherTag = $(this)
                      .closest(".sidebar-tags, .refined-widgets")
                      .find("input:checked");
      
                    if (otherTag.length) {
                      var tagName = otherTag.val();
      
                      if (tagName) {
                        var tagPos = newTags.indexOf(tagName);
      
                        if (tagPos >= 0) {
                          //remove tag
                          newTags.splice(tagPos, 1);
                        }
                      }
                    }
                  }
      
                  var tagName = $(this).prev().val();
      
                  if (tagName) {
                    var tagPos = newTags.indexOf(tagName);
      
                    if (tagPos >= 0) {
                      newTags.splice(tagPos, 1);
                    } else {
                      newTags.push(tagName);
                    }
                  }
      
                  if (newTags.length) {
                    Shopify.queryParams.constraint = newTags.join("+");
                  } else {
                    delete Shopify.queryParams.constraint;
                  }
      
                  var newurl = $(this).data("href");
      
                  window.location.href = newurl;
      
                  //ella.filterAjaxClick(newurl);
      
                  //ella.doAjaxSidebarGetContent(newurl);
                }
              );
          },

         ajaxFilterClearTags: function () {
            var sidebarTag = $(".sidebar-tags");
      
            sidebarTag.each(function () {
              var sidebarTag = $(this);
      
              if (sidebarTag.find("input:checked").length) {
                //has active tag
                sidebarTag
                  .find(".clear")
                  .show()
                  .click(function (e) {
                    e.preventDefault();
                    e.stopPropagation();
      
                    var currentTags = [];
      
                    if (Shopify.queryParams.constraint) {
                      currentTags = Shopify.queryParams.constraint.split("+");
                    }
      
                    sidebarTag.find("input:checked").each(function () {
                      var selectedTag = $(this);
                      var tagName = selectedTag.val();
      
                      if (tagName) {
                        var tagPos = currentTags.indexOf(tagName);
                        if (tagPos >= 0) {
                          //remove tag
                          currentTags.splice(tagPos, 1);
                        }
                      }
                    });
      
                    if (currentTags.length) {
                      Shopify.queryParams.constraint = currentTags.join("+");
                    } else {
                      delete Shopify.queryParams.constraint;
                    }
      
                    var newurl = $(this).data("href");
                    window.location.href = newurl;
                    // ella.filterAjaxClick(newurl);
      
                    //ella.doAjaxSidebarGetContent(newurl);
                  });
              }
            });
          },

        ajaxFilterClearAll: function () {
          var clearAllSlt = ".refined-widgets a.clear-all";
          var clearAllElm = $(clearAllSlt);
    
          $body
            .off("click.clearAllTags", clearAllSlt)
            .on("click.clearAllTags", clearAllSlt, function (e) {
              e.preventDefault();
              e.stopPropagation();
    
              delete Shopify.queryParams.constraint;
    
              var newurl = $(this).data("href");
              window.location.href = newurl;
    
              // ella.filterAjaxClick(newurl);
              // ella.doAjaxSidebarGetContent(newurl);
            });
        },
         queryParams: function () {
          Shopify.queryParams = {};
    
          if (location.search.length) {
            for (
              var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
              i < aCouples.length;
              i++
            ) {
              aKeyValue = aCouples[i].split("=");
    
              if (aKeyValue.length > 1) {
                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
                  decodeURIComponent(aKeyValue[1]);
              }
            }
          }
        },
      
      hide_filter: function () {
          $(".sidebar-tags .widget-content ul").each(function () {
            if ($(this).children("li").length > 0) {
              $(this).parents(".sidebar-tags").show();
            } else {
              $(this).parents(".sidebar-tags").hide();
            }
          });
          $(".show-more--list_tags").click(function (e) {
            $(this).closest(".list-tags").addClass("full");
          });
        },

           initReturnModule: function () {
          $(document).on("click", "input.return_request_form", function () {
            $(".loading").addClass("active");
            $("form.post_data").removeClass("exchange-request-frm");
            $("form.post_data").addClass("return-request-frm");
            $(".return-description").show();
            $(".exchange-description").hide();
          });
    
          $(document).on("click", "input.exchange_request_form", function () {
            $(".loading").addClass("active");
            $("form.post_data").removeClass("return-request-frm");
            $("form.post_data").addClass("exchange-request-frm");
            $(".return-description").hide();
            $(".exchange-description").show();
          });
    
          $(document).on("click", ".submit-button input", function () {
            $(document).on(
              "change",
              ".return-request-frm #search_type",
              function (e) {
                $("#search_value").val("");
                if (this.value == "email") {
                  $("#search_value").attr("type", "email");
                  $("#search_value").attr("placeholder", "Enter your email ID");
    
                  $("#search_value").removeAttr("maxlength");
                  $("#search_value").removeAttr("pattern");
                  $(".label_email_mobile").text("Email Id");
                } else {
                  $("#search_value").attr("type", "tel");
                  $("#search_value").attr(
                    "placeholder",
                    "Enter last 4 digits of mobile number"
                  );
                  $("#search_value").attr("maxlength", 4);
                  $("#search_value").attr("pattern", "[0-9]+");
                  //$('#search_value').attr("onkeydown", "limit(this, 4);");
                  //$('#search_value').attr("onkeyup", "limit(this, 4);");
                  $(".label_email_mobile").text("Mobile Number");
                }
              }
            );
    
            if (
              $(".return-request-frm #search_type").val() == "email" &&
              $(".return-request-frm #search_value").val() == ""
            ) {
              var errMsg = "Please provide your email address used in Order";
              $(".return-request-frm .msg-box").text(errMsg);
              return false;
            }
            var emailValue = $(".return-request-frm #search_value").val();
            if (
              $(".return-request-frm #search_type").val() == "email" &&
              emailValue.indexOf("@") == -1
            ) {
              var errMsg =
                "Please provide your correct email address used in Order";
              $(".return-request-frm .msg-box").text(errMsg);
              return false;
            }
            if (
              $(".return-request-frm #search_type").val() == "phone" &&
              $(".return-request-frm #search_value").val() == ""
            ) {
              var errMsg = "Please provide your phone number used in Order";
              $(".return-request-frm .msg-box").text(errMsg);
              return false;
            }
            if ($(".return-request-frm #order_id").val() == "") {
              var errMsg = "Please provide Order ID";
              console.log("errMsg 9164", errMsg);
              $(".return-request-frm .msg-box").text(errMsg);
              return false;
            }
    
            $(".return-request-frm .msg-box").text("");
            $(".both-button").show();
          });
          var returnpage = $(".return-request-frm");
          if (returnpage.length) {
            $(document).on(
              "change",
              ".return-request-frm #search_type",
              function (e) {
                console.log(this.value);
                $("#search_value").val("");
                if (this.value == "email") {
                  $("#search_value").attr("type", "email");
                  $("#search_value").attr("placeholder", "Enter your email ID");
    
                  $("#search_value").removeAttr("maxlength");
                  $("#search_value").removeAttr("pattern");
                  $(".label_email_mobile").text("Email Id");
                } else {
                  $("#search_value").attr("type", "tel");
                  $("#search_value").attr(
                    "placeholder",
                    "Enter last 4 digits of mobile number"
                  );
                  $("#search_value").attr("maxlength", 4);
                  $("#search_value").attr("pattern", "[0-9]+");
                  //$('#search_value').attr("onkeydown", "limit(this, 4);");
                  //$('#search_value').attr("onkeyup", "limit(this, 4);");
                  $(".label_email_mobile").text("Mobile Number");
                }
              }
            );
    
            $(document).on(
              "click",
              ".close-btn, .success-buttons button",
              function (e) {
                e.preventDefault();
                $(".exchange-request-frm").trigger("submit");
                $(".success-popup").removeClass("active");
              }
            );
    
            $(document).on("submit", ".return-request-frm", function (e) {
              e.preventDefault();
              var params = $(this).serializeArray();
              var apiurl = "https://mp.goddiva.uk/api/get-order-iems-info";
              //$('.seller-lead-registration-frm .lead-msg-box').html('<img width="20" src="https://cdn.shopify.com/s/files/1/0071/7406/2170/files/tradegalaLoading.gif?18809">');
    
              if ($(".return-request-frm #order_id").val() == "") {
                var errMsg = "Please provide Order ID";
                $(".return-request-frm .msg-box").text(errMsg);
                return false;
              }
              if (
                $(".return-request-frm #search_type").val() == "email" &&
                $(".return-request-frm #order_email").val() == ""
              ) {
                var errMsg = "Please provide your email address used in Order";
                $(".return-request-frm .msg-box").text(errMsg);
                return false;
              }
              if (
                $(".return-request-frm #search_type").val() == "phone" &&
                $(".return-request-frm #order_pnone").val() == ""
              ) {
                var errMsg = "Please provide your phone number used in Order";
                $(".return-request-frm .msg-box").text(errMsg);
                return false;
              }
    
              $(".return-request-frm .msg-box").text("");
    
              $.ajax({
                type: "Post",
                url: apiurl,
                data: params,
                dataType: "json",
                success: function (data) {
                  var tagVal = data.orderItems.tags;
                  if (tagVal == null || tagVal.indexOf("Old_Order_") == -1) {
                    $(".order-details").css("display", "block");
                    log("orderItems", data.orderItems.length);
                    halo.resetReturnModule();
                    if (data.orderItems.length < 1) {
                      $(".return-request-frm .msg-box").text(data.result);
                    } else {
                      log("Order Data: ", data);
                      ella.initReturnModulePage(data);
                    }
                    $(".errorMessage").css("display", "none");
                  } else {
                    $(".order-details").css("display", "none");
                    $(".errorMessage").css("display", "block");
                    $(".errorMessage").html(
                      "This has already been exchanged for this Order " +
                        data.orderItems.tags.split("Old_Order_")[1] +
                        " so you can't do Return and Exchange for this order."
                    );
                  }
                  // var return_divHeight = $('.wrapper-header').height() + $('.breadcrumb').height() + $('.container form').height() + $('.container .return-description').height();
                  // console.log("return_divHeight",return_divHeight);
                  // window.scrollTo({top: return_divHeight, behavior: 'smooth'});
                  $(".loading").removeClass("active");
                },
                error: function (xhr, text) {
                  console.log("xhr", xhr);
                  var errmsg = `Service is temporarily unavailable - Please try again in some time. If it's an urgent query - please contact info@goddiva.co.uk`;
                  $(".return-request-frm .msg-box").text(errmsg);
                },
              });
    
              function log(key, value) {
                console.log("============", key, "===========");
                console.log(value);
                console.log("=======================");
              }
            });
    
            $(document).on("submit", ".exchange-request-frm", function (e) {
              e.preventDefault();
              var params = $(this).serializeArray();
              var apiurl = "https://mp.goddiva.uk/api/get-order-iems-info";
              //$('.seller-lead-registration-frm .lead-msg-box').html('<img width="20" src="https://cdn.shopify.com/s/files/1/0071/7406/2170/files/tradegalaLoading.gif?18809">');
    
              if ($(".exchange-request-frm #order_id").val() == "") {
                var errMsg = "Please provide Order ID";
                console.log("errMsg 9274", errMsg);
                $(".exchange-request-frm .msg-box").text(errMsg);
                return false;
              }
              if (
                $(".exchange-request-frm #search_type").val() == "email" &&
                $(".exchange-request-frm #order_email").val() == ""
              ) {
                var errMsg = "Please provide your email address used in Order";
                $(".exchange-request-frm .msg-box").text(errMsg);
                return false;
              }
              if (
                $(".exchange-request-frm #search_type").val() == "phone" &&
                $(".exchange-request-frm #order_pnone").val() == ""
              ) {
                var errMsg = "Please provide your phone number used in Order";
                $(".exchange-request-frm .msg-box").text(errMsg);
                return false;
              }
    
              $(".exchange-request-frm .msg-box").text("");
    
              $.ajax({
                type: "Post",
                url: apiurl,
                data: params,
                dataType: "json",
                success: function (data) {
                  var tagVal = data.orderItems.tags;
                  if (tagVal == null || tagVal.indexOf("Old_Order_") == -1) {
                    $(".order-details").css("display", "block");
                    //log("orderItems", data.orderItems.length);
                    halo.resetReturnModule();
                    if (data.orderItems.length < 1) {
                      $(".exchange-request-frm .msg-box").text(data.result);
                    } else {
                      // log('Order Data: ', data);
                      halo.initExchangeModulePage(data);
                    }
                    // var return_divHeight = $('.wrapper-header').height() + $('.breadcrumb').height() + $('.container form').height() + $('.container .exchange-description').height();
                    // // $('.wrapper-header').height() +
                    // console.log("return_divHeight",return_divHeight);
                    // window.scrollTo({top: return_divHeight, behavior: 'smooth'});
                    $(".errorMessage").css("display", "none");
                  } else {
                    $(".order-details").css("display", "none");
                    $(".errorMessage").css("display", "block");
                    $(".errorMessage").html(
                      "This has already been exchanged for this Order " +
                        data.orderItems.tags.split("Old_Order_")[1] +
                        " so you can't do Return and Exchange for this order."
                    );
                  }
                },
                error: function (xhr, text) {
                  console.log("xhr", xhr);
                  var errmsg = `Service is temporarily unavailable - Please try again in some time. If it's an urgent query - please contact info@goddiva.co.uk`;
                  $(".return-request-frm .msg-box").text(errmsg);
                },
              });
    
              function log(key, value) {
                console.log("============", key, "===========");
                console.log(value);
                console.log("=======================");
              }
            });
          }
    
          function limit(element, max) {
            var max_chars = max;
            if (element.value.length > max_chars) {
              element.value = element.value.substr(0, max_chars);
            }
          }
        },

         resetReturnModule: function () {
            $(".rr-order-name").html("");
            $(".rr-order-date").text("");
            $("[data-order-info-by-vendor]").html("");
            $(".order-details").addClass("d-none");
          },

            initExchangeModulePage: function (data) {
      // console.log("data",data);

      var order = data.orderItems,
        ItemImages = data.ItemImages,
        ItemFullfillments = data.ItemFullfillments,
        orderItemProductHandle = data.orderItemProductHandle,
        trackingInformation = data.tracking_information,
        orderItemVariants = data.orderItemVariants,
        lineItems = order.line_items;
      if (!lineItems.length) {
        return true;
      }

      var vendorslist = lineItems.map(function (item) {
        return item.vendor.toLowerCase().replace(/[ ]+/g, "-");
      });
      var vendorAry = uniqueArray(vendorslist);

      _setOrderName(order.name);
      _setOrderDate(order.date);
      _orderInfoByVendor(
        vendorAry,
        lineItems,
        order,
        orderItemProductHandle,
        trackingInformation,
        orderItemVariants
      );

      _actionBtns(order);

      ////////////////////////////////////////////////

      function _setOrderName(name) {
        $(".rr-order-name").text("Order " + name);
      }

      function _setOrderDate(date) {
        $(".rr-order-date").text(date);
      }

      function _orderInfoByVendor(
        vendors,
        lineItems,
        orderObj,
        orderItemProductHandle,
        trackingInformation,
        orderItemVariants
      ) {
        // log(orderObj, 'orderObj');

        var orderInfo = [],
          return_reason = [],
          reasons =
            "Too Big, Too Small, Too Long, Too Short, Not as Expected, Ordered for Choice, Incorrect Item, Arrived Late, Faulty, Other".split(
              ","
            );
        reasons.forEach(function (reason) {
          var specify =
            reason.toLowerCase() == "faulty" || reason.toLowerCase() == "other"
              ? "(Specify)"
              : "";
          return_reason.push(
            `<option value="` +
              reason.trim() +
              `" data-value="` +
              reason.trim() +
              `"> ` +
              reason.trim() +
              specify +
              `</option>`
          );
        });

        vendors.forEach(function (vendor) {
          var vendor_li = [],
            hideReturn = true,
            rerurnBtnBlock = "";

          lineItems.forEach(function (line_item) {
            // console.log("line_item",line_item);
            var trackingData = trackingInformation[line_item.id],
              orderItemOption = orderItemVariants[line_item.id],
              line_item_id = "",
              line_item_v_title = line_item.variant_title,
              variant_id = "",
              disabled_variant = "",
              option_value = "";

            for (var key in orderItemOption) {
              // console.log("orderItemOption[key]", orderItemOption[key]);
              // console.log("line_item_v_title",line_item_v_title);
              if (orderItemOption[key].includes("Already Purchased")) {
                disabled_variant = "disabled";
              } else {
                disabled_variant = "";
              }
              option_value += `<option data-value="${key}" ${disabled_variant}>${orderItemOption[key]}</option>`;
            }

            var li_vendor = line_item.vendor
              .toLowerCase()
              .replace(/[ ]+/g, "-");
            var liitemimg = ItemImages[line_item.variant_id]
              ? `<img src="` +
                ItemImages[line_item.variant_id] +
                `" alt="` +
                line_item.name +
                `" />`
              : `<img src="https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_200x200.gif" alt="no image" />`;
            //log(line_item,'line_item');
            //

            // show return btn
            hideReturn =
              ItemFullfillments[line_item.variant_id] == 0 ? true : false;
            // log('ItemFullfillments[line_item.variant_id]', ItemFullfillments[line_item.variant_id]);
            // log('hideReturn', hideReturn);

            var available_option = hideReturn
              ? ``
              : `<label>Available Option</label><select name="exchange_option" required="" class="exchange exchange-option-selected-` +
                line_item.id +
                `" data-line-item-id="` +
                line_item.id +
                `">
                       <option value="" data-value="">Select Option</option>${option_value}</select><span class="icon-dropdown">
                       <i class="fa fa-angle-down"></i>
                     </span>`;

            var tracking_data = hideReturn
              ? ``
              : `Fulfilled <time datetime="${trackingData.created_date}">${trackingData.formated_date}</time>
                                                      <div><a href="${trackingData.tracking_url}">
                                                          Track shipment
                                                        </a><div>
                                                          <span>Tracking Company: ${trackingData.tracking_name}</span>
                                                          <br>
                                                          <span>Tracking Number: #${trackingData.tracking_number} </span>
                                                        </div>
                                                      </div>`;
            var otherOption = hideReturn
              ? ``
              : `<div class="return-requested">Can not use the Exchange Because another product option is not available. <a href="/pages/returns">You can return this item.</a></div>`;

            if (vendor == li_vendor) {
              var licheckbox = hideReturn
                ? ``
                : `<label for="` +
                  vendor +
                  `_` +
                  line_item.id +
                  `" class="li-` +
                  line_item.id +
                  `">
<input type="checkbox" class="returnfor_` +
                  vendor +
                  ` returnfor_` +
                  line_item.id +
                  `" id="` +
                  vendor +
                  `_` +
                  line_item.id +
                  `" name="` +
                  vendor +
                  `_` +
                  line_item.id +
                  `" data-vendor="` +
                  vendor +
                  `" data-vid="` +
                  line_item.variant_id +
                  `" value="` +
                  line_item.id +
                  `" /><span><small></small></span></label>`;

              var liQtyOption = [];
              for (var i = 1; i <= line_item.quantity; i++) {
                liQtyOption.push(`<option value="${i}">${i}</option>`);
              }
              var liorderreturnQty = hideReturn
                ? ``
                : `<label for="shopify_return_order_quantity_${line_item.id}"/>Select Quantity to Exchange</label><select name="shopify_return_order_quantity_` +
                  line_item.id +
                  `" id="shopify_return_order_quantity_` +
                  line_item.id +
                  `" class="li-return-order-qty li-return-order-qty-` +
                  line_item.id +
                  `">${liQtyOption.join("")}</select>`;
              var className = "";
              if (Object.keys(orderItemOption).length < 2) {
                className = "item-return-requested";
              }
              var vli =
                `<div class="exchange-form-row ${className} litem-` +
                line_item.id +
                `">
<div class="order-checklist">`;
              if (Object.keys(orderItemOption).length > 1) {
                vli +=
                  `<div class="checkbox switcher">` + licheckbox + `</div>`;
              }
              vli +=
                `</div>
  <div class="order-pic">` +
                liitemimg +
                `</div>
  <div class="order-detail">
  <div>
  <h3>` +
                line_item.name +
                `</h3>
  <div class="note">` +
                tracking_data +
                `</div>
</div>
<div><p>Brand: ` +
                line_item.vendor +
                `</p></div>
<div><p>Product Code:  ` +
                line_item.sku +
                `</p></div>
<div><p>Quantity: ` +
                line_item.quantity +
                `</p>
<input type="hidden" name="li_qty_` +
                line_item.id +
                `" class="li_qty_` +
                line_item.id +
                `" value="` +
                line_item.quantity +
                `" />
</div>`;
              if (Object.keys(orderItemOption).length > 1) {
                vli +=
                  `<div class="exchange-box">
            <div class="form-group return-options-list"  style="position: relative; max-width: 380px;">` +
                  available_option +
                  `</div>
            <div class="form-group return-item-quantity"  style="position: relative; max-width: 380px;">${liorderreturnQty}</div>
          </div>`;
              } else {
                vli += otherOption;
              }
              vli += `</div>
</div>`;
              vendor_li.push(vli);
              rerurnBtnBlock = hideReturn
                ? `<div class="return-button1"><button class="" type="button">Order is not fulfilled yet</button></div>`
                : `<div class="return-button1 exchange-button">
<button class="btn exchangeform" type="button" data-vendor="` +
                  vendor +
                  `" data-customer_id="` +
                  orderObj.customer.id +
                  `" data-order_id="` +
                  orderObj.id +
                  `">Exchange Item</button>
<button class="btn resetreturnform" type="button" data-selclass="returnfor_` +
                  vendor +
                  `" type="reset">Cancel</button>
</div>`;
            }
          });

          // var rerurnBtnBlock = (hideReturn)?`<div class="return-button"><button class="" type="button">Order is not fulfilled yet</button></div>`:`<div class="return-button">
          //   <button class="btn returnform" type="button" data-vendor="`+vendor+`" data-customer_id="`+ orderObj.customer.id+`" data-order_id="`+ orderObj.id+`">Return Item</button>
          //   <button class="btn resetreturnform" type="button" data-selclass="returnfor_`+vendor+`" type="reset">Cancel</button>
          //   </div>`;

          var venderOrderInfo =
            `<div class="vendor-list-box product-list-` +
            vendor +
            ` mt-4">
<h3 class="text-capitalize">` +
            vendor.replace(/[-]+/g, " ") +
            `</h3>` +
            vendor_li.join("") +
            rerurnBtnBlock +
            `</div>`;
          orderInfo.push(venderOrderInfo);
        });

        $("[data-order-info-by-vendor]").html(orderInfo.join(""));
        $(".order-details").removeClass("d-none");
      }

      function _actionBtns(_actionBtns) {
        $(".exchangeform").click(function (e) {
          e.preventDefault();
          var order_id = $(this).data("order_id"),
            customer_id = $(this).data("customer_id"),
            return_items = [],
            optionSelected = true,
            specificReasonNotDefined = false,
            newoption = [],
            newoptionId = [],
            reasons = [],
            specific_reason = [],
            shopify_order_quantity = [],
            return_order_qty = [],
            exchange_order_qty = [],
            vendor = $(this).data("vendor"),
            sel = ".returnfor_" + $(this).data("vendor");

          if ($(sel + ":checked").length) {
            $(sel + ":checked").each(function (i, el) {
              var reasonOptCls = ".return-reason-" + el.value,
                li_qty = ".li_qty_" + el.value,
                return_qty = ".li-return-order-qty-" + el.value,
                specificOptCls = ".sror-" + el.value;

              var optionValue = _getNewOptionValueByLID(el.value);
              if (!optionValue.variantvalue) {
                optionSelected = false;
              }

              // var specificValue = _getSpecificReasonByLID(reasonValue, el.value);
              // if (reasonValue == 'Faulty' || reasonValue == 'Other') {
              //   if (!specificValue) {
              //     specificReasonNotDefined = true;
              //   }
              // }

              return_items.push(el.value);
              shopify_order_quantity.push(_getQtyByLID(li_qty));
              exchange_order_qty.push(_getQtyByLID(return_qty));
              // return_order_qty.push(_getQtyByLID(return_qty));
              newoption.push(optionValue.variantvalue);
              newoptionId.push(optionValue.variantId);
              // specific_reason.push(specificValue);
            });
          }

          if (return_items.length && optionSelected == true) {
            $(this).text("Sending Request...");
            $(".returnform").attr("disabled", true);
            var item_list = return_items.join(","),
              newoption_list = newoption.join(","),
              liqty_list = shopify_order_quantity.join(","),
              // returnqty_list = return_order_qty.join(','),
              newoptionId_list = newoptionId.join(","),
              exchangeqty_list = exchange_order_qty.join(",");
            // specific_list = specific_reason.join(',');
            if (newoption_list == "") {
              alert("Please select new option for exchange");
              $(".returnform").attr("disabled", false);
              return false;
            }
            submitReturnRequest(
              order_id,
              customer_id,
              vendor,
              item_list,
              newoption_list,
              exchangeqty_list,
              liqty_list,
              newoptionId_list
            );
          } else {
            if (return_items.length == 0) {
              alert("Please select item for exchange");
            }
            if (return_items.length && optionSelected == false) {
              alert("Please select available option for exchange");
              // console.log('Please select available option for exchange');
            }
            if (return_items.length && specificReasonNotDefined == true) {
              alert("Please provide specific reason for return");
              // console.log('Please provide specific reason for return');
            }
          }
        });

        function _getNewOptionValueByLID(lid) {
          var newOptCls = ".exchange-option-selected-" + lid;
          var variantvalue = $(newOptCls).val() ? $(newOptCls).val() : null,
            variantId = $(newOptCls).find("option:selected").attr("data-value");
          var optionValueAndId = {
            variantvalue: variantvalue,
            variantId: variantId,
          };
          return optionValueAndId;
        }

        // function _getReasonByLID(lid) {
        //   var reasonOptCls = '.exchange-option-selected-' + lid;
        //   return ($(reasonOptCls).val()) ? $(reasonOptCls).val() : null;
        // }

        function _getQtyByLID(lid) {
          return $(lid).val() ? $(lid).val() : null;
        }

        // function _getSpecificReasonByLID(reason, lid) {
        //   var specificOptCls = '.sror-' + +lid;
        //   console.log(reason);
        //   if (reason == 'Faulty' || reason == 'Other') {
        //     return ($(specificOptCls).val()) ? $(specificOptCls).val() : null;
        //   } else {
        //     return null;
        //   }
        // }

        $(document).on("click", ".resetreturnform", function (e) {
          e.preventDefault();
          var selclass = "." + $(this).data("selclass");
          $(selclass).attr("checked", false);
        });

        $(document).on("change", ".exchange", function (e) {
          var $this = $(this);
          var line_item_id = $this.data("line-item-id");
          var toggleElement = jQuery(".returnfor_" + line_item_id);

          if ($this.val() != "") {
            toggleElement.prop("checked", true);
          } else {
            toggleElement.prop("checked", false);
          }
        });

        function submitReturnRequest(
          order_id,
          customer_id,
          vendor,
          items,
          newoption_list,
          exchangeqty_list,
          liqty_list,
          newoptionId_list
        ) {
          var params = {
            order_id: order_id,
            customer_id: customer_id,
            items: items,
            vendor_name: vendor,
            new_option_by_user: newoption_list,
            shopify_order_quantity: liqty_list,
            new_variant_id: newoptionId_list,
            shopify_exchange_order_quantity: exchangeqty_list,
          };

          //               log('submitReturnRequest', params);
          //               log('*****************', '++++++++++++++++++');
          //               return true;
          console.log("params", params);
          $(".returnform").attr("disabled", true);

          $.ajax({
            url: "https://mp.goddiva.uk/api/save-order-exchange-request",
            type: "POST",
            dataType: "json",
            data: params,
            success: function (response) {
              console.log("save-order-exchange-request", response);
              $(".exchangeform").text("Exchange Item");
              $(".exchangeform").attr("disabled", false);
              $(".success-popup").addClass("active");
            },
            error: function (error) {
              console.log("error");
              console.log("Error in creating return request");
              $(".returnform").text("Return Item");
              $(".returnform").attr("disabled", false);
            },
          });
        }

        function fetchOrderReturnStatus() {
          $(".loading").addClass("active");

          var params = {
            order_id: order.id,
          };
          $.ajax({
            url: "https://mp.goddiva.uk/api/get-return-order-items",
            type: "POST",
            dataType: "json",
            data: params,
            success: function (response) {
              console.log("response", response);
              var dicountValue = response.return_discount.value;
              if (response.return_discount.type == "percentage") {
                $(".dicount_value").text(dicountValue + "%");
              } else {
                $(".dicount_value").text("GBP " + dicountValue);
              }
              if (Object.keys(response.exchange_items).length > 0) {
                var ri = response.exchange_items;
                $.each(ri, function (obj_ex, resultObj) {
                  var chk = ".li-" + obj_ex,
                    item = ".litem-" + obj_ex;
                  $(chk).addClass("disabled");
                  $(item).addClass("item-return-requested");
                  $(item + " .checkbox").addClass("d-none");
                  $(item + " .exchange-box").addClass("d-none");
                  // $(item + ' .order-detail').append('<div class="return-requested">Exchange already requested for quantity '+data_exchangeqty_list+'</div>');
                  if (resultObj.msg != undefined && resultObj.msg != "") {
                    $(item + " .order-detail").append(
                      '<div class="return-requested">' +
                        resultObj.msg +
                        "</div>"
                    );
                  }
                  if (
                    resultObj.return_url != undefined &&
                    resultObj.return_url != ""
                  ) {
                    $(item + " .order-detail").append(
                      '<div class="return-requested"><a style="color: #FF0000;" href="' +
                        resultObj.return_url +
                        '" target="_blank">Click Here to Generate Return Label</a></div>'
                    );
                  }
                });
              }
              if (Object.keys(response.return_items).length > 0) {
                console.log("return data");
                var ri = response.return_items;

                $.each(ri, function (obj, resultObj) {
                  var chk = ".li-" + obj,
                    item = ".litem-" + obj;
                  $(chk).addClass("disabled");
                  $(item).addClass("item-return-requested");
                  $(item + " .checkbox").addClass("d-none");
                  $(item + " .exchange-box").addClass("d-none");
                  if (resultObj.msg != undefined && resultObj.msg != "") {
                    if (
                      $(item + " .order-detail").find("div.return-requested")
                        .length > 0
                    ) {
                      $(item + " .order-detail")
                        .find("div.return-requested")
                        .html(resultObj.msg);
                    } else {
                      $(item + " .order-detail").append(
                        '<div class="return-requested">' +
                          resultObj.msg +
                          "</div>"
                      );
                    }
                  }
                  if (
                    resultObj.return_url != undefined &&
                    resultObj.return_url != ""
                  ) {
                    $(item + " .order-detail").append(
                      '<div class="return-requested"><a style="color: #FF0000;" href="' +
                        resultObj.return_url +
                        '" target="_blank">Click Here to Generate Return Label</a></div>'
                    );
                  }
                });
              }

              if (response.declined_items.length > 0) {
                var di = response.declined_items;
                $.each(di, function (i, obj) {
                  var chk = ".li-" + obj,
                    item = ".litem-" + obj;
                  $(chk).addClass("disabled");
                  $(item).addClass("item-return-declined");
                  $(item + " .checkbox").addClass("d-none");
                  $(item + " .exchange-box").addClass("d-none");
                  $(item + " .order-detail").append(
                    '<div class="return-requested"> Return Request Declined</div>'
                  );
                });
              }

              $(".order-wrapper").fadeIn();
              $(".loading").removeClass("active");
              console.log("Success Done");
            },
            complete: function (data) {
              console.log("Complete");
              processExchangeItems(data);
              $(".vendor-list-box").each(function (i, el) {
                var elRowCount = $(el).find(".exchange-form-row").length,
                  elReturnCount = $(el).find(".item-return-requested").length;
                console.log("elRowCount", elRowCount);
                console.log("elReturnCount", elReturnCount);
                if (elRowCount == elReturnCount) {
                  $(el).find(".exchange-button").addClass("d-none");
                }
              });
            },
            error: function (error) {
              $(".loading").removeClass("active");
              console.log("Error in fetching order return requests");
            },
          });
        }
        function processExchangeItems(data) {
          console.log("data", data);
          $(".exchange-form-row").each(function (i, el) {
            // var eljson_data = JSON.parse($(el).find('.line_item_json').html()),
            //     line_item_id = eljson_data.id,
            //     line_item_v_title = eljson_data.variant.title,
            var variant_length = 1,
              item = $(this).find(".litem-");
            /* variant_title = '',
                    variant_id = '',
                    option_value = '',
                    html = '';
                    for(i=0; i<variant_length; i++){
                      variant_title = eljson_data.product.variants[i].title,
                      variant_id = eljson_data.product.variants[i].id;
                      
                      var disabled_variant = '',
                          already_purchased = '';
                      
                      if(line_item_v_title == variant_title){
                        disabled_variant = "disabled",
                        already_purchased = " (Already Purchased)";
                      }
                      option_value += `<option data-value="`+variant_id+`" `+disabled_variant+`>`+variant_title+ already_purchased+`</option>`
                    }
            
                    html += `<label>Available Option</label><select name="exchange_option" data-line-item-id="`+line_item_id+`" required="" class="exchange exchange-option-selected-`+line_item_id+`">
                               <option value="" data-value="">Select Option</option>`+option_value+`</select><span class="icon-dropdown">
                               <i class="fa fa-angle-down"></i>
                             </span>`;
        
                  var returnURL = window.location.pathname+'?view=return-form',
                      return_url_link = " <a href='"+returnURL+"'>You can return this item.</a>";
          
                  var chk = '.li-' + line_item_id, item = '.litem-' + line_item_id;
              console.log('variant_length', variant_length);
              console.log('item-return-requested', !jQuery(item).hasClass('item-return-requested'));*/
            // if(variant_length == 1 && !jQuery(item).hasClass('item-return-requested')){
            //     $(chk).addClass('disabled');
            //     $(item).addClass('item-return-requested');
            //     $(item + ' .checkbox').addClass('d-none');
            //     $(item + ' .exchange-box').addClass('d-none');
            //   console.log('Selector', item + ' .order-detail')
            //    // $(item + ' .order-detail').append('<div class="return-requested">Can not use the Exchange Because another product option is not available.'+return_url_link+'</div>');
            // }else{
            //     //$(el).find('.exchange-options-list').prepend(html);
            // }
          });
        }

        fetchOrderReturnStatus();
      }

      function uniqueArray(a) {
        function onlyUnique(value, index, self) {
          return self.indexOf(value) === index;
        }
        var unique = a.filter(onlyUnique); // returns ['a', 1, 2, '1']
        return unique;
      }

      function log(el, ki) {
        console.log("=========", ki, "====");
        console.log(el);
        console.log("===================");
      }
    },

      // initCustomCartTabs: function () {
      //   console.log('initCustomCartTabs');
      //     $("#tabs")
      //       .tabs({
      //         active: 0,
      //       })
      //       .addClass("ui-tabs-vertical ui-helper-clearfix");
      //   },

      initCustomTabs: function () {
          var customTabsSection = $("[data-custom-tabs]");
    
          customTabsSection.each(function () {
            var self = $(this),
              listTabs = self.find(".list-custom-tabs"),
              tabLink = listTabs.find("[data-custom-tabTop]"),
              tabContent = self.find("[data-custom-TabContent]");
    
            var linkActive = self.find(".list-custom-tabs .tab-links.active"),
              activeTab = self.find(".custom-tabs-content .tab-content.active");
    
            tabLink.off("click").on("click", function (e) {
              e.preventDefault();
              e.stopPropagation();
    
              if ($(this).hasClass("active")) {
                return;
              }
    
              if (!$(this).hasClass("active")) {
                var curTab = $(this),
                  curCCtitle = curTab.data("cctitle"),
                  curTabContent = $(curTab.data("target"));
    
                tabLink.removeClass("active");
                tabContent.removeClass("active");
    
                if (curCCtitle) {
                  $(".discount-code-field input").attr("placeholder", curCCtitle);
                }
    
                curTab.addClass("active");
                curTabContent.addClass("active");
              }
            });
          });
        },

      /***---DS Function call Ends--****/
        
        menuSidebarMobile: function() {
            var buttonIconOpen = $('.mobileMenu-toggle'),
                buttonClose = $('.halo-sidebar-close, .background-overlay');

            buttonIconOpen.off('click.toggleCurrencyLanguage').on('click.toggleCurrencyLanguage', (event) =>{
                event.preventDefault();
                $body.addClass('menu_open');
                    if(window.mobile_menu == 'default'){
                        if(!$('#navigation-mobile .site-nav-mobile.nav .header__inline-menu').length){
                            $('.header .header__inline-menu').appendTo('#navigation-mobile .site-nav-mobile.nav');
                        }
                    }
                    if(!$('#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text').length){
                        $('.header-top--wrapper .header-top--right .free-shipping-text').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
                    }
                    if(!$('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').length){
                        $('.header-top--wrapper .header-top--right .customer-service-text').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
                    }
                    if(!$('#navigation-mobile .site-nav-mobile.nav-account .header__location').length){
                        $('.header-top--wrapper .header-top--right .header__location').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
                    }
                    if(!$('#navigation-mobile .top-language-currency').length){
                        if($('.header').hasClass('header-03')){
                            $('.header .header-bottom-right .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
                        }else if($('.header').hasClass('header-05')){
                            $('.header .header-top--left .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
                        }else{
                            $('.header .header-language_currency .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
                        }
                    }
                    halo.productMenuSlider();
            });

            buttonClose.off('click.toggleCloseCurrencyLanguage').on('click.toggleCloseCurrencyLanguage', () =>{
                $body.removeClass('menu_open');
                $('#navigation-mobile').off('transitionend.toggleCloseMenu').on('transitionend.toggleCloseMenu', () => {
                    if (!$body.hasClass('menu_open')) {

                        if(!$('.header .header__inline-menu').length){
                            if($('.header').hasClass('header-03') || $('.header').hasClass('header-04') || $('.header').hasClass('header-07') || $('.header').hasClass('header-08')){
                                $('#navigation-mobile .site-nav-mobile.nav .header__inline-menu').appendTo('.header .header-bottom--wrapper .header-bottom-left');
                            }else{
                                $('#navigation-mobile .site-nav-mobile.nav .header__inline-menu').appendTo('.header .header-bottom--wrapper');
                            }
                        }
                        if(!$('.header-top--wrapper .header-top--right .free-shipping-text').length){
                            if(!$('.header-04').hasClass('style_2')){
                                $('#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text').insertBefore('.header-top--wrapper .header-top--right .header__group');
                            }
                        }
                        if(!$('.header-top--wrapper .header-top--right .header__location').length){
                            $('#navigation-mobile .site-nav-mobile.nav-account .header__location').insertBefore('.header-top--wrapper .header-top--right .header__group');
                        }
                        if(!$('.header-top--wrapper .header-top--right .customer-service-text').length){
                            if($('.header').hasClass('header-03')){
                                $('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').insertBefore('.header-top--wrapper .header-top--right .header__group .header__icon--wishlist');
                            }else{
                                $('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').insertBefore('.header-top--wrapper .header-top--right .top-language-currency');
                            }
                        }
                        if(!$('.header-language_currency .top-language-currency').length){
                            if($('.header').hasClass('header-03')){
                                $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-bottom--wrapper .header-bottom-right .header-language_currency');
                            }else if($('.header').hasClass('header-04')){
                                $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-bottom--wrapper .header-bottom-right .header-language_currency');
                            }else if($('.header').hasClass('header-05')){
                                $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-top--wrapper .header-top--left .header-language_currency');
                            }else{
                                $('#navigation-mobile .site-nav-mobile .top-language-currency').insertBefore('.header .header-language_currency .header__search');
                            }
                        }
                    }
                })
                    
            });

            $doc.on('click', '.halo-sidebar-close', function (e) {
                e.preventDefault();
                e.stopPropagation();
                $body.removeClass('menu_open');
            });
        },

        menuSidebarMobileToggle: function() {
            $body.on('click', '.site-nav-mobile .list-menu .menu_mobile_link', function (e) {
                if(!e.currentTarget.classList.contains('list-menu__item--end')){
                    e.preventDefault();
                    e.stopPropagation();
                    var $target = $(this);
                    var $parent = $target.parent();
                    var $menuDislosure1 = $target.parent().find('ul.list-menu--disclosure-1');

                    $parent.removeClass('is-hidden').addClass('is-open').removeClass('d-none');
                    $menuDislosure1.off('transitionend.toggleMenuLink1').on('transitionend.toggleMenuLink1', () => {
                        if ($parent.hasClass('is-open') && !$parent.hasClass('is-hidden') && !$parent.hasClass('d-none')) {
                            // $parent.addClass('d-none')
                            $parent.siblings().removeClass('is-open').addClass('is-hidden').removeClass('d-none');
                        }
                    })

                    // $target.parent().siblings().removeClass('is-open').addClass('is-hidden');
                    // $target.parent().removeClass('is-hidden').addClass('is-open');
                }
            });

            $body.on('click', '.site-nav-mobile .list-menu .menu_mobile_link_2', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var $target = $(this);
                var $target = $(this);
                var $parent = $target.parent().parent();
                var $menuDislosure2 = $target.parent().find('ul.list-menu--disclosure-2');
                var $parentToScroll = $target.parent().parent().parent().parent().parent().parent();

                $parent.removeClass('is-hidden').addClass('is-open').removeClass('d-none');
                $menuDislosure2.off('transitionend.toggleMenuLink2').on('transitionend.toggleMenuLink2', () => {
                    if ($parent.hasClass('is-open') && !$parent.hasClass('is-hidden') && !$parent.hasClass('d-none')) {
                        $parent.addClass('d-none')
                        $parent.siblings().removeClass('is-open').addClass('is-hidden').removeClass('d-none');
                        $parentToScroll.animate({
                            scrollTop: 0
                        }, 0);
                    }
                })

                // if($('.header').hasClass('header-04') || $('.header').hasClass('header-01') || $('.header').hasClass('header-02')){
                    // $target.parent().parent().siblings().removeClass('is-open').addClass('is-hidden');
                    // $target.parent().parent().removeClass('is-hidden').addClass('is-open');
                    // $target.parent().parent().parent().parent().parent().parent().animate({
                    //     scrollTop: 0
                    // }, 0);
                // } else{
                //     $target.parents('.site-nav').siblings().removeClass('is-open').addClass('is-hidden');
                //     $target.parents('.site-nav').removeClass('is-hidden').addClass('is-open');
                //     $target.parents('.menu-dropdown__wrapper').animate({
                //         scrollTop: 0
                //     }, 0);
                // }

                if($('.menu-dropdown').hasClass('megamenu_style_4') || $('.menu-dropdown').hasClass('megamenu_style_1')){
                    $target.parents('.menu-dropdown').animate({
                        scrollTop: 0
                    }, 0);
                }

                $target.parents('.menu-dropdown').addClass('is-overflow');
            });

            $body.on('click', '.nav-title-mobile', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var $target = $(this),
                    $parentLv1 = $target.parent().parent().parent().parent('.is-open'),
                    $parentLv2 = $target.parent().parent().parent('.is-open'),
                    $parentLv3 = $target.parent().parent('.is-open');

                $parentLv1.siblings().removeClass('is-hidden');
                $parentLv1.removeClass('is-open').removeClass('d-none');
                $parentLv2.siblings().removeClass('is-hidden');
                $parentLv2.removeClass('is-open').removeClass('d-none');
                $parentLv3.siblings().removeClass('is-hidden');
                $parentLv3.removeClass('is-open').removeClass('d-none');
                $('.menu-dropdown').removeClass('is-overflow');
            });

            if(window.mobile_menu != 'default'){
                $doc.on('click', '[data-mobile-menu-tab]', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    var tabItem = event.currentTarget.closest('li'),
                        tabTarget = event.currentTarget.dataset.target;

                    if(!tabItem.classList.contains('is-active')){

                        document.querySelector('[data-navigation-tab-mobile]').querySelectorAll('li').forEach((element) =>{
                            if(element != tabItem){
                                element.classList.remove('is-active');
                            } else {
                                element.classList.add('is-active');

                                document.querySelectorAll('[id^="MenuMobileListSection-"]').forEach((tab) =>{
                                    if(tab.getAttribute('id') == tabTarget) {
                                        tab.classList.remove('is-hidden');
                                        tab.classList.add('is-visible');
                                    } else {
                                        tab.classList.remove('is-visible');
                                        tab.classList.add('is-hidden');
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },
         initScrollTop: function () {
              var backToTop = $("#back-top");
        
              $win.scroll(function () {
                if ($(this).scrollTop() > 220) {
                  backToTop.fadeIn(400);
                } else {
                  backToTop.fadeOut(400);
                }
              });
        
              backToTop.off("click.scrollTop").on("click.scrollTop", function (e) {
                e.preventDefault();
                e.stopPropagation();
        
                $("html, body").animate(
                  {
                    scrollTop: 0,
                  },
                  400
                );
                return false;
              });
            },
        setCookie(cname, cvalue, exdays){
            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            const expires = 'expires=' + d.toUTCString();
            document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
        },

        initMultiTab: function() {
            let designMode;
            document.body.matches('.shopify-design-mode') ? designMode = true : designMode = false;
            
            if($('[data-menu-tab]').length > 0){
                $doc.on('click', '[data-menu-tab] li', (event) => {
                    var active = $(event.currentTarget).data('load-page'),
                        href= $(event.currentTarget).attr('href');

                    $.cookie('page-url', active, {
                        expires: 1,
                        path: '/'
                    });
                });

                var canonical = $('[canonical-shop-url]').attr('canonical-shop-url'),
                    pageUrl = $.cookie('page-url'),
                    menuTabItem,
                    logoTabItem,
                    menuItem;

                if ((window.location.pathname.indexOf('/pages/') !== -1) && window.page_active && (window.page_active != pageUrl))  {
                    this.setCookie('page-url', window.page_active, 1);
                    pageUrl = window.page_active;
                }
                
                if(pageUrl != null){
                    menuTabItem = $(`[data-load-page="${pageUrl}"]`);
                    logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
                    menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
                } else{
                    menuTabItem = $('[data-load-page].is-active');
                    logoTabItem = $('[data-load-logo-page].first');
                    menuItem = $('[data-load-menu-page].is-active');
                }

                var menuTab = menuTabItem.closest('[data-menu-tab]');
              
                menuTab.find('[data-load-page]').not(menuTabItem).removeClass('is-active');
                logoTabItem.siblings().removeClass('is-active');
                menuItem.siblings().removeClass('is-active');
                if(pageUrl != '') {
                  logoTabItem.addClass('is-active');
                  menuTabItem.addClass('is-active');
                  menuItem.addClass('is-active');
                } else {
                  $('[data-load-page]:nth-child(1)').addClass('is-active');
                  $('[data-load-logo-page]:nth-child(1)').addClass('is-active');
                  $('[data-load-menu-page]:nth-child(1)').addClass('is-active');
                }

                var active = $('[data-menu-tab] li.is-active').data('load-page'),
                    check = false,
                    url = window.routes.root + `/search?type=product&q=${active}&view=ajax_mega_menu`;
              
                if($body.hasClass('template-index')){
                    if ($win.width() < 1025) {
                        if(window.mobile_menu == 'default'){
                            window.addEventListener('load', () => {
                                if (designMode) {
                                    if (check == false) {
                                        check = true;
                                        halo.initMobileMenuDefault(url)
                                    }
                                }
                                else {
                                    document.body.addEventListener('click', () => {
                                        if (check == false) {
                                            check = true;
                                            halo.initMobileMenuDefault(url)
                                        }
                                    }, false)
                                }
                            }, false)
                        } else {
                            window.addEventListener('load', () => {
                                if (designMode) {
                                    if (check == false) {
                                        check = true;
                                        halo.initMultiTabMobile()
                                    }
                                }
                                else {
                                    document.body.addEventListener('click', () => {
                                        if (check == false) {
                                            check = true;
                                            halo.initMultiTabMobile()
                                        }
                                    }, false)
                                }
                            }, false)
                        }
                    }
                } else {
                    if ($win.width() < 1025) {
                        if(window.mobile_menu == 'default'){
                            window.addEventListener('load', () => {
                                if (designMode) {
                                    if (check == false) {
                                        check = true;
                                        halo.initMobileMenuDefault(url)
                                    }
                                }
                                else {
                                    document.body.addEventListener('click', () => {
                                        if (check == false) {
                                            check = true;
                                            halo.initMobileMenuDefault(url)
                                        }
                                    }, false)
                                }
                             }, false)
                        } else {
                            window.addEventListener('load', () => {
                                if (designMode) {
                                    if (check == false) {
                                        check = true;
                                        halo.initMultiTabMobile()
                                    }
                                }
                                else {
                                    document.body.addEventListener('click', () => {
                                        if (check == false) {
                                            check = true;
                                            halo.initMultiTabMobile()
                                        }
                                    }, false)
                                }
                            }, false)
                        }
                    }
                }
            } else {
                var check = false,
                    url = window.routes.root + '/search?view=ajax_mega_menu';

                if ($win.width() < 1025) {
                    if (window.mobile_menu == "default") {
                        if (designMode) {
                            if (check == false) {
                                check = true;
                                halo.initMobileMenuDefault(url)
                            }
                        }
                        else {
                            document.body.addEventListener("click",() => {
                                if (check == false) {
                                    check = true;
                                    halo.initMobileMenuDefault(url)
                                }
                            }, false)
                        }
                    } else {
                        window.addEventListener("load",() => {
                            if (designMode) {
                                if (check == false) {
                                    check = true;
                                    halo.initMultiTabMobile()
                                }
                            }
                            else {
                                document.body.addEventListener("click",() => {
                                    if (check == false) {
                                        check = true;
                                        halo.initMultiTabMobile()
                                    }
                                }, false)
                            }
                        }, false)
                    }
                }
            }
        },

        initMobileMenuDefault: function(url) {
            const menuMobile = $('[data-navigation-mobile]');
            const nav = $('#HeaderNavigation [data-navigation]');
            const style = nav.attr('style') != undefined ? nav.attr('style') : nav.closest('#HeaderNavigation').attr('style');
            menuMobile.append(`<nav class="header__inline-menu" data-navigation role="navigation" style="${style != undefined ? style : ''}">${nav.html() != undefined ? nav.html() : ''}</nav>`);

            const topLanCur = $('.top-language-currency');
            const lanCurMobile = $('#navigation-mobile .nav-currency-language');
            if (lanCurMobile.text().trim() == '' && topLanCur.length > 0) lanCurMobile.append(`<div class="top-language-currency">${topLanCur.html()}</div>`)
            
            // If second level menu have only 1 menu, open thrid level menu directly strat
            $('.menu-lv-1').on('click', function() {
              var dropdowns = $(this).find('.site-nav.dropdown');
              if (dropdowns.length === 1) {
                dropdowns.addClass('is-open');
              }
            });
          
            $('.back-level-2').on('click', function(e) {
              e.preventDefault();
              const $megamenu = $(this).closest('.menu-dropdown');
              const $dropdowns = $megamenu.find('.site-nav.dropdown');
              const $backLevel1 = $megamenu.find('.back-level-1');
              if ($dropdowns.length === 1) {
                  $backLevel1.trigger('click');
              } 
          });
          // If second level menu have only 1 menu, open thrid level menu directly ends
          
        },

        initMultiTabMobile: function() {
            if ($win.width() < 1025) {
                if(window.mobile_menu == 'custom'){
                    var chk = false,
                        menuElement = $('[data-section-type="menu"]'),
                        menuMobile = $('[data-navigation-mobile]'),
                        menuTabMobile = $('[data-navigation-tab-mobile]');

                        document.body.addEventListener('click', () => {
                            if (chk == false) {
                                chk = true;
                                const content = document.createElement('div');
                                const tab = document.createElement('ul');
                                
                                Object.assign(tab, {
                                    className: 'menu-tab list-unstyled'
                                });
                                
                                tab.setAttribute('role', 'menu');
                                
                                menuElement.each((index, element) => {
                                    var currentMenu = element.querySelector('template').content.firstElementChild.cloneNode(true);
                                    
                                    if(index == 0){
                                        currentMenu.classList.add('is-visible'); 
                                    } else {
                                        currentMenu.classList.add('is-hidden');
                                    }
                                    
                                    content.appendChild(currentMenu);
                                });

                                content.querySelectorAll('[id^="MenuMobileListSection-"]').forEach((element, index) => {
                                    var tabTitle = element.dataset.heading,
                                        tabId = element.getAttribute('id'),
                                        tabElement = document.createElement('li');

                                    Object.assign(tabElement, {
                                        className: 'item'
                                    });

                                    tabElement.setAttribute('role', 'menuitem');

                                    if (index == 0) {
                                        tabElement.classList.add('is-active');
                                    }

                                    tabElement.innerHTML = `<a class="link" href="#" data-mobile-menu-tab data-target="${tabId}">${tabTitle}</a>`;

                                    tab.appendChild(tabElement);
                                });

                                menuTabMobile.html(tab);
                                menuMobile.html(content.innerHTML);
                            }
                        }, false);
                }
            }
        },

        initMenu: function(url) {
            if(!$('.header').hasClass('header-04')){
                fetch(url)
                    .then(response => response.text())
                    .then(text => {
                        const html = document.createElement('div');
                        html.innerHTML = text;
                        const navigation = html.querySelector('#HeaderNavigation');
                        if (navigation && navigation.innerHTML.trim().length) {
                            document.querySelector('#HeaderNavigation').innerHTML = navigation.innerHTML;
                        }
                    })
                    .catch(e => {
                        console.error(e);
                    });
            }
        },
        
        clickedActiveProductTabs: function() {
            const handler = (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const $block = $(entry.target);
                        if ($block.hasClass('ajax-loaded')) return;

                        var listTabs = $block.find('.list-product-tabs'),
                            tabLink = listTabs.find('[data-product-tabTop]'),
                            tabContent = $block.find('[data-product-TabContent]'),
                            limit = $block.data('limit');

                        var linkActive = listTabs.find('.tab-links.active'),
                            activeTab = $block.find('.product-tabs-content .tab-content.active');
                            
                        if (!$block.hasClass('ajax-loaded')) {
                            halo.doAjaxProductTabs(
                                linkActive.data('href'), 
                                activeTab.find('.loading'), 
                                activeTab.find('.products-load'), 
                                $block.attr('sectionid'), 
                                limit,
                                $block
                            );
                        }
                        
                        tabLink.off('click').on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();

                            if (!$(this).hasClass('active')) {
                                const curTab = $(this),
                                    curTabContent = $(curTab.data('target'));

                                tabLink.removeClass('active');
                                tabContent.removeClass('active');

                                if (!curTabContent.hasClass('loaded')) halo.doAjaxProductTabs(curTab.data('href'), curTabContent.find('.loading'), curTabContent.find('.products-load'), $block.attr('sectionid'), limit);
                                
                                curTab.addClass('active');
                                curTabContent.addClass('active');
                                curTabContent.find('.slick-slider').slick('refresh');
                            };
                        });
                    }
                })
            }

            this.productBlock = document.querySelectorAll('[data-product-tab-block]');

            const config = {
                threshold: 0.1,
            }

            this.observer = new IntersectionObserver(handler, config);
            this.productBlock.forEach(block => {
                this.observer.observe(block);
            });
        },

        doAjaxProductTabs: function (handle, loadingElm, curTabContent, sectionId, limit, self) {
            $.ajax({
                type: "get",
                url: handle,
                data: {
                    constraint: `sectionId=${handle}+limit=${limit}`
                },

                beforeSend: function () {
                    if (self != undefined) self.addClass('ajax-loaded');
                },

                success: function (data) {
                    curTabContent.parent().addClass('loaded');
                    if (handle == '?view=ajax_product_block') return;
                    
                    if ($(data).text().trim() === '') {
                        noProduct(curTabContent);
                    }
                    else {
                        curTabContent.html(data);

                        if(window.wishlist.show){
                            halo.setLocalStorageProductForWishlist();
                        }

                        if (halo.checkNeedToConvertCurrency()) {
                            Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                        };
                    }
                },
                complete: function () {
                    if (curTabContent.hasClass('products-carousel')) {
                        halo.productBlockSilder(curTabContent.parent());
                    }
                    else if (curTabContent.hasClass('products-cursor') && curTabContent.data('enable-hover') === 'true') {
                        halo.productBlockScroller(curTabContent);
                    }

                    if (window.review.show && $('.shopify-product-reviews-badge').length > 0 && window.SPR != null && typeof window.SPR.registerCallbacks === 'functions') {
                        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                    }
                },
                error: function (xhr, text) {
                    noProduct(curTabContent);
                }
            });
            
            const noProduct = (curTabContent) => {
                curTabContent.html(`<p class="loading center">Sorry, there are no products in this collection</p>`);
            }
        },
        lookbookCarousel: function() {
            var lookbookCarousel = $('.lookbook-carousel'),
                itemToShow = lookbookCarousel.data('item-to-show'),
                itemDots = lookbookCarousel.data('item-dots'),
                itemDotsMb = lookbookCarousel.data('item-dots-mb'),
                itemArrows = lookbookCarousel.data('item-arrows'),
                itemArrowsMb = lookbookCarousel.data('item-arrows-mb');

            if(lookbookCarousel.length > 0) {
                if(lookbookCarousel.not('.slick-initialized')) {
                    lookbookCarousel.slick({
                        mobileFirst: true,
                        adaptiveHeight: true,
                        vertical: false,
                        infinite: true,
                        slidesToShow: itemToShow,
                        slidesToScroll: itemToShow,
                        arrows: itemArrowsMb,
                        dots: itemDotsMb,
                        autoplay: false,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: 
                        [
                            {
                                breakpoint: 1024,
                                settings: {
                                    arrows: itemArrows,
                                    dots: itemDots
                                }
                            }
                        ]
                    });
                }
            }

            if (lookbookCarousel.hasClass('enable_counter_number')) {
                var slickNext = lookbookCarousel.find('.slick-next');
                lookbookCarousel.closest('.special-banner__item--lookbook_banner').find('.products-counter-number').appendTo(slickNext);
                lookbookCarousel.on('afterChange', (event) => {
                    var slickIndex = lookbookCarousel.find('.slick-current').data('slick-index');
                    lookbookCarousel.find("#count-image").text(slickIndex + 1);
                });
            }
        },
        productBlockSilder: function(wrapper) {
            var productGrid = wrapper.find('.products-carousel'),
                itemToShow = productGrid.data('item-to-show'),
                itemDots = productGrid.data('item-dots'),
                itemDotsMb = productGrid.data('item-dots-mb'),
                itemArrows = productGrid.data('item-arrows'),
                itemArrowsMb = productGrid.data('item-arrows-mb'),
                isProductCard06 = document.body.classList.contains('product-card-layout-06');

            if(productGrid.length > 0) {
                if(productGrid.hasClass('slick-initialized')) return;
                if(productGrid.not('.slick-initialized')) {
                    if (isProductCard06) {
                        productGrid.on('init', () => {
                            const selectOptionsHeight = productGrid.find('.product .card-action').eq(0).height();
                            productGrid.find('.slick-list').css('padding-bottom', selectOptionsHeight + 'px');
                            productGrid.attr('data-slider-padding-bottom', selectOptionsHeight)
                        })
                    }

                    if (productGrid.hasClass('enable_progress_bar')) {
                        var progressBar = wrapper.find('.scrollbar-thumb');
                        productGrid.on('init', (event, slick) => {
                            var percent = ((slick.currentSlide / (slick.slideCount - 1)) * 100) + '%';
                            progressBar.css('--percent', percent);
                        });
                    }
                  
                    productGrid.slick({
                        mobileFirst: true,
                        adaptiveHeight: true,
                        vertical: false,
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: itemArrowsMb,
                        dots: itemDotsMb,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: 
                        [
                            {
                                breakpoint: 1599,
                                settings: {
                                    arrows: itemArrows,
                                    dots: itemDots,
                                    get slidesToShow() {
                                        if(itemToShow !== undefined && itemToShow !== null && itemToShow !== ''){
                                            return this.slidesToShow = itemToShow;
                                        } else {
                                            return this.slidesToShow = 1;
                                        }
                                    },
                                    get slidesToScroll() {
                                        if(itemToShow !== undefined && itemToShow !== null && itemToShow !== '' && itemToShow !== 3.5 && itemToShow !== 4.5 && itemToShow !== 5.5){
                                            return this.slidesToScroll = itemToShow;
                                        } else {
                                            return this.slidesToScroll = 1;
                                        }
                                    },
                                    get initialSlide() {
                                        if(itemToShow == 3.5 || itemToShow == 4.5 || itemToShow == 5.5) {
                                            return this.initialSlide = 0.5;
                                        } else {
                                            return this.initialSlide = 1;
                                        }
                                    }
                                }
                            },
                            {
                                breakpoint: 1024,
                                settings: {
                                    arrows: itemArrows,
                                    dots: itemDots,
                                    get slidesToShow() {
                                        if(itemToShow !== undefined && itemToShow !== null && itemToShow !== ''){
                                            if(itemToShow == 5 || itemToShow == 6){
                                                return this.slidesToShow = itemToShow - 1;
                                            } else {
                                                if (productGrid.parents('.collection-column-2').length){
                                                    return this.slidesToShow = 2;
                                                } else{
                                                    return this.slidesToShow = itemToShow;
                                                }
                                               
                                            }
                                        } else {
                                            return this.slidesToShow = 1;
                                        }
                                    },
                                    get slidesToScroll() {
                                        if(itemToShow !== undefined && itemToShow !== null && itemToShow !== '' && itemToShow !== 3.5 && itemToShow !== 4.5 && itemToShow !== 5.5){
                                            if(itemToShow == 5 || itemToShow == 6){
                                                return this.slidesToScroll = itemToShow - 1;
                                            } else {
                                                if (productGrid.parents('.collection-column-2').length){
                                                    return this.slidesToScroll = 2;
                                                } else{
                                                    return this.slidesToScroll = itemToShow;
                                                }
                                               
                                            }
                                        } else {
                                            return this.slidesToScroll = 1;
                                        }
                                    },
                                    get initialSlide() {
                                        if(itemToShow == 3.5 || itemToShow == 4.5 || itemToShow == 5.5) {
                                            return this.initialSlide = 0.5;
                                        } else {
                                            return this.initialSlide = 1;
                                        }
                                    }
                                }
                            },
                            {
                                breakpoint: 991,
                                settings: {
                                    arrows: itemArrowsMb,
                                    dots: itemDotsMb,
                                    get slidesToShow(){
                                        if (productGrid.hasClass('has__banner_tab') || productGrid.parents('.product-block-has__banner').length){
                                            if (productGrid.parents('.product-block-has__banner').length && productGrid.parents('.product-block-has__banner').data('width-banner') > 40) {
                                                return this.slidesToShow = 2;
                                            }
                                            else {
                                                return this.slidesToShow = 3;
                                            }
                                        }
                                        else{
                                            if (productGrid.parents('.collection-column-2').length){
                                                return this.slidesToShow = 2;
                                            }
                                            else if (itemToShow == 1) {
                                                return this.slidesToShow = itemToShow;
                                            }
                                            else{
                                                return this.slidesToShow = 4;
                                            }
                                        }
                                    },
                                    get slidesToScroll(){
                                        if (productGrid.hasClass('has__banner_tab') || productGrid.parents('.product-block-has__banner').length){
                                            if (productGrid.parents('.product-block-has__banner').length && productGrid.parents('.product-block-has__banner').data('width-banner') > 40) {
                                                return this.slidesToScroll = 2;
                                            }
                                            else {
                                                return this.slidesToScroll = 3;
                                            }
                                        }
                                        else{
                                            if (productGrid.parents('.collection-column-2').length){
                                                return this.slidesToScroll = 2;
                                            }
                                            else if (itemToShow == 1) {
                                                return this.slidesToScroll = itemToShow;
                                            }
                                            else{
                                                return this.slidesToScroll = 4;
                                            }
                                        }
                                    },
                                    get initialSlide() {
                                        if(itemToShow == 3.5 || itemToShow == 4.5 || itemToShow == 5.5) {
                                            return this.initialSlide = 0.5;
                                        } else {
                                            return this.initialSlide = 1;
                                        }
                                    }
                                }
                            },
                            {
                                breakpoint: 767,
                                arrows: itemArrowsMb,
                                dots: itemDotsMb,
                                settings: {
                                    get slidesToShow(){
                                        if (productGrid.hasClass('has__banner_tab') || productGrid.parents('.product-block-has__banner').length){
                                            return this.slidesToShow = 2;
                                        }
                                        else if (itemToShow == 1) {
                                            return this.slidesToShow = itemToShow;
                                        }
                                        else{
                                            return this.slidesToShow = 3;
                                        }
                                    },
                                    get slidesToScroll(){
                                        if (productGrid.hasClass('has__banner_tab') || productGrid.parents('.product-block-has__banner').length){
                                            return this.slidesToScroll = 2;
                                        }
                                        else if (itemToShow == 1) {
                                            return this.slidesToScroll = itemToShow;
                                        }
                                        else{
                                            return this.slidesToScroll = 3;
                                        }
                                    },
                                    get initialSlide() {
                                        if(itemToShow == 3.5 || itemToShow == 4.5 || itemToShow == 5.5) {
                                            return this.initialSlide = 0.5;
                                        } else {
                                            return this.initialSlide = 1;
                                        }
                                    }
                                }
                            },
                            {
                                breakpoint: 320,
                                arrows: itemArrowsMb,
                                dots: itemDotsMb,
                                settings: {
                                    get slidesToShow(){
                                        if (itemToShow == 1) {
                                            if (productGrid.hasClass('special-banner__products--slider') || productGrid.hasClass('special-banner__products--grid')) {
                                                return this.slidesToShow = 2;
                                            } else {
                                                return this.slidesToShow = itemToShow;
                                            }
                                        }
                                        else {
                                            return this.slidesToShow = 2;
                                        }

                                    },
                                    get slidesToScroll(){
                                        if (itemToShow == 1) {
                                            return this.slidesToScroll = itemToShow;
                                        }
                                        else {
                                            return this.slidesToScroll = 2;
                                        }
                                    }
                                }
                            }
                        ]
                    });

                    if (productGrid.hasClass('enable_progress_bar')) {
                        productGrid.on('afterChange', (event, slick, nextSlide) => {
                            var percent = ((nextSlide / (slick.slideCount - 1)) * 100) + '%';
                            progressBar.css('--percent', percent);
                        });
                    }
                    if (productGrid.hasClass('enable_counter_number')) {
                        var slickNext = productGrid.find('.slick-next');
                        productGrid.closest('.halo-block, .special-banner__product').find('.products-counter-number').appendTo(slickNext);
                        productGrid.on('afterChange', (event) => {
                            var slickIndex = productGrid.find('.slick-current').data('slick-index');
                            productGrid.find("#count-image").text(slickIndex + 1);
                        });
                    }
                }
            }
        },

        productBlockInfiniteScroll: function() {
            var productBlock = $('[data-product-block], [data-product-tab-block]');

            productBlock.each((index, element) => {
                var $block = $(element),
                    showMore = $block.find('[data-product-infinite]');
            
                if (showMore.length > 0) {
                    showMore.find('.button').on('click', (event) => {
                        var showMoreButton = $(event.target);

                        if (!showMoreButton.hasClass('view-all')) {
                            event.preventDefault();
                            event.stopPropagation();

                            // var text = window.button_load_more.loading;

                            showMoreButton.addClass('is-loading');
                            // showMoreButton.text(text);

                            var url = showMoreButton.attr('data-collection'),
                                limit = showMoreButton.attr('data-limit'),
                                swipe = showMoreButton.attr('data-swipe'),
                                total = showMoreButton.attr('data-total'),
                                image_ratio = showMoreButton.attr('data-image-ratio'),
                                sectionId = showMoreButton.attr('sectionId'),
                                page = parseInt(showMoreButton.attr('data-page'));

                            halo.doProductBlockInfiniteScroll(url, total, limit, swipe, image_ratio, sectionId, page, showMoreButton, $block);
                        }
                    });
                }
            });
        },

        doProductBlockInfiniteScroll: function(url, total, limit, swipe, image_ratio, sectionId, page, showMoreButton, $block){
            $.ajax({
                type: 'get',
                url: window.routes.root + '/collections/' + url,
                cache: false,
                data: {
                    view: 'ajax_product_block_load_more',
                    constraint: 'limit=' + limit + '+page=' + page + '+sectionId=' + sectionId + '+imageRatio=' + image_ratio + '+swipe=' + swipe
                },
                beforeSend: function () {
                    // halo.showLoading();
                },
                success: function (data) {
                    const $productGrid = showMoreButton.closest('.tab-content').length ? showMoreButton.closest('.tab-content').find('.products-grid') : showMoreButton.closest('.halo-block-content').find('.products-grid');
                    $productGrid.append(data);

                    var length = $productGrid.find('.product').length;

                    if($(data).length == limit && length < 50){
                        var text = window.button_load_more.default;

                        showMoreButton.removeClass('is-loading');
                        showMoreButton.attr('data-page', page + 1);
                        showMoreButton.find('span').text(text);
                    } else {
                        if (total > 50) {
                            var text = window.button_load_more.view_all;

                            showMoreButton.find('span').text(text);
                            showMoreButton.removeClass('is-loading');
                            showMoreButton.attr('href', window.routes.root + '/collections/' + url).addClass('view-all');
                        } else {
                            var text = window.button_load_more.no_more;

                            showMoreButton.find('span').text(text);
                            showMoreButton.removeClass('is-loading');
                            showMoreButton.attr('disabled', 'disabled');
                        }
                    }
                },
                complete: function () {
                    // halo.hideLoading();
                    if (halo.checkNeedToConvertCurrency()) {
                        Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                    };

                    if (window.review.show && $('.shopify-product-reviews-badge').length > 0 && window.SPR != null && typeof window.SPR.registerCallbacks === 'functions') {
                        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                    }
                }
            });
        },

        productMenuSlider: function(){
            var productGrid = $('.megamenu_style_5');
            if(productGrid.length > 0) {
                productGrid.each((index, el) => {
                    let _self = $(el).find('.products-carousel'),
                        _dataRows = _self.data('row');
                    if(_self.not('.slick-initialized')) {
                        _self.slick({
                            mobileFirst: true,
                            adaptiveHeight: true,
                            vertical: false,
                            infinite: false,
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: true,
                            rtl: window.rtl_slick,
                            responsive: 
                            [
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 3,
                                        slidesToScroll: 1,
                                    }
                                },
                                {
                                    breakpoint: 1500,
                                    settings: {
                                        slidesToShow: _dataRows,
                                        slidesToScroll: 1,
                                        dots: false
                                    }
                                }
                            ]
                        });
                    }
                })
            }
        },

        buildRecommendationBlock: function(){
            if (document.querySelector('[data-recommendations-block]') == null) return;

            var $this = document.querySelector('[data-recommendations-block]'),
                layout = $this.dataset.layout;
                swipe = $this.dataset.swipe;

            const config = {
                threshold: 0.25,
            }

            const handleIntersection = (entries, observer) => {
                const recommendationsContainer = $this.querySelector('.wrapper-container');
                if (!entries[0].isIntersecting) return;
                if ($this.innerHTML.trim() != '' && !recommendationsContainer.classList.contains('product-recommendations-loading') && !recommendationsContainer.classList.contains('has-product')) return;
                recommendationsContainer.classList.add('has-product');

                fetch($this.dataset.url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('[data-recommendations-block]');
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        $this.innerHTML = recommendations.innerHTML;

                        var productItems = $($this).find('.product-item')
                        var firstProductData = productItems.eq(0).data('json-product')
                        if (!firstProductData) return $($this).remove();

                        if (layout == 'slider') {
                            halo.productBlockSilder($($this));
                        } else if (layout == 'scroll') {
                            const enableHover = $($this).find('[data-enable-hover]').attr('data-enable-hover')
                            const wrapper = $this.closest('.products-flex');

                            if (enableHover === 'true' && wrapper.clientWidth < wrapper.scrollWidth) {
                                halo.productBlockScroller($($this));
                            }
                        }

                        var productItems = $($this).find('.product-item')
                        productItems.each(async (index, rawProduct) => {
                            var product = $(rawProduct);
                            var productId = product.data('product-id');
                            var productJson = product.data('json-product');
                            var handle = productJson.handle
                            
                            await  $.ajax({
                                type: 'get',
                                url: window.routes.root + '/products/' + handle + '?view=ajax_variant_quantity',
                                beforeSend: function () {},
                                success: function (data) {
                                    const element = new DOMParser().parseFromString(data, 'text/html')
                                    if (element.querySelector(`[data-quantity-product-id="${productId}"]`)) {
                                        const quantityInfo = JSON.parse(element.querySelector(`[data-quantity-product-id="${productId}"]`).innerHTML)
                                        window[`quick_view_inven_array_${productId}`] = quantityInfo
                                    }
                                },      
                                error: function (xhr, text) {
                                    halo.showWarning($.parseJSON(xhr.responseText).description);
                                },
                                complete: function () {}
                            });
                        }) 

                        const loadingImages = $this.querySelectorAll('.media--loading-effect img');
                        this.observeImageLazyloaded(loadingImages);

                        if(window.compare.show){
                            var $compareLink = $('[data-compare-link]');

                            halo.setLocalStorageProductForCompare($compareLink);
                        }

                        if(window.wishlist.show){
                            halo.setLocalStorageProductForWishlist();
                        }

                        if (window.review.show && $('.shopify-product-reviews-badge').length > 0 && window.SPR != null && typeof window.SPR.registerCallbacks === 'functions') {
                            return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                        }

                        this.calculateTranslateYHeight()
                    }
                })
                .catch(e => {
                    console.error(e);
                });
            }

            new IntersectionObserver(handleIntersection.bind($this), ({}, config)).observe($this);
        },

        initVideoPopup: function (){
            if ($(".video-open-popup").length) {
            } else {return}
            $('.video-open-popup .video-button').off('click').on('click',function(){
                let video_type = $(this).attr('data-type'),
                    video_src = $(this).attr('data-src'),
                    aspect_ratio = $(this).attr('aspect_ratio'),
                    modal = $('[data-popup-video]');

                const $content = `<div class="fluid-width-video-wrapper" style="padding-top: ${aspect_ratio}">
                                    ${video_type == 'youtube' ? 
                                        `<iframe
                                            id="player"
                                            type="text/html"
                                            width="100%"
                                            frameborder="0"
                                            webkitAllowFullScreen
                                            mozallowfullscreen
                                            allowFullScreen
                                            src="https://www.youtube.com/embed/${video_src}?autoplay=1&mute=1">
                                        </iframe>`
                                        :
                                        `<iframe 
                                            src="https://player.vimeo.com/video/${video_src}?autoplay=1&mute=1" 
                                            class="js-vimeo" 
                                            allow="autoplay; 
                                            encrypted-media" 
                                            webkitallowfullscreen 
                                            mozallowfullscreen 
                                            allowfullscreen">
                                        </iframe>`
                                    }
                                </div>`;
                modal.find('.halo-popup-content').html($content);
                $body.addClass('video-show');
            });

            $('[data-popup-video], [data-popup-video] .halo-popup-close, .background-overlay').on('click', function (e) {
                // e.preventDefault();
                // e.stopPropagation();
                let modalContent = $('[data-popup-video] .halo-popup-content');
                if (!modalContent.is(e.target) && !modalContent.has(e.target).length) {
                    $body.removeClass('video-show');
                    $('[data-popup-video] iframe').remove();
                };
            });
        },

        swapHoverVideoProductCard: function () {
            if (window.innerWidth > 1200) {
                $('.product-item .card').mouseenter(function(){
                    var chil = $(this).find('video');
                    var _chil = $(this).find('video').get(0);
                    if (chil.length > 0) {
                        _chil.play();
                    }
                });
                $('.product-item .card').mouseleave(function(){
                    var chil = $(this).find('video');
                    var _chil = $(this).find('video').get(0);
                    if (chil.length > 0) {
                        _chil.pause();
                    }
                })
            }
        },

        initGlobalCheckbox: function() {
            $doc.on('change', '.global-checkbox--input', (event) => {
                var targetId = event.target.getAttribute('data-target');

                if(event.target.checked){
                    $(targetId).attr('disabled', false);
                } else{
                    $(targetId).attr('disabled', true);
                }
            });

            $doc.on('click', '[data-term-condition]', (event) => {
                event.preventDefault();
                event.stopPropagation();
                $body.addClass('term-condition-show');
            });

            $doc.on('click', '[data-close-term-condition-popup]', (event) => {
                event.preventDefault();
                event.stopPropagation();
                $body.removeClass('term-condition-show');
            });

            $doc.on('click', (event) => {
                setTimeout(() => {
                    if ($body.hasClass('cart-sidebar-show')) {
                        if (($(event.target).closest('[data-term-condition-popup]').length === 0)){
                            $body.removeClass('term-condition-show');
                        }
                    }
                    if ($body.hasClass('term-condition-show')) {
                        if ($(event.target).closest('[data-term-condition-popup]').length === 0){
                            $body.removeClass('term-condition-show');
                        }
                    }
                }, 10);
            });
        },
        
        initColorSwatch: function() {
            $doc.ready(function() {
                $('.card .swatch-label.is-active').trigger('click');
            });
            
            $doc.on('click', '.card .swatch-label', (event) => {
                var $target = $(event.currentTarget),
                    title = $target.attr('title').replace(/^\s+|\s+$/g, ''),
                    product = $target.closest('.product-item'),
                    productJson = product.data('json-product'),
                    productTitle = product.find('.card-title'),
                    productAction = product.find('[data-btn-addtocart]'),
                    variantId = $target.data('variant-id'),
                    productHref = product.find('a').attr('href'),
                    oneOption = $target.data('with-one-option'),
                    newImage = $target.data('variant-img'),
                    mediaList = []; 

                $target.parents('.swatch').find('.swatch-label').removeClass('is-active');
                $target.addClass('is-active');
                
                if(productTitle.hasClass('card-title-change')){
                    if($body.hasClass('style_2_text_color_varriant')){
                        productTitle.find('[data-change-title]').text(title);
                    }else{
                        productTitle.find('[data-change-title]').text(' - ' + title);
                    }
                } else {
                    if($body.hasClass('style_2_text_color_varriant')){
                        productTitle.addClass('card-title-change').append('<span data-change-title>' + title + '</span>');
                    }else{
                        productTitle.addClass('card-title-change').append('<span data-change-title> - ' + title + '</span>');
                    }
                }

                const selectedVariant = productJson.variants.find(variant => variant.id === variantId)

                if (selectedVariant.compare_at_price > selectedVariant.price) {
                    product.find('.price').addClass('price--on-sale');
                    product.find('.price__sale .price-item--regular').html(Shopify.formatMoney(selectedVariant.compare_at_price, window.money_format));
                    product.find('.price__sale .price-item--sale').html(Shopify.formatMoney(selectedVariant.price, window.money_format));
                    const labelSale = `-${Math.round((selectedVariant.compare_at_price - selectedVariant.price) * 100 / selectedVariant.compare_at_price)}%`;
                    product.find('.price__label_sale .label_sale').html(labelSale);
                } else {
                    product.find('.price__regular .price-item').html(Shopify.formatMoney(selectedVariant.price, window.money_format));

                    if (selectedVariant.compare_at_price == null) {
                        product.find('.price').removeClass('price--on-sale');
                        product.find('.price__sale .price-item--regular').html('');
                    }
                }
  
                product.find('a:not(.single-action):not(.number-showmore)').attr('href', productHref.split('?variant=')[0]+'?variant='+ variantId);

                if (oneOption != undefined) {
                    var quantity = $target.data('quantity');

                    product.find('[name="id"]').val(oneOption);
  
                    if (quantity > 0) {
                        if(window.notify_me.show){
                            productAction
                                .removeClass('is-notify-me')
                                .addClass('is-visible');
                        } else {
                            productAction
                                .removeClass('is-soldout')
                                .addClass('is-visible');
                        }
                    } else {
                       if(window.notify_me.show){
                            productAction
                                .removeClass('is-visible')
                                .addClass('is-notify-me');
                        } else {
                            productAction
                                .removeClass('is-visible')
                                .addClass('is-soldout');
                        }
                    }

                    if(productAction.hasClass('is-soldout') || productAction.hasClass('is-notify-me')){
                        if(productAction.hasClass('is-notify-me')){
                            productAction.text(window.notify_me.button);
                        } else {
                            productAction
                                .text(window.variantStrings.soldOut)
                                .prop('disabled', true);
                        }
                    } else {
                        productAction
                            .text(window.variantStrings.addToCart)
                            .prop('disabled', false);
                    }
                } else {
                    if (productJson != undefined) {
                        if(window.quick_shop.show){
                            halo.checkStatusSwatchQuickShop(product, productJson);
                        }
                    }

                    product.find('.swatch-element[data-value="' + title + '"]').find('.single-label').trigger('click');
                }

                if (productJson.media != undefined) {
                    var mediaList = productJson.media.filter((index, element) => {
                        return element.alt === title;
                    });
                }

                if (mediaList.length > 0) {
                    if (mediaList.length > 1) {
                        var length = 2;
                    } else {
                        var length = mediaList.length;
                    }
                    
                    for (var i = 0; i < length; i++) {
                        product.find('.card-media img:eq('+ i +')').attr('srcset', mediaList[i].src);
                    }
                } else {
                    if (newImage) {
                        product.find('.card-media img:nth-child(1)').attr('srcset', newImage);
                    }
                }
  
                // halo.checkPreOrderOfVariant(selectedVariant, productAction, productJson)
                if (halo.checkNeedToConvertCurrency()) {
                    Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                }
            });
              
            $doc.on('click', '.item-swatch-more .number-showmore', (event) => {
                if ($(event.target).closest('.swatch').hasClass('show--more')) {
                    $(event.target).closest('.swatch').removeClass('show--more');
                    $(event.target).find('span:eq(0)').text('+');
                } else {
                    $(event.target).closest('.swatch').addClass('show--more');
                    $(event.target).find('span:eq(0)').text('-'); 
                }
            })
        },

        checkPreOrderOfVariant: function(selectedVariant, productAction, productJson) {
            // Check if variant is allowed to sale when out of stock
            const variantId = selectedVariant.id
            const updatePreOrderText = (productAction, selectedVariant, inventoryQuantity) => {
                const product = productAction.parents('.product-item');
                const hasQuickShopPanel = product.find('[data-quickshop-popup]').length > 0;

                if (selectedVariant.inventory_management == null) {
                    productAction
                        .text(hasQuickShopPanel ? window.variantStrings.add : window.variantStrings.addToCart)
                        .prop('disabled', false)
                        .addClass('button--pre-untrack')
                }
                else if (selectedVariant.available && inventoryQuantity <=0 ) {
                    productAction
                        .text(window.variantStrings.preOrder)
                        .prop('disabled', false)
                        .addClass('button--pre-untrack')
                } else {
                    productAction.removeClass('button--pre-untrack');
                    if (inventoryQuantity > 0) {
                        if(window.notify_me.show){
                            productAction
                                .removeClass('is-notify-me')
                                .addClass('is-visible')
                        } else {
                            productAction
                                .removeClass('is-soldout')
                                .addClass('is-visible')
                        }
                    } else {
                      
                       if(window.notify_me.show){
                            productAction
                                .removeClass('is-visible')
                                .addClass('is-notify-me')
                                .prop('disabled', false);
                        } else {
                            productAction
                                .removeClass('is-visible')
                                .addClass('is-soldout').prop('disabled', true);
                        }
                    }

                    if(productAction.hasClass('is-soldout') || productAction.hasClass('is-notify-me')){
                        if(productAction.hasClass('is-notify-me')){

                            productAction.text(window.notify_me.button).prop('disabled', false).removeClass('btn-unavailable');;
                        } else {
                            productAction
                                .text(window.variantStrings.soldOut)
                                .prop('disabled', true);
                        }
                    } else {
                        productAction
                            .text(hasQuickShopPanel ? window.variantStrings.add : window.variantStrings.addToCart)
                            .prop('disabled', false);
                    }
                }
            }
    
            const variantsQuantityInvenText = `quick_view_inven_array_${productJson.id}`
            var arrayInVarName = variantsQuantityInvenText,
                inven_array = window[arrayInVarName]; 
            
            if(inven_array != undefined) {
                var inven_num = inven_array[variantId],
                    inventoryQuantity = parseInt(inven_num);
                    updatePreOrderText(productAction, selectedVariant, inventoryQuantity)
            } else {
                $.ajax({
                    type: 'get',
                    url: window.routes.root + '/products/' + productJson.handle + '?view=ajax_quick_shop_data',
                    beforeSend: function () {},
                    success: function (data) {
                        window[variantsQuantityInvenText] = JSON.parse(data.split('=')[1])
                        var inven_num = window[variantsQuantityInvenText][variantId],
                            inventoryQuantity = parseInt(inven_num);
                        updatePreOrderText(productAction, selectedVariant, inventoryQuantity)   
                    },      
                    error: function (xhr, text) {
                        halo.showWarning($.parseJSON(xhr.responseText).description);
                    },
                    complete: function () {
                        
                    }
                });
            }
        },

        initQuickShop: function() {
            if(window.quick_shop.show) {
                $doc.on('click', '[data-quickshop-popup]', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                   if (document.body.classList.contains('template-collection')) {
                    checkRestrictions();
                    console.log('Quick shop init from theme.js to check block brand');
                   }
                    
                    var $target = $(event.target),
                        product = $target.parents('.product-item'),
                        productJson = product.data('json-product'),
                        variantPopup = product.find('.variants-popup');
                        
                    const $quickView = document.querySelector('.halo-quick-view-popup');
                    if (!document.body.matches('.qv-loaded', '.qs3-loaded') && $quickView) {
                        halo.buildStyleSheet($quickView.dataset.urlStyleProduct, $quickView);
                        document.body.classList.add('qs3-loaded');
                    }

                    if(!product.hasClass('quickshop-popup-show')){
                     
                        $('.product-item').removeClass('quickshop-popup-show');

                        if ($body.hasClass('quick_shop_option_2')) {
                            var height = product.find('.card-media').outerHeight(true);
                            var variantsArray = variantPopup.find('.variants')

                            if ($body.hasClass('product-card-layout-02')){
                                if ($win.width() > 1024) {
                                    variantsArray.css('max-height', (height - 114) + 'px');
                                    variantsArray.css('min-height', (height - 114) + 'px');
                                } else {
                                    variantsArray.css('max-height', (height - 70) + 'px');
                                    variantsArray.css('min-height', (height - 70) + 'px');
                                } 
                            } else if ($body.hasClass('product-card-layout-04')){
                                if ($win.width() > 1024) {
                                    variantsArray.css('max-height', (height - 116) + 'px');
                                    variantsArray.css('min-height', (height - 116) + 'px');
                                } else {
                                    variantsArray.css('max-height', (height - 70) + 'px');
                                    variantsArray.css('min-height', (height - 70) + 'px');
                                } 
                            } else {
                                if ($win.width() > 1024) {
                                    variantsArray.css('max-height', (height - 74) + 'px');
                                    variantsArray.css('min-height', (height - 74) + 'px');
                                } else {
                                    variantsArray.css('max-height', (height - 20) + 'px');
                                    variantsArray.css('min-height', (height - 20) + 'px');
                                } 
                            }

                            if (variantsArray[0].scrollHeight > variantsArray[0].clientHeight) {
                                variantsArray.addClass('scrollable')
                            }

                            if (!$('.productListing').hasClass('productList')){
                                halo.appendProductQuickShopOption2(product);
                            }
                        } else if ($body.hasClass('quick_shop_option_3')) {
                            const handle = $target.data('product-handle');
                            if (!$('.productListing').hasClass('productList')){
                                halo.updateContentQuickshopOption3(handle);
                            }
                            
                            $doc.on('click', '[data-close-quick-shop-popup]', (event) => {
                                event.preventDefault();
                                event.stopPropagation();
                
                                $body.removeClass('quickshop-popup-show');
                            });
                            
                            $doc.off('click.quickShopOverlay').on('click.quickShopOverlay', (event) => {
                                if ($body.hasClass('quickshop-popup-show') && $(event.target).is('.background-overlay')) {
                                    $body.removeClass('quickshop-popup-show');
                                }
                            })
                        } 

                        if (!$body.hasClass('quick_shop_option_3')) {
                            if ($win.width() < 767) {
                                if ($('.productListing').hasClass('productList')) {
                                    halo.appendToListViewModal(product)
                                } else {
                                    product.addClass('quickshop-popup-show');
                                }
                            } else {
                                product.addClass('quickshop-popup-show');
                            }
                        } else {
                            if ($('.productListing').hasClass('productList')){
                                if ($win.width() < 767) {
                                    halo.appendToListViewModal(product)
                                } else {
                                    product.addClass('quickshop-popup-show');
                                }
                            }
                        }
                        
                        product.find('.swatch-label.is-active').trigger('click');
                        halo.checkStatusSwatchQuickShop(product, productJson);
                        
                        if($body.hasClass('quick_shop_option_2') || ($('productListing').hasClass('productList') && !$('.card-swatch').hasClass('quick_shop_type_3'))){
                            if ($win.width() < 767) {
                                if (!$('.productListing').hasClass('productList')){
                                    var quickshopVariantPopup = $('#halo-card-mobile-popup .variants-popup');
                                    quickshopVariantPopup.find('.selector-wrapper').each((index, element) => {
                                        $(element).find('.swatch-element:not(.soldout):not(.unavailable)').eq('0').find('.single-label').trigger('click');
                                    });
                                } else {
                                    variantPopup.find('.selector-wrapper').each((index, element) => {
                                        $(element).find('.swatch-element:not(.soldout):not(.unavailable)').eq('0').find('.single-label').trigger('click');
                                    });
                                }
                            } else {
                                variantPopup.find('.selector-wrapper').each((index, element) => {
                                    $(element).find('.swatch-element:not(.soldout):not(.unavailable)').eq('0').find('.single-label').trigger('click');
                                });
                            }
                            if (!$('.productListing').hasClass('productList')){
                                $body.addClass('quick_shop_popup_mobile');
                            }
                        } else {
                            variantPopup.find('.selector-wrapper:not(.option-color)').each((index, element) => {
                                $(element).find('.swatch-element:not(.soldout):not(.unavailable)').eq('0').find('.single-label').trigger('click');
                            });
                        }
                    } else {
                        halo.initAddToCartQuickShop($target, variantPopup);
                    }

                    if (halo.checkNeedToConvertCurrency()) {
                        Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                    }
                });

                $doc.on('click', '[data-cancel-quickshop-popup]', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    var $target = $(event.currentTarget),
                        product = $target.parents('.product-item'),
                        quickshopMobilePopup = $doc.find('#halo-card-mobile-popup');

                    product.removeClass('quickshop-popup-show');
                    var productQuickshopShown = $doc.find('.quickshop-popup-show')
                    productQuickshopShown.removeClass('quickshop-popup-show');
                    $body.removeClass('quickshop-list-view-show');
                     
                    if($body.hasClass('quick_shop_option_2')){
                        $body.removeClass('quick_shop_popup_mobile');
                        quickshopMobilePopup.removeClass('show');
                    }
                });

                $doc.on('click', (event) => {
                    if ($(event.target).closest('[data-quickshop-popup]').length === 0 && $(event.target).closest('.variants-popup').length === 0 && $(event.target).closest('.card-swatch').length === 0 && $(event.target).closest('[data-warning-popup]').length === 0) {
                        $('.product-item').removeClass('quickshop-popup-show');
                        if($body.hasClass('quick_shop_option_2')){
                            $body.removeClass('quick_shop_popup_mobile');
                        }
                    }
                });

                halo.changeSwatchQuickShop();
            }
        },
  
        appendToListViewModal: function(product)  {
            const quickshopMobilePopup = $doc.find('#list-view-popup');
            const quickshopForm = product.clone();
            quickshopMobilePopup.find('.halo-popup-content').empty();
            quickshopMobilePopup.find('.halo-popup-content').append(quickshopForm);

            const form = quickshopMobilePopup.find('[data-quickshop] .card-information .variants-popup form').eq('0');
            const mobilePopupId = form.attr('id') + '-mobile';
            const optionInputs = form.find('.single-option');
            const optionLabels = form.find('.single-label');
            const cardInfoWrapper = quickshopMobilePopup.find('.card-product')
            const variantsPopup = quickshopMobilePopup.find('.variants-popup')
            const submitBtn = quickshopMobilePopup.find('[data-btn-addtocart]')
            variantsPopup.removeClass("card-list__hidden")
            let clicked = {
                selected1: false,
                selected2: false,
                selected3: false
            } 

            form.attr('id', mobilePopupId);
            submitBtn.attr('data-form-id', submitBtn.attr('data-form-id') + '-mobile')

            optionInputs.each((index, optionInput) => {
                $(optionInput).attr('id', $(optionInput).attr('id') + '-mobile');
                $(optionInput).attr('name', $(optionInput).attr('name') + '-mobile');
            })

            optionLabels.each((index, optionLabel) => {
                $(optionLabel).attr('for', $(optionLabel).attr('for') + '-mobile');

                const swatchWrapper = $(optionLabel).closest('.selector-wrapper')
                const swatchElement = $(optionLabel).closest('.swatch-element')
                if (!swatchElement.hasClass('available')) return 
                
                if (swatchWrapper.hasClass('selector-wrapper-1') && !clicked.selected1) {
                    clicked.selected1 = true
                    $(optionLabel).trigger('click')
                } else if (swatchWrapper.hasClass('selector-wrapper-2') && !clicked.selected2) {
                    clicked.selected2 = true 
                    $(optionLabel).trigger('click')
                } else if (swatchWrapper.hasClass('selector-wrapper-3') && !clicked.selected3) {
                    clicked.selected3 = true
                    $(optionLabel).trigger('click')
                }
            })

            $body.addClass('quickshop-list-view-show');

            $('.background-overlay').off('click.closeListViewModal').on('click.closeListViewModal', () => {
                $body.removeClass('quickshop-list-view-show');
            })
        },

        changeSwatchQuickShop: function () {
            $doc.on('change', '[data-quickshop] .single-option', (event) => {
                var $target = $(event.target),
                    product = $target.parents('.product-item'),
                    productJson = product.data('json-product'),
                    productAction = product.find('[data-btn-addtocart]'),
                    variantList,
                    optionColor = product.find('.option-color').data('option-position'),
                    optionIndex = $target.closest('[data-option-index]').data('option-index'),
                    swatch = product.find('.swatch-element'),
                    thisVal = $target.val(),
                    selectedVariant,
                    productInput = product.find('[name=id]'),
                    selectedOption1 = product.find('.selector-wrapper-1').find('input:checked').val(),
                    selectedOption2 = product.find('.selector-wrapper-2').find('input:checked').val(),
                    selectedOption3 = product.find('.selector-wrapper-3').find('input:checked').val();

                let holidayModeElements = product.find(`.holiday-mode-wrapper`);
                
                let holidayModeWrapper;
                if(holidayModeElements.length > 0){
                  holidayModeWrapper = holidayModeElements[0];
                }

                if ($body.hasClass('quick_shop_option_2') && $('.productListing').hasClass('productList')) {
                    selectedOption1 = product.find('.selector-wrapper-1').eq('1').find('input:checked').val();
                } else {
                    if ($('.productListing').hasClass('productList') && $win.width() < 767) {
                        selectedOption1 = product.find('.selector-wrapper-1').eq('1').find('input:checked').val();
                        selectedOption2 = product.find('[data-option-index="1"]').eq('1').find('input:checked').val();
                    } else {
                        selectedOption1 = product.find('.selector-wrapper-1').eq('0').find('input:checked').val();
                    }
                }

                if (productJson != undefined) {
                    variantList = productJson.variants;
                }

                swatch.removeClass('soldout');
                swatch.find('input[type="radio"]').prop('disabled', false);

                switch (optionIndex) {
                    case 0:
                        var availableVariants = variantList.find((variant) => {
                            if (optionColor == 1) {
                                return variant.option2 == thisVal && variant.option1 == selectedOption2;
                            } else {
                                if (optionColor == 2) {
                                    return variant.option3 == thisVal && variant.option1 == selectedOption2;
                                } else {
                                    return variant.option1 == thisVal && variant.option2 == selectedOption2;
                                }
                            }
                        });

                        if(availableVariants != undefined){
                            selectedVariant =  availableVariants;
                        } else{
                            var altAvailableVariants = variantList.find((variant) => {
                                if (optionColor == 1) {
                                    return variant.option2 == thisVal;
                                } else {
                                    if (optionColor == 2) {
                                        return variant.option3 == thisVal;
                                    } else {
                                        return variant.option1 == thisVal;
                                    }
                                }
                            });

                            selectedVariant =  altAvailableVariants;
                        }

                        break;
                    case 1:
                        var availableVariants = variantList.find((variant) => {
                            if (optionColor == 1) {
                                return variant.option2 == selectedOption1 && variant.option1 == thisVal && variant.option3 == selectedOption2;
                            } else {
                                if (optionColor == 2) {
                                    return variant.option3 == selectedOption1 && variant.option1 == thisVal && variant.option2 == selectedOption2;
                                } else {
                                    return variant.option1 == selectedOption1 && variant.option2 == thisVal && variant.option3 == selectedOption2;
                                }
                            }
                        });

                        if(availableVariants != undefined){
                            selectedVariant =  availableVariants;
                        } else {
                            var altAvailableVariants = variantList.find((variant) => {
                                if (optionColor == 1) {
                                    return variant.option2 == selectedOption1 && variant.option1 == thisVal;
                                } else {
                                    if (optionColor == 2) {
                                        return variant.option3 == selectedOption1 && variant.option1 == thisVal;
                                    } else {
                                        return variant.option1 == selectedOption1 && variant.option2 == thisVal;
                                    }
                                }
                            });

                            selectedVariant =  altAvailableVariants;
                        }

                        break;
                    case 2:
                        var availableVariants = variantList.find((variant) => {
                            if (optionColor == 1) {
                                return variant.option2 == selectedOption1 && variant.option1 == selectedOption2 && variant.option3 == thisVal;
                            } else {
                                if (optionColor == 2) {
                                    return variant.option3 == selectedOption1 && variant.option1 == selectedOption2 && variant.option2 == thisVal;
                                } else {
                                    return variant.option1 == selectedOption1 && variant.option2 == selectedOption2 && variant.option3 == thisVal;
                                }
                            }
                        });

                        if(availableVariants != undefined){
                            selectedVariant =  availableVariants;
                        }

                        break;
                }
                            
                if (selectedVariant == undefined) {
                    return;
                }
                
                productInput.val(selectedVariant.id);
                var value = $target.val();
               

                
                $target.parents('.selector-wrapper').find('.form-label span').text(value);
                if (selectedVariant.available) {
                    product.find('[data-btn-addtocart]').removeClass('btn-unavailable');
                    product.find('[data-quickshop] quickshop-update-quantity').removeClass('disabled');
                    product.find('[data-btn-addtocart]').attr('data-available', 'true');
                    (holidayModeWrapper) ? holidayModeWrapper.style.display = "block" : null;
                      
                } else {
                    product.find('[data-btn-addtocart]').addClass('btn-unavailable');
                    product.find('[data-quickshop] quickshop-update-quantity').addClass('disabled');
                    product.find('[data-btn-addtocart]').attr('data-available', 'false');
                    (holidayModeWrapper) ? holidayModeWrapper.style.display = "none" : null;
                    
                }

                if (halo.checkNeedToConvertCurrency()) {
                    Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                };

                if (!$body.hasClass('quick_shop_option_2') && !$body.hasClass('quick_shop_option_3') && $win.width() < 767) {
                    
                } 

                halo.checkStatusSwatchQuickShop(product, productJson);
                halo.checkPreOrderOfVariant(selectedVariant, productAction, productJson);
            });
        },

        checkStatusSwatchQuickShop: function(product, productJson){
            var variantPopup = product.find('.card-variant'),
                variantList,
                productOption = product.find('[data-option-index]'),
                optionColor = product.find('.option-color').data('option-position'),
                selectedOption1 = product.find('[data-option-index="0"]').find('input:checked').val(),
                selectedOption2 = product.find('[data-option-index="1"]').find('input:checked').val(),
                selectedOption3 = product.find('[data-option-index="2"]').find('input:checked').val(),
                productId = product.data('product-id');

            
            if ($body.hasClass('quick_shop_option_2')) {
                var height = product.find('.card-media').outerHeight(true);
                if (selectedOption3 != undefined) {
                    if ($body.hasClass('product-card-layout-01')) {
                        if (height < 310) {
                            $('[data-quickshop]').addClass('active_option_3');
                        } else {
                            $('[data-quickshop]').removeClass('active_option_3');
                        }  
                    } else {
                        if (height < 370) {
                            $('[data-quickshop]').addClass('active_option_3');
                        } else {
                            $('[data-quickshop]').removeClass('active_option_3');
                        } 
                    }
                } else {
                    if ($win.width() > 1024) {
                        if ($body.hasClass('product-card-layout-05')) {
                            if (height < 350 && selectedOption2 != undefined) {
                                $('[data-quickshop]').addClass('active_option_3');
                            } else {
                                $('[data-quickshop]').removeClass('active_option_3');
                            }    
                        } else if ($body.hasClass('product-card-layout-01')) {
                            if (height < 310 && selectedOption2 != undefined) {
                                $('[data-quickshop]').addClass('active_option_3');
                            } else {
                                $('[data-quickshop]').removeClass('active_option_3');
                            }  
                        }else {
                            if (height < 370 && selectedOption2 != undefined) {
                                $('[data-quickshop]').addClass('active_option_3');
                            } else {
                                $('[data-quickshop]').removeClass('active_option_3');
                            }   
                        }
                    } else {
                        if ($body.hasClass('product-card-layout-01')) {
                            if (height < 310) {
                                if (selectedOption1 != undefined || selectedOption2 != undefined) {
                                    $('[data-quickshop]').removeClass('active_option_3');
                                } else {
                                    $('[data-quickshop]').addClass('active_option_3');
                                }
                            } else {
                                $('[data-quickshop]').removeClass('active_option_3');
                            }   
                        } else {
                            if (height < 370) {
                                if (selectedOption1 != undefined || selectedOption2 != undefined) {
                                    $('[data-quickshop]').removeClass('active_option_3');
                                } else {
                                    $('[data-quickshop]').addClass('active_option_3');
                                }
                            } else {
                                $('[data-quickshop]').removeClass('active_option_3');
                            }   
                        }
                    }
                }
            }

            if ($body.hasClass('quick_shop_option_2') && $('.productListing').hasClass('productList')) {
                selectedOption1 = product.find('[data-option-index="0"]').eq('1').find('input:checked').val();
            } else {
                if ($('.productListing').hasClass('productList') && $win.width() < 767) {
                    selectedOption1 = product.find('[data-option-index="0"]').eq('1').find('input:checked').val();
                    selectedOption2 = product.find('[data-option-index="1"]').eq('1').find('input:checked').val();
                } else {
                    selectedOption1 = product.find('[data-option-index="0"]').eq('0').find('input:checked').val();
                }
            }
            
            if (productJson != undefined) {
                variantList = productJson.variants;
            }

            productOption.each((index, element) => {
                var optionIndex = $(element).data('option-index'),
                    swatch = $(element).find('.swatch-element');

                switch (optionIndex) {
                    case 0: 
                        swatch.each((idx, elt) => {
                            var item = $(elt),
                                swatchVal = item.data('value');

                            var optionSoldout = variantList.find((variant) => {
                                if (optionColor == 1) {
                                    return variant.option2 == swatchVal && variant.available;
                                } else {
                                    if (optionColor == 2) {
                                        return variant.option3 == swatchVal && variant.available;
                                    } else {
                                        return variant.option1 == swatchVal && variant.available;
                                    }
                                }
                            });

                            var optionUnavailable = variantList.find((variant) => {
                                if (optionColor == 1) {
                                    return variant.option2 == swatchVal;
                                } else {
                                    if (optionColor == 2) {
                                        return variant.option3 == swatchVal;
                                    } else {
                                        return variant.option1 == swatchVal;
                                    }
                                }
                            });

                            if(optionSoldout == undefined){
                                if (optionUnavailable == undefined) {
                                    item.removeClass('soldout available').addClass('unavailable');
                                    item.find('input[type="radio"]').prop('checked', false);
                                } else {
                                    item
                                        .removeClass('unavailable available')
                                        .addClass('soldout')
                                        .find('.single-action')
                                        .attr('data-variant-id', optionUnavailable.title);
                                    item.find('input[type="radio"]').prop('disabled', false);
                                }
                            } else {
                                item.removeClass('soldout unavailable').addClass('available');
                                item.find('input[type="radio"]').prop('disabled', false);
                            }
                        });

                        break;
                    case 1:
                        swatch.each((idx, elt) => {
                            var item = $(elt),
                                swatchVal = item.data('value');

                            var optionSoldout = variantList.find((variant) => {
                                if (optionColor == 1) {
                                    return variant.option2 == selectedOption1 && variant.option1 == swatchVal && variant.available;
                                } else {
                                    if (optionColor == 2) {
                                        return variant.option3 == selectedOption1 && variant.option1 == swatchVal && variant.available;
                                    } else {
                                        return variant.option1 == selectedOption1 && variant.option2 == swatchVal && variant.available;
                                    }
                                }
                            });

                            var optionUnavailable = variantList.find((variant) => {
                                if (optionColor == 1) {
                                    return variant.option2 == selectedOption1 && variant.option1 == swatchVal;
                                } else {
                                    if (optionColor == 2) {
                                        return variant.option3 == selectedOption1 && variant.option1 == swatchVal;
                                    } else {
                                        // CHECK: find the error and value of selectedOption1 
                                        return variant.option1 == selectedOption1 && variant.option2 == swatchVal;
                                    }
                                }
                            });

                            if(optionSoldout == undefined){
                                if (optionUnavailable == undefined) {
                                    item.removeClass('soldout available').addClass('unavailable');
                                    item.find('input[type="radio"]').prop('checked', false);
                                } else {
                                    item
                                        .removeClass('unavailable available')
                                        .addClass('soldout')
                                        .find('.single-action-selector')
                                        .attr('data-variant-id', optionUnavailable.title);
                                    item.find('input[type="radio"]').prop('disabled', false);
                                }
                            } else {
                                item.removeClass('soldout unavailable').addClass('available');
                                item.find('input[type="radio"]').prop('disabled', false);
                            }
                            
                        });
                        break;
                    case 2:
                        swatch.each((idx, elt) => {
                            var item = $(elt),
                                swatchVal = item.data('value');

                            var optionSoldout = variantList.find((variant) => {
                                if (optionColor == 1) {
                                    return variant.option2 == selectedOption1 && variant.option1 == selectedOption2 && variant.option3 == swatchVal && variant.available;
                                } else {
                                    if (optionColor == 2) {
                                        return variant.option3 == selectedOption1 && variant.option1 == selectedOption2 && variant.option2 == swatchVal && variant.available;
                                    } else {
                                        return variant.option1 == selectedOption1 && variant.option2 == selectedOption2 && variant.option3 == swatchVal && variant.available;
                                    }
                                }
                            });

                            var optionUnavailable = variantList.find((variant) => {
                                if (optionColor == 1) {
                                    return variant.option2 == selectedOption1 && variant.option1 == selectedOption2 && variant.option3 == swatchVal;
                                } else {
                                    if (optionColor == 2) {
                                        return variant.option3 == selectedOption1 && variant.option1 == selectedOption2 && variant.option2 == swatchVal;
                                    } else {
                                        return variant.option1 == selectedOption1 && variant.option2 == selectedOption2 && variant.option3 == swatchVal;
                                    }
                                }
                            });

                            if(optionSoldout == undefined){
                                if (optionUnavailable == undefined) {
                                    item.removeClass('soldout available').addClass('unavailable');
                                    item.find('input[type="radio"]').prop('checked', false);
                                } else {
                                    item
                                        .removeClass('unavailable available')
                                        .addClass('soldout')
                                        .find('.single-action-selector')
                                        .attr('data-variant-id', optionUnavailable.title);
                                    item.find('input[type="radio"]').prop('disabled', false);
                                }
                            } else {
                                item.removeClass('unavailable soldout').addClass('available');
                                item.find('input[type="radio"]').prop('disabled', false);
                            }
                        });

                        break;  
                }
            });

            variantPopup.find('.selector-wrapper:not(.option-color)').each((index, element) => {
                var item = $(element);

                if (item.find('.swatch-element').find('input:checked').length < 1) {
                    if (item.find('.swatch-element.available').length > 0) {
                        item.find('.swatch-element.available').eq('0').find('.single-label').trigger('click');
                    } else {
                        item.find('.swatch-element.soldout').eq('0').find('.single-label').trigger('click');
                    }
                }
            });

  
            if ($body.hasClass('quick_shop_option_2')) {
                var variantId = product.find('[data-quickshop]').eq(1).find('[name="id"]').val();
                var arrayInVarName = `quick_view_inven_array_${productId}`,
                    inven_array = window[arrayInVarName]; 
                  
                if(inven_array != undefined) {
                    var inven_num = inven_array[variantId],
                        inventoryQuantity = parseInt(inven_num),
                        quantityInput = product.find('input[name="quantity"]').eq(0);
                    
                    quantityInput.attr('data-inventory-quantity', inventoryQuantity);
                    if (quantityInput.val() > inventoryQuantity) {
                        if (inventoryQuantity > 0) {
                            quantityInput.val(inventoryQuantity)
                        } else {
                            quantityInput.val(1)
                        }
                    }
                }
            }
        },

    //    updateExclusiveProduct: function() {
    //       let debounce;
    //       $('#exclusive-product').off('change').on('change', (event) => {
    //           event.stopPropagation();
    //           event.preventDefault();
    //           clearTimeout(debounce);
      
    //           debounce = setTimeout(() => {
    //               const variantId = event.target.dataset.variantId;
      
    //               if (event.target.checked) {
    //                 console.log('variantId exclusive checked', variantId);
    //                   Shopify.addItem(variantId, 1, () => {
    //                       Shopify.getCart((cart) => {
    //                           halo.updateSidebarCart(cart);
    //                           halo.updateCart(cart);
    //                       });
    //                   });
    //               } else {
    //                 console.log('variantId exclusive unchecked', variantId);
    //                   Shopify.removeItem(variantId, () => {
    //                       Shopify.getCart((cart) => {
    //                           halo.updateSidebarCart(cart);
    //                           halo.updateCart(cart);
    //                       });
    //                   });
    //               }
    //           }, 10);
    //       });
    //   },

    //   checkExclusiveProductInCart: function() {
    //         const exclusiveCheckbox = $('#exclusive-product');
    //         const variantId = exclusiveCheckbox.data('variant-id'); 
    //         const popupVariantIdHidden = $('#exclusive-product');
    //         const popupVariantId = popupVariantIdHidden.data('variant-id'); 
    //         const addButton = document.querySelector('.gde-ex-add-btn');
    //         Shopify.getCart((cart) => {
    //             let isExclusiveProductInCart = false;
    //             cart.items.forEach((item) => {
    //                 if (item.variant_id == variantId || item.variant_id == popupVariantId) {
    //                     isExclusiveProductInCart = true;
    //                 }
    //             });
    //             exclusiveCheckbox.prop('checked', isExclusiveProductInCart);
    //             if (isExclusiveProductInCart) {
    //                   const subscriptionMessageElement = document.querySelector('.subscription-message');
    //                   if (subscriptionMessageElement) {
    //                       subscriptionMessageElement.textContent = 'You can add 1 subscription only';
    //                   }
    //                 //   if($('.register-note')){
    //                 //     $('.register-note').hide();
    //                 //   }
    //                   if($('.exclusive-product-wrapper')){
    //                     $('.exclusive-product-wrapper').hide();
    //                   }
    //               } else {
                      
    //                   const subscriptionMessageElement = document.querySelector('.subscription-message');
    //                   if (subscriptionMessageElement) {
    //                       subscriptionMessageElement.textContent = '';
    //                   }
    //                 // if($('.register-note')){
    //                 //      $('.register-note').show();
    //                 //   }
    //                 if($('.exclusive-product-wrapper')){
    //                     $('.exclusive-product-wrapper').show();
    //                   }
    //               }
    //             if (addButton) {                  
    //                 if (isExclusiveProductInCart) {
    //                     addButton.setAttribute('disabled', 'disabled');
    //                     const subscriptionMessageElement = document.querySelector('.subscription-message');
    //                     if (subscriptionMessageElement) {
    //                         subscriptionMessageElement.textContent = 'You can add 1 subscription only';
    //                     }
    //                     // if($('.register-note')){
    //                     //   $('.register-note').hide();
    //                     // }
    //                     if($('.exclusive-product-wrapper')){
    //                       $('.exclusive-product-wrapper').hide();
    //                     }
    //                 } else {
    //                     addButton.removeAttribute('disabled');
    //                     const subscriptionMessageElement = document.querySelector('.subscription-message');
    //                     if (subscriptionMessageElement) {
    //                         subscriptionMessageElement.textContent = '';
    //                     }
    //                 //   if($('.register-note')){
    //                 //        $('.register-note').show();
    //                 //     }
    //                   if($('.exclusive-product-wrapper')){
    //                       $('.exclusive-product-wrapper').show();
    //                     }
    //                 }
    //             }
    //       });
    //       //close the popup
    //       const modalCloseBtn = document.getElementById('single_add_modal-close');
    //       if (modalCloseBtn){
    //         document.getElementById('single_add_modal-close').addEventListener('click', function() {
    //            if(document.getElementById('single_btn_add_modal_wrapper')){
    //               document.getElementById('single_btn_add_modal_wrapper').classList.remove('show');
    //             }
    //             document.body.classList.remove('modal-open');
    //         });
    //       }
    //       //redirect to same page after login
    //       const loginLink = document.querySelector('.nonloginlink');
    //       if (loginLink) {
    //           const currentPath = window.location.pathname;
    //           const redirectUrl = `/account/login?checkout_url=${encodeURIComponent(currentPath)}`;
    //           loginLink.setAttribute('href', redirectUrl);
    //       }
        
    //       halo.checkExclusiveProductEligibility();
    //     },
      
    //    checkExclusiveProductEligibility: function() {
    //         var body = document.body; 
    //         var countryCode = body.getAttribute('data-country-code');
    //         const exclusiveProductWrapper = document.querySelector('.exclusive-product-wrapper');
    //         const pageCountryMessage = document.querySelector('.country-message');
    //         const pageBtnWrapper = document.querySelector('.single_btn_add_btn_wrapper');
    //         const singleBtn = document.querySelector('.single_btn_add');
    //         const singleBtnMessage = document.querySelector('.single_btn_add_message');
    //         const gdLoader = singleBtnMessage ? singleBtnMessage.querySelector('.gdloader') : null;
    //         let message;
    //          if (window.customerVIP){
    //             message = `<p>Your subscription is already active. Enjoy exclusive benefits!</p>`
    //          }else{
    //             message =`<p>Goddiva Exclusive shipping isn’t available at your location.</p>`
    //          }

    //         // Helper: Hide elements + show message
    //         const disableExclusiveContent = () => {
    //             if (exclusiveProductWrapper) exclusiveProductWrapper.style.display = 'none';
    //             if (pageCountryMessage) {
    //             pageCountryMessage.innerHTML = message;
    //             }
    //             if (pageBtnWrapper) pageBtnWrapper.style.display = 'none';
    //             if (singleBtn) singleBtn.style.display = 'none';
    //             if (singleBtnMessage) {
    //             singleBtnMessage.innerHTML = message;
    //             }
    //             $('.register-note').hide();
    //         };

    //         // Helper: Show button after eligibility check
    //         const enableExclusiveContent = () => {
    //             if (gdLoader) gdLoader.remove(); // remove loader
    //             if (singleBtn) singleBtn.style.display = 'block';
    //             if (singleBtnMessage) singleBtnMessage.innerHTML = ''; // clear message area
    //             $('.exclusive-product-wrapper-for-cart').removeClass('hidden');
    //             $('.register-note').show();
    //         };

    //         if (window.customerVIP){
    //             disableExclusiveContent();
    //             return;
    //         }

    //         // Case 1: User country code is known (via body attribute)
    //         if (countryCode) {
    //             if (countryCode !== 'GB') {
    //             disableExclusiveContent();
    //             body.classList.add('usingaddress');
    //             } else {
    //             enableExclusiveContent();
    //             }
    //         } 
    //         // Case 2: No country code available → fetch from IP API
    //         else {
    //             fetch('https://pro.ip-api.com/json/?key=XjCy8wkn8k9YuLG&fields=status,country,countryCode')
    //             .then(response => response.json())
    //             .then(data => {
    //                 if (data.status === 'success') {
    //                 if (data.countryCode !== 'GB') {
    //                     disableExclusiveContent();
    //                 } else {
    //                     enableExclusiveContent();
    //                 }
    //                 body.classList.add('usingip');
    //                 } else {
    //                 console.error('Country lookup failed');
    //                 }
    //             })
    //             .catch(error => {
    //                 console.error('Error fetching country code:', error);
    //             });
    //         }
    //     },
      

updateExclusiveProduct: function() {
            let debounce;
            $('#exclusive-product').off('change').on('change', (event) => {
                event.stopPropagation();
                event.preventDefault();
                clearTimeout(debounce);

                debounce = setTimeout(() => {
                const variantId = event.target.dataset.variantId;

                if (event.target.checked) {
                    console.log('variantId exclusive checked', variantId);
                    Shopify.addItem(variantId, 1, () => {
                    Shopify.getCart((cart) => {
                        halo.updateSidebarCart(cart);
                        halo.updateCart(cart);
                        halo.checkExclusiveProductInCart();
                    });
                    });
                } else {
                    console.log('variantId exclusive unchecked', variantId);
                    Shopify.removeItem(variantId, () => {
                    Shopify.getCart((cart) => {
                        halo.updateSidebarCart(cart);
                        halo.updateCart(cart);
                        halo.checkExclusiveProductInCart();
                    });
                    });
                }
                }, 10);
            });
            },

        checkExclusiveProductInCart: function() {
            const exclusiveCheckbox = $('#exclusive-product');
            const variantId = exclusiveCheckbox.data('variant-id'); 
            const popupVariantIdHidden = $('#exclusive-product');
            const popupVariantId = popupVariantIdHidden.data('variant-id'); 
            const addButton = document.querySelector('.gde-ex-add-btn');

            Shopify.getCart((cart) => {
                let isExclusiveProductInCart = false;

                cart.items.forEach((item) => {
                if (item.variant_id == window.gdUnlimitedId || item.variant_id == window.gdUnlimitedId) {
                    isExclusiveProductInCart = true;
                }
                });
               ;

                // Sync checkbox state
                if (exclusiveCheckbox.length) {
                exclusiveCheckbox.prop('checked', isExclusiveProductInCart);
                }

                if (isExclusiveProductInCart) {
                // Unlimited product IS in cart
                $('.register-note').hide();                // requirement 3: do NOT show note
                $('.exclusive-product-wrapper').hide();    // hide checkbox area

                const subscriptionMessageElement = document.querySelector('.subscription-message');
                if (subscriptionMessageElement) {
                    subscriptionMessageElement.textContent = 'You can add 1 subscription only.';
                }

                if (addButton) {
                    addButton.setAttribute('disabled', 'disabled');
                }
                } else {
                // Unlimited product is NOT in cart
                $('.register-note').show();               // requirement 3: show note
                $('.exclusive-product-wrapper').show();   // show checkbox

                const subscriptionMessageElement = document.querySelector('.subscription-message');
                if (subscriptionMessageElement) {
                    subscriptionMessageElement.textContent = '';
                }

                if (addButton) {
                    addButton.removeAttribute('disabled');
                }
                }
            });

            // close the popup
            const modalCloseBtn = document.getElementById('single_add_modal-close');
            if (modalCloseBtn){
                modalCloseBtn.addEventListener('click', function() {
                const modal = document.getElementById('single_btn_add_modal_wrapper');
                if (modal) modal.classList.remove('show');
                document.body.classList.remove('modal-open');
                });
            }

            // redirect to same page after login
            const loginLink = document.querySelector('.nonloginlink');
            if (loginLink) {
                const currentPath = window.location.pathname;
                const redirectUrl = `/account/login?checkout_url=${encodeURIComponent(currentPath)}`;
                loginLink.setAttribute('href', redirectUrl);
            }

            halo.checkExclusiveProductEligibility();
        },

        checkExclusiveProductEligibility: function() {
            var body = document.body; 
            var countryCode = body.getAttribute('data-country-code');
            const exclusiveProductWrapper = document.querySelector('.exclusive-product-wrapper');
            const pageCountryMessage = document.querySelector('.country-message');
            const pageBtnWrapper = document.querySelector('.single_btn_add_btn_wrapper');
            const singleBtn = document.querySelector('.single_btn_add');
            const singleBtnMessage = document.querySelector('.single_btn_add_message');
            const gdLoader = singleBtnMessage ? singleBtnMessage.querySelector('.gdloader') : null;

            const VALID_VENDORS = [
                "Goddiva", "Goddiva Plus", "Cosmochic",
                "Danaya", "City Goddess", "Goddiva Denim",
                "Goddiva Accessories"
            ];

            // Helper: Hide elements + show country restriction message
            const disableExclusiveContent = () => {
                if (exclusiveProductWrapper) exclusiveProductWrapper.style.display = 'none';
                if (pageCountryMessage) {
                pageCountryMessage.innerHTML = `<p>Goddiva Exclusive shipping isn’t available at your location</p>`;
                }
                if (pageBtnWrapper) pageBtnWrapper.style.display = 'none';
                if (singleBtn) singleBtn.style.display = 'none';
                if (singleBtnMessage) {
                singleBtnMessage.innerHTML = `<p>You're already a VIP customer — get a whole host of other exclusive benetits as an Unlimited Member.</p>`;
                }
                $('.register-note').hide(); // for non-GB, never show the note
            };

            // Helper: Show button after eligibility check (do NOT touch register-note here)
            const enableExclusiveContent = () => {
                if (gdLoader) gdLoader.remove(); // remove loader
                if (singleBtn) singleBtn.style.display = 'block';
                if (singleBtnMessage) singleBtnMessage.innerHTML = ''; // clear message area
                $('.exclusive-product-wrapper-for-cart').removeClass('hidden');
                // .register-note will be controlled by checkExclusiveProductInCart based on whether Unlimited is in cart
            };

            if (window.customerVIP){
                disableExclusiveContent();
                return;
            }
            
            // 1) VIP customers: Unlimited disabled everywhere
            if (body.classList.contains('is-vip-customer')) {
                if (exclusiveProductWrapper) exclusiveProductWrapper.style.display = 'none';
                $('.exclusive-product-wrapper-for-cart').hide();
                $('.register-note').hide();

                if (pageBtnWrapper) pageBtnWrapper.style.display = 'none';
                if (singleBtn) singleBtn.style.display = 'none';

                const vipMsg = `<p>You're already a VIP customer — get a whole host of other exclusive benetits as an Unlimited Member.</p>`;
                if (singleBtnMessage) singleBtnMessage.innerHTML = vipMsg;
                if (pageCountryMessage) pageCountryMessage.innerHTML = vipMsg;

                $('.gde-ex-add-btn').attr('disabled', true);
                return; // stop, do not run any further checks
            }

            // 2) Check cart vendors first
            Shopify.getCart((cart) => {
                const hasValidVendor = cart.items.some(item => VALID_VENDORS.includes(item.vendor));

                if (!hasValidVendor) {
                // No supported vendor → hide Unlimited everywhere
                if (exclusiveProductWrapper) exclusiveProductWrapper.style.display = 'none';
                $('.exclusive-product-wrapper-for-cart').hide();
                $('.register-note').hide();

                const msg = `<p>Unlimited subscription is available only for Goddiva brand items.</p>`;
                if (singleBtnMessage) singleBtnMessage.innerHTML = msg;
                if (pageCountryMessage) pageCountryMessage.innerHTML = msg;

                if (pageBtnWrapper) pageBtnWrapper.style.display = 'none';
                if (singleBtn) singleBtn.style.display = 'none';

                $('.gde-ex-add-btn').attr('disabled', true);
                return; // stop here
                }

                // 3) Vendor OK → proceed with original country logic

                // Case 1: User country code is known (via body attribute)
                if (countryCode) {
                if (countryCode !== 'GB') {
                    disableExclusiveContent();
                    body.classList.add('usingaddress');
                } else {
                    enableExclusiveContent();
                }
                } 
                // Case 2: No country code available → fetch from IP API
                else {
                fetch('https://pro.ip-api.com/json/?key=XjCy8wkn8k9YuLG&fields=status,country,countryCode')
                    .then(response => response.json())
                    .then(data => {
                    if (data.status === 'success') {
                        if (data.countryCode !== 'GB') {
                        disableExclusiveContent();
                        } else {
                        enableExclusiveContent();
                        }
                        body.classList.add('usingip');
                    } else {
                        console.error('Country lookup failed');
                    }
                    })
                    .catch(error => {
                    console.error('Error fetching country code:', error);
                    });
                }
            });
         },


        initAddToCartQuickShop: function($target, popup){
            var variantId = popup.find('[name="id"]').val(),
                qty = 1;

            halo.actionAddToCart($target, variantId, qty);
            
        },

        initAddToCart: function() {
            $doc.off('click.addToCart').on('click.addToCart', '[data-btn-addtocart]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var $target = $(event.target),
                    product = $target.parents('.product-item'),
                    MobilePopup_Option_2 = $doc.find('#halo-card-mobile-popup'),
                    ProductQuickShopShown_Option_2 = $doc.find('.quickshop-popup-show');

                if($target.closest('product-form').length > 0){
                    var productForm = $target.closest('form');
                    
                    halo.actionAddToCart2($target, productForm);
                } else {
                    if(!$target.hasClass('is-notify-me') && !$target.hasClass('is-soldout')){
                        var form = $target.parents('form'),
                            variantId = form.find('[name="id"]').val(),
                            qty = form.find('[name="quantity"]').val();
                            input = form.find('[name="quantity"]').eq(0);
                        if(qty == undefined){
                            qty = 1;
                        }
                          
                        halo.actionAddToCart($target, variantId, qty, input);
                    
                    } else if($target.hasClass('is-notify-me')){
                        halo.notifyInStockPopup($target);
                    }
                }
            });
            
            $doc.on('click', '[data-close-add-to-cart-popup]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                $body.removeClass('add-to-cart-show');
            });


            $doc.on('click', (event) => {
                if($body.hasClass('add-to-cart-show')){
                    if (($(event.target).closest('[data-add-to-cart-popup]').length === 0)) {
                        $body.removeClass('add-to-cart-show');
                    }
                }
            });
        },

        // actionAddToCart: function($target, variantId, qty, input){
        //     var originalMessage = window.variantStrings.submit,
        //         waitMessage = window.variantStrings.addingToCart,
        //         successMessage = window.variantStrings.addedToCart;
            
        //     if($target.hasClass('button-text-change')){
        //         originalMessage = $target.text();
        //     }

        //     $target.addClass('is-loading');

        //     if($body.hasClass('quick-view-show')){
        //         Shopify.addItem(variantId, qty, () => {
        //             // $target.text(successMessage);
        //             if (window.after_add_to_cart.type == 'cart') {
        //                 halo.redirectTo(window.routes.cart);
        //             } else {
        //                 Shopify.getCart((cartTotal) => {
        //                     $body.addClass('cart-sidebar-show');
        //                    $body.removeClass('similar_items_added');
        //                     halo.updateSidebarCart(cartTotal);
        //                     $body.find('[data-cart-count]').text(cartTotal.item_count);
        //                     $target.removeClass('is-loading');
        //                 });
        //             }
        //         }, input);
        //     } else {
        //         Shopify.addItem(variantId, qty, () => {
        //             // $target.text(successMessage);
        //             $target.removeClass('is-loading');
        //             if ($body.hasClass('quickshop-popup-show') && $body.hasClass('quick_shop_option_3')) {
        //                 $body.removeClass('quickshop-popup-show');
                        
        //                 $('.quickshop-popup-show').removeClass('quickshop-popup-show');
        //             }

        //             if ($body.hasClass('quickshop-list-view-show')) {
        //                 $body.removeClass('quickshop-list-view-show')
        //             }

        //             if ($body.hasClass('show-mobile-options')) {
        //                 $body.removeClass('show-mobile-options');
        //                 $('.background-overlay').addClass('hold');
        //             }

        //             if ($body.hasClass('quick_shop_popup_mobile') && $body.hasClass('quick_shop_option_2')) {
        //                 // setTimeout(() => {
        //                     $body.removeClass('quick_shop_popup_mobile');
        //                     $doc.find('#halo-card-mobile-popup').removeClass('show');
        //                     $doc.find('.quickshop-popup-show').each((index, popup) => {
        //                         $(popup).removeClass('quickshop-popup-show');
        //                     })
        //                 // }, 200);
        //             }

        //             switch (window.after_add_to_cart.type) {
        //                 case 'cart':
        //                     halo.redirectTo(window.routes.cart);

        //                     break;
        //                 case 'quick_cart':
        //                      if(window.quick_cart.show){
        //                         Shopify.getCart((cart) => {
        //                             if( window.quick_cart.type == 'popup'){
        //                                 // $body.addClass('cart-modal-show');
        //                                 // halo.updateDropdownCart(cart);
        //                             } else {
        //                                 if($body.hasClass('template-cart')){
        //                                   halo.updateCart(cart);
        //                                   halo.giftBagForGoddiva();
        //                                 } else {
        //                                   $body.addClass('cart-sidebar-show');
        //                                   $body.removeClass('similar_items_added');
        //                                   halo.updateSidebarCart(cart);
        //                                   halo.giftBagForGoddiva();
        //                                 }
        //                             }

        //                             $target.removeClass('is-loading');
        //                             $('.background-overlay').removeClass('hold');
        //                         });
        //                     } else {
        //                         halo.redirectTo(window.routes.cart);
        //                     }
        //                     break;
        //                 case 'popup_cart_1':
        //                     Shopify.getCart((cart) => {
        //                         halo.updatePopupCart(cart, 1, variantId);
        //                         halo.updateSidebarCart(cart);
        //                         $body.addClass('add-to-cart-show');
        //                         $target.removeClass('is-loading');
        //                         $('.background-overlay').removeClass('hold');
        //                     });

        //                     break;
        //             }
        //         }, input);
        //     }
        // },
      
        // actionAddToCart2: function($target, productForm) {
        //     const config = fetchConfig('javascript');
        //     var originalMessage = window.variantStrings.submit,
        //         waitMessage = window.variantStrings.addingToCart,
        //         successMessage = window.variantStrings.addedToCart;
            
        //     if($target.hasClass('button-text-change')){
        //         originalMessage = $target.text();
        //     }

        //     $target.addClass('is-loading');

        //     let addToCartForm = document.querySelector('[data-type="add-to-cart-form"]');
        //     let formData = new FormData(addToCartForm);

        //     const properties = document.querySelectorAll('input[name^="properties"]')

        //     properties.forEach(property => {
        //       if (property.value == null) return;
        //         if (property.type == 'file') {
        //           formData.append(property.name, property.files[0])
        //         } else {
        //           formData.append(property.name, property.value)
        //         }
        //     })

        //     const enoughInStock = halo.checkSufficientStock(productForm);
        //     if (!enoughInStock && $body.hasClass('quickshop-popup-show')) {
        //         alert(window.cartStrings.addProductOutQuantity);
        //         $target.removeClass('is-loading');
        //         return 
        //     }

        //     const addItemToCart = (variantId) => {
        //         fetch(window.Shopify.routes.root + 'cart/add.js', {
        //             method: 'POST',
        //             body: formData
        //         })
        //         .then(response => {
        //             return response.json();
        //         })
        //         .catch((error) => {
        //             console.error('Error:', error);
        //         })
        //         .finally(() => {
        //             if ($body.hasClass('quickshop-popup-show')) {
        //                 $body.removeClass('quickshop-popup-show');
        //             }
    
        //             if($body.hasClass('quick-view-show')){
        //                 if (window.after_add_to_cart.type == 'cart') {
        //                     halo.redirectTo(window.routes.cart);
        //                 } else {
        //                     Shopify.getCart((cartTotal) => {
        //                         $body.find('[data-cart-count]').text(cartTotal.item_count);
        //                         $target.removeClass('is-loading');
        //                     });
        //                 }
        //             } else {
        //                 switch (window.after_add_to_cart.type) {
        //                     case 'cart':
        //                         halo.redirectTo(window.routes.cart);
                            
        //                         break;
        //                     case 'quick_cart':
        //                         if(window.quick_cart.show){
        //                             Shopify.getCart((cart) => {
        //                                 if( window.quick_cart.type == 'popup'){
        //                                     // $body.addClass('cart-modal-show');
        //                                     // halo.updateDropdownCart(cart);
        //                                 } else {
        //                                     $body.addClass('cart-sidebar-show');
        //                                    $body.removeClass('similar_items_added');
        //                                     halo.updateSidebarCart(cart);
        //                                 }
                                        
        //                                 $target.removeClass('is-loading');
        //                             });
        //                         } else {
        //                             halo.redirectTo(window.routes.cart);
        //                         }
                                
        //                         break;
        //                     case 'popup_cart_1':
        //                         Shopify.getCart((cart) => {
        //                             halo.updatePopupCart(cart, 1, variantId);
        //                             halo.updateSidebarCart(cart);
        //                             $body.addClass('add-to-cart-show');
        //                             $target.removeClass('is-loading');
        //                         });
    
        //                         break;
        //                 }
        //             }
        //         });
        //     }

        //     fetch(window.Shopify.routes.root + 'cart.js', {
        //         method: 'GET',
        //     })
        //     .then(response => {
        //         return response.json();
        //     }).then(response => { 
        //         const variantId = parseInt($(addToCartForm).serialize().split('id=')[1])
        //         const item = response.items.find(item => item.variant_id == variantId)
        //         const currentQuantity = item?.quantity 
        //         const currentProductId = item?.product_id
        //         const moreQuantity = parseInt(productForm.find('[data-inventory-quantity]').val()) 
        //         const maxQuantity = parseInt(productForm.find('[data-inventory-quantity]').data('inventory-quantity'))
        //         const saleOutStock = document.getElementById('product-add-to-cart').dataset.available === 'true' | false

        //         halo.giftBagForGoddiva();

        //         if (!currentQuantity || !maxQuantity || saleOutStock) return addItemToCart(variantId)
        //         var arrayInVarName = `selling_array_${currentProductId}`,
        //         itemInArray = window[arrayInVarName],
        //         itemStatus = itemInArray[variantId];
        //         if(itemStatus == 'deny') {
        //           if (currentQuantity + moreQuantity > maxQuantity)  {
        //               const remainingQuantity = maxQuantity - currentQuantity 
        //               throw new Error(`You ${remainingQuantity > 0 ? `can only add ${remainingQuantity}` : 'cannot add'} more of the items into the cart`)
        //           } else {
        //               addItemToCart(variantId);
        //           }
        //         } else {
        //           addItemToCart(variantId);
        //         }
        //     }).catch(err => {
        //         this.showWarning(err)
        //     }).finally(() => {
        //         $target.removeClass('is-loading');
        //     })
        // },

        // checkSufficientStock: function(productForm) {
        //     const maxValidQuantity = productForm.find('[data-inventory-quantity]').data('inventory-quantity')
        //     const inputQuantity = parseInt(productForm.find('[data-inventory-quantity]').val())
            
        //     return maxValidQuantity >= inputQuantity
        // },  


        // commented old addtocartaction and addtocartaction and create new for SUP-489
        showDisclaimerPopup: function(onAgree, onDecline) {
           
            // Prevent duplicate popups
            if ($('#gd-disclaimer-popup').length) return;

            const popup = `
            <div id="gd-disclaimer-popup" style="
                position:fixed; inset:0; background:rgba(0,0,0,0.55);
                z-index:99999; display:flex; align-items:center; justify-content:center;
            ">
                <div style="
                    background:#fff; border-radius:8px; padding:32px 28px 24px;
                    max-width:480px; width:90%; position:relative;
                    box-shadow:0 8px 32px rgba(0,0,0,0.18); text-align:center;
                ">
                    <button id="gd-disclaimer-close" aria-label="Close" style="
                        position:absolute; top:12px; right:14px; background:none;
                        border:none; cursor:pointer; font-size:22px; color:#555;
                    ">&times;</button>

                    <h2 style="margin:0 0 14px; font-size:18px;">Please Note</h2>
                    <p style="margin:0 0 24px; color:#555; font-size:14px; line-height:1.6;">
                        Due to the nature of the fabric and hand embellishment, beads may leave
                        small holes in the fabric. This is a natural characteristic and not
                        considered a defect.
                    </p>

                    <div style="display:flex; gap:12px; justify-content:center; flex-wrap:wrap;">
                        <button id="gd-disclaimer-agree" style="
                            background:#000; color:#fff; border:none;
                            padding:12px 24px; border-radius:4px; cursor:pointer; font-size:14px;
                        ">Agree, and add to cart</button>

                        <button id="gd-disclaimer-decline" style="
                            background:#fff; color:#000; border:1px solid #000;
                            padding:12px 24px; border-radius:4px; cursor:pointer; font-size:14px;
                        ">It's not for me</button>
                    </div>
                </div>
            </div>`;

            $('body').append(popup);

            const closePopup = () => {
                $('#gd-disclaimer-popup').fadeOut(200, function() { $(this).remove(); });
            };

            // Agree → run onAgree callback
            $('#gd-disclaimer-agree').one('click', function() {
                closePopup();
                onAgree();
            });

            // Decline or close icon → run onDecline callback
            $('#gd-disclaimer-decline, #gd-disclaimer-close').one('click', function() {
                closePopup();
                onDecline();
            });

            // Backdrop click → also decline
            $('#gd-disclaimer-popup').on('click', function(e) {
                if ($(e.target).is('#gd-disclaimer-popup')) {
                    closePopup();
                    onDecline();
                }
            });
        },

        actionAddToCart: function($target, variantId, qty, input) {
            var sku = $target.closest('.product-item').data('product-sku') || '';
            var needsDisclaimer = sku === 'DR4782';

            if (needsDisclaimer) {
                halo.showDisclaimerPopup(
                    function() { halo._doAddToCart($target, variantId, qty, input); },
                    function() { $target.removeClass('is-loading'); }
                );
                return;
            }

            halo._doAddToCart($target, variantId, qty, input);
        },

        actionAddToCart2: function($target, productForm) {
            var needsDisclaimer = window.popupRequired === true;

            if (needsDisclaimer) {
                halo.showDisclaimerPopup(
                    function() { halo._doAddToCart2($target, productForm); },
                    function() { $target.removeClass('is-loading'); }
                );
                return;
            }

            halo._doAddToCart2($target, productForm);
        },


        _doAddToCart: function($target, variantId, qty, input) {
            var originalMessage = window.variantStrings.submit,
                waitMessage     = window.variantStrings.addingToCart,
                successMessage  = window.variantStrings.addedToCart;
               // console.log('quickshop add to cart');

            if ($target.hasClass('button-text-change')) {
                originalMessage = $target.text();
            }
            $target.addClass('is-loading');

            if ($body.hasClass('quick-view-show')) {
                Shopify.addItem(variantId, qty, (item) => {
                    oaiq("measure", "items_added", {
                        type: "contents",
                        amount: item.line_price,
                        currency: window.shop_currency,
                        contents: [{
                            id: item.variant_id ?? item.id,
                            name: item.product_title,
                            content_type: "product",
                            quantity: item.quantity,
                        }],
                    });
                    if (window.after_add_to_cart.type == 'cart') {
                        halo.redirectTo(window.routes.cart);
                    } else {
                        Shopify.getCart((cartTotal) => {
                            $body.addClass('cart-sidebar-show');
                            $body.removeClass('similar_items_added');
                            halo.updateSidebarCart(cartTotal);
                            $body.find('[data-cart-count]').text(cartTotal.item_count);
                            $target.removeClass('is-loading');
                        });
                    }
                }, input);
            } else {
                Shopify.addItem(variantId, qty, (item) => {
                    oaiq("measure", "items_added", {
                        type: "contents",
                        amount: item.line_price,
                        currency: window.shop_currency,
                        contents: [{
                            id: item.variant_id ?? item.id,
                            name: item.product_title,
                            content_type: "product",
                            quantity: item.quantity,
                        }],
                    });
                    $target.removeClass('is-loading');
                    if ($body.hasClass('quickshop-popup-show') && $body.hasClass('quick_shop_option_3')) {
                        $body.removeClass('quickshop-popup-show');
                        $('.quickshop-popup-show').removeClass('quickshop-popup-show');
                    }
                    if ($body.hasClass('quickshop-list-view-show')) {
                        $body.removeClass('quickshop-list-view-show');
                    }
                    if ($body.hasClass('show-mobile-options')) {
                        $body.removeClass('show-mobile-options');
                        $('.background-overlay').addClass('hold');
                    }
                    if ($body.hasClass('quick_shop_popup_mobile') && $body.hasClass('quick_shop_option_2')) {
                        $body.removeClass('quick_shop_popup_mobile');
                        $doc.find('#halo-card-mobile-popup').removeClass('show');
                        $doc.find('.quickshop-popup-show').each((index, popup) => {
                            $(popup).removeClass('quickshop-popup-show');
                        });
                    }
                    switch (window.after_add_to_cart.type) {
                        case 'cart':
                            halo.redirectTo(window.routes.cart);
                            break;
                        case 'quick_cart':
                            if (window.quick_cart.show) {
                                Shopify.getCart((cart) => {
                                    if (window.quick_cart.type == 'popup') {
                                        // reserved
                                    } else {
                                        if ($body.hasClass('template-cart')) {
                                            halo.updateCart(cart);
                                            halo.giftBagForGoddiva();
                                        } else {
                                            $body.addClass('cart-sidebar-show');
                                            $body.removeClass('similar_items_added');
                                            halo.updateSidebarCart(cart);
                                            halo.giftBagForGoddiva();
                                        }
                                    }
                                    $target.removeClass('is-loading');
                                    $('.background-overlay').removeClass('hold');
                                });
                            } else {
                                halo.redirectTo(window.routes.cart);
                            }
                            break;
                        case 'popup_cart_1':
                            Shopify.getCart((cart) => {
                                halo.updatePopupCart(cart, 1, variantId);
                                halo.updateSidebarCart(cart);
                                $body.addClass('add-to-cart-show');
                                $target.removeClass('is-loading');
                                $('.background-overlay').removeClass('hold');
                            });
                            break;
                    }
                }, input);
            }
        },

        _doAddToCart2: function($target, productForm) {
            var originalMessage = window.variantStrings.submit,
                waitMessage     = window.variantStrings.addingToCart,
                successMessage  = window.variantStrings.addedToCart;
                //console.log('product page add to cart');

            if ($target.hasClass('button-text-change')) {
                originalMessage = $target.text();
            }
            $target.addClass('is-loading');

            var addToCartForm = document.querySelector('[data-type="add-to-cart-form"]');
            var formData = new FormData(addToCartForm);
            var properties = document.querySelectorAll('input[name^="properties"]');
            properties.forEach(function(property) {
                if (property.value == null) return;
                if (property.type == 'file') {
                    formData.append(property.name, property.files[0]);
                } else {
                    formData.append(property.name, property.value);
                }
            });

            // Quickshop only
            var enoughInStock = halo.checkSufficientStock(productForm);
            if (!enoughInStock && $body.hasClass('quickshop-popup-show')) {
                alert(window.cartStrings.addProductOutQuantity);
                $target.removeClass('is-loading');
                return;
            }

            // ✅ Inventory source
            var productIdInput = document.querySelector('[name="product-id"]');
            var productId = productIdInput ? productIdInput.getAttribute('value') : null;
            var inventoryArray = productId ? window['product_inven_array_' + productId] : null;
            var addButton = document.getElementById('product-add-to-cart');
            var inventoryPolicy = addButton ? addButton.getAttribute('data-inventory-policy') : '';

            var addItemToCart = function(variantId) {
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    body: formData
                })
                .then(function(response) {
                    return response.json();
                })
                .then(function(item) {
                    oaiq("measure", "items_added", {
                        type: "contents",
                        amount: item.line_price,
                        currency: window.shop_currency,
                        contents: [{
                            id: item.variant_id ?? item.id,
                            name: item.product_title,
                            content_type: "product",
                            quantity: item.quantity,
                        }],
                    });
                    return item;
                })
                .catch(function(error) {
                    console.error('Error:', error);
                })
                .finally(function() {
                    if ($body.hasClass('quickshop-popup-show')) {
                        $body.removeClass('quickshop-popup-show');
                    }
                    if ($body.hasClass('quick-view-show')) {
                        if (window.after_add_to_cart.type == 'cart') {
                            halo.redirectTo(window.routes.cart);
                        } else {
                            Shopify.getCart(function(cartTotal) {
                                $body.find('[data-cart-count]').text(cartTotal.item_count);
                                $target.removeClass('is-loading');
                            });
                        }
                    } else {
                        switch (window.after_add_to_cart.type) {
                            case 'cart':
                                halo.redirectTo(window.routes.cart);
                                break;
                            case 'quick_cart':
                                if (window.quick_cart.show) {
                                    Shopify.getCart(function(cart) {
                                        if (window.quick_cart.type == 'popup') {
                                            // reserved
                                        } else {
                                            $body.addClass('cart-sidebar-show');
                                            $body.removeClass('similar_items_added');
                                            halo.updateSidebarCart(cart);
                                        }
                                        $target.removeClass('is-loading');
                                        halo.giftBagForGoddiva();
                                    });
                                } else {
                                    halo.redirectTo(window.routes.cart);
                                }
                                break;
                            case 'popup_cart_1':
                                Shopify.getCart(function(cart) {
                                    halo.updatePopupCart(cart, 1, variantId);
                                    halo.updateSidebarCart(cart);
                                    $body.addClass('add-to-cart-show');
                                    $target.removeClass('is-loading');
                                });
                                break;
                        }
                    }
                });
            };

            fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' })
            .then(function(response) {
                return response.json();
            })
            .then(function(response) {
                var variantId = parseInt($(addToCartForm).serialize().split('id=')[1]);
                var item = response.items.find(function(i) { return i.variant_id == variantId; });
                var currentQuantity = item ? item.quantity : 0;
                var moreQuantity = 1;

                // ✅ inventory array — no qty input, no saleOutStock bypass
                var maxQuantity = parseInt(inventoryArray ? inventoryArray[variantId] : 0) || null;

              //  halo.giftBagForGoddiva();

                if (!maxQuantity || inventoryPolicy !== 'shopify') {
                    return addItemToCart(variantId);
                }

                if (currentQuantity + moreQuantity > maxQuantity) {
                    var remainingQuantity = maxQuantity - currentQuantity;
                    $target.removeClass('is-loading');
                    halo.showWarning('You ' + (remainingQuantity > 0 ? 'can only add ' + remainingQuantity : 'cannot add') + ' more of the items into the cart');
                    return;
                }

                addItemToCart(variantId);
            })
            .catch(function(err) {
                halo.showWarning(err);
                $target.removeClass('is-loading');
            });
        },

        checkSufficientStock: function(productForm) {
            const qtyInput = productForm.find('[data-inventory-quantity]');
            const addButton = document.getElementById('product-add-to-cart');

            const maxValidQuantity = qtyInput.length
                ? parseInt(qtyInput.data('inventory-quantity'))
                : parseInt(addButton ? addButton.getAttribute('data-inventory-quantity') : 0);

            const inputQuantity = qtyInput.length
                ? parseInt(qtyInput.val())
                : 1;

            if (!maxValidQuantity) return true;

            return maxValidQuantity >= inputQuantity;
        },

        updateContentQuickshopOption3: function(handle){
            var quickShopPopup = $('#halo-quickshop-popup-option-3'),
                quickShopPopupContent = quickShopPopup.find('.halo-popup-content');

            $.ajax({
                type: 'get',
                url: window.routes.root + '/products/' + handle + '?view=ajax_quick_shop',
                beforeSend: function () {
                    $('[data-quick-view-popup] .halo-popup-content').empty()
                },
                success: function (data) {
                    quickShopPopupContent.html(data);       
                },
                error: function (xhr, text) {
                    // alert($.parseJSON(xhr.responseText).description);
                    halo.showWarning($.parseJSON(xhr.responseText).description);
                },
                complete: function () {
                    var $scope = quickShopPopup.find('.quickshop');
                    
                    halo.productImageGallery($scope);
                    setTimeout(() => {
                        $body.addClass('quickshop-popup-show');
                    }, 150)
                }
            });
        },
        
        appendProductQuickShopOption2: function(product) {
            //  Append Product Popup Quick Shop 2 Show Mobile
            if (window.innerWidth <= 767) {
                var quickshopMobilePopup = $doc.find('#halo-card-mobile-popup');
                var quickshopForm = product.clone();
                quickshopMobilePopup.find('.halo-popup-content').empty();
                quickshopForm.find('.card-product__group').remove();
                quickshopMobilePopup.find('.halo-popup-content').append(quickshopForm);

                var form = quickshopMobilePopup.find('[data-quickshop] form').eq('0');
                var mobilePopupId = form.attr('id') + 'mobile';
                form.attr('id', mobilePopupId);
                var optionInputs = form.find('.single-option');
                var optionLabels = form.find('.single-label');

                optionInputs.each((index, optionInput) => {
                    $(optionInput).attr('id', $(optionInput).attr('id') + '-mobile');
                })
                
                optionLabels.each((index, optionLabel) => {
                    $(optionLabel).attr('for', $(optionLabel).attr('for') + '-mobile');
                })

                quickshopMobilePopup.addClass('show');

                $doc.on('click', (e) => {
                    var $target = $(e.target)
                    if ($target.hasClass('background-overlay')) {
                        quickshopMobilePopup.removeClass('show');
                        $body.removeClass('quick_shop_popup_mobile');
                        product.removeClass('quickshop-popup-show');
                    }
                })
            } 
        },

        isRunningInIframe: function() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        },

        redirectTo: function(url){
            if (halo.isRunningInIframe() && !window.iframeSdk) {
                window.top.location = url;
            } else {
                window.location = url;
            }
        },

        initQuickCart: function() {
            if(window.quick_cart.show){
                if(window.quick_cart.type == 'popup'){
                    // halo.initDropdownCart();
                } else {
                    halo.initSidebarCart();
                }
            }

            halo.initEventQuickCart();
        },

        initEventQuickCart: function(){
            halo.removeItemQuickCart();
            halo.updateQuantityItemQuickCart();
            halo.editQuickCart();
        },

        productCollectionCartSlider: function(){
            var productCart = $('[data-product-collection-cart]');

            productCart.each((index, element) => {
                var self = $(element),
                    productGrid = self.find('.products-carousel'),
                    itemDots = productGrid.data('item-dots'),
                    itemArrows = productGrid.data('item-arrows');

                if(productGrid.length > 0){
                    if(!productGrid.hasClass('slick-initialized')){
                        productGrid.slick({
                            mobileFirst: true,
                            adaptiveHeight: false,
                            infinite: false,
                            vertical: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: true,
                            arrows: false,
                            nextArrow: window.arrows.icon_next,
                            prevArrow: window.arrows.icon_prev,
                            rtl: window.rtl_slick,
                            responsive: [
                            {
                                breakpoint: 1025,
                                settings: {
                                    dots: itemDots,
                                    arrows: itemArrows
                                }
                            }]
                        });
                    }
                }
            });
        },

        updatePopupCart: function(cart, layout, variantId) {
            var item = cart.items.filter(item => item.id == variantId)[0],
                popup = $('[data-add-to-cart-popup]'),
                product = popup.find('.product-added'),
                productTitle = product.find('.product-title'),
                productImage = product.find('.product-image'),
                title = item.title || item.product_title,
                image = item.featured_image,
                img = '<img src="'+ image.url +'" alt="'+ image.alt +'" title="'+ image.alt +'"/>';

            productImage.attr('href', item.url).html(img);

            productTitle
                .find('.title')
                .attr('href', item.url)
                .empty()
                .append(title);

            Shopify.getCart((cartTotal) => {
                $body.find('[data-cart-count]').text(cartTotal.item_count);
            });
        },

        initSidebarCart: function() {
            var cartIcon = $('[data-cart-sidebar]');
            let checkInitSideBarCart = true;
            cartIcon.on('click', () => {
                if (!checkInitSideBarCart) return
                checkInitSideBarCart = false
                Shopify.getCart((cart) => {
                    halo.updateSidebarCart(cart);
                })                          
            })
            if ($body.hasClass('template-cart')) {
                cartIcon.on('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    $('html, body').animate({
                        scrollTop: 0
                    }, 700);
                });
            } else {
                cartIcon.on('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    
                    $body.addClass('cart-sidebar-show');
                   $body.removeClass('similar_items_added');
                });
            }

            $doc.on('click', '[data-close-cart-sidebar]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                if ($body.hasClass('cart-sidebar-show')) {
                    $body.removeClass('cart-sidebar-show');
                }
            });

            $body.on('click', '.background-overlay', (event) => {
                if ($body.hasClass('cart-sidebar-show') && !$body.hasClass('edit-cart-show') && !$body.hasClass('term-condition-show') && !$body.hasClass('has-warning')) {
                    if (($(event.target).closest('#halo-cart-sidebar').length === 0) && 
                        ($(event.target).closest('[data-cart-sidebar]').length === 0) && 
                        ($(event.target).closest('[data-edit-cart-popup]').length === 0) && 
                        ($(event.target).closest('[data-warning-popup]').length === 0) && 
                        ($(event.target).closest('[data-term-condition-popup]').length === 0)){
                        $body.removeClass('cart-sidebar-show');
                    }
                }
            })
        },

        updateSidebarCart: function(cart, product_id) {

        
            if(!$.isEmptyObject(cart)){
               let count = 0;
               cart.items.forEach(item => {
                  if((item.product_id).toString() == product_id){
                    count++;
                  }
                });
                const $cartDropdown = $('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
                const $cartLoading = '<div class="loading-overlay loading-overlay--custom">\
                        <div class="loading-overlay__spinner">\
                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
                            </svg>\
                        </div>\
                    </div>';
                const loadingClass = 'is-loading';

                $cartDropdown
                    .addClass(loadingClass)
                    .prepend($cartLoading);
                $('#halo-cart-sidebar').addClass('freeze');
                $.ajax({
                    type: 'GET',
                    url: window.routes.root + '/cart?view=ajax_side_cart',
                    cache: false,
                    success: function (data) {
                       if(cart.item_count < 1){
                        $('.cart-count-addon').addClass('hidden');
                         setTimeout(function() {
                        $('.previewCartMessage').addClass('hidden');
                           }, 2000);
                      }else{
                         $('.cart-count-addon').removeClass('hidden');
                           setTimeout(function() {
                             $('.previewCartMessage').removeClass('hidden');
                          }, 300);
                      }
                     
                        var response = $(data);

                        $cartDropdown
                            .removeClass(loadingClass)
                            .html(response);

                        halo.dispatchChangeForShippingMessage();
                        $(".halo-sidebar-header .previewCartTotals-value .money").load(location.href+" .halo-sidebar-header .previewCartTotals-value .money","");
                    },
                    error: function (xhr, text) {
                        halo.showWarning($.parseJSON(xhr.responseText).description);
                        $('#halo-cart-sidebar').removeClass('freeze');
                    },
                    complete: function () {
                        if (cart.item_count > 0){
                            $('.cart-count-bubble').css('display','');
                        }else{
                             $('.cart-count-bubble').css('display','none');
                        }
                        $body.find('[data-cart-count]').text(cart.item_count);
                        halo.productCollectionCartSlider();
                        halo.updateGiftWrapper();
                        if (halo.checkNeedToConvertCurrency()) {
                          Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                        };
                        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
                       let quantityUpdater = $(".previewCart-wrapper cart-update-quantity");
                    // halo.dsQtyUpdate();
                      halo.afterRemoveFromCart(count, product_id);
                      halo.checkInMiniCart();
                      halo.updateGDFreeShippingBar();
                      halo.updateExclusiveProduct();
                      halo.checkExclusiveProductInCart();
                      halo.removeGiftBagIfNeeded(cart); 
                      halo.restrictGiftBagQuantity();
                      looklabProgressBar();
                      halo.looklabCheckVariantInCart();
                      window.triggerScarfLinkClick('#add-scarf-cart .view-multiwear-products.view-all-scarf-cart-drawer');
                      $('#halo-cart-sidebar').removeClass('freeze');

                    }
                });
            }
        },
        updateGDFreeShippingBar: function() {
          var shippingBar = document.getElementById('gd-free-shipping-bar');
          if (shippingBar) {
           var freeShippingThreshold = shippingBar.getAttribute('data-gd-free-shipping-threshold'); 
           var cartTotal = 0; 
          // Fetch cart data using Shopify's AJAX API
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              cartTotal = cart.total_price;
              var progress = (cartTotal / freeShippingThreshold) * 100;
              var progressBar = document.getElementById('progress-bar');
              var message = document.getElementById('free-shipping-message');
              var progress = Math.min(progress, 100); 
    
              // Remove existing progress classes
                progressBar.classList.remove('progress30', 'progress60', 'progress100', 'free-progress');
          
                // Add the appropriate progress class
                if (progress === 0) {
                  // No class to add for 0 progress
                } else if (progress <= 30) {
                  progressBar.classList.add('progress30');
                } else if (progress <= 60) {
                  progressBar.classList.add('progress60');
                } else if (progress < 100) {
                  progressBar.classList.add('progress100');
                } else {
                  progressBar.classList.add('free-progress');
                }
    
              progressBar.style.width = progress + '%';
              //progressBar.innerText = progress.toFixed(2) + '%';
    
              if (cartTotal >= freeShippingThreshold) {
                message.innerText = 'Congratulations! You qualify for free shipping.';
              } else {
                var amountLeft = (freeShippingThreshold - cartTotal) / 100;
                message.innerText = "You're only " +window.currencySymbol+ amountLeft.toFixed(2) + " away from free shipping!";
              }
    
              document.getElementById('free-shipping-progress-container').style.display = 'block';
            });
          }
        },
        dsQtyUpdate : function(){
              
             const selectedQuantity = $(".ds_total");
        
            $(".btn-quantity, .previewCartItem-remove").click(function() {
                setTimeout(function() {
                    const quantityInput = $(".previewCartTotals.total .previewCartTotals-value");
                    const inputValue = quantityInput.text();
                    selectedQuantity.text(inputValue);
                }, 2000);
            });
        },
        dispatchChangeForShippingMessage: function() {
            document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
                const changeEvent = new Event('change', { bubbles: true })
                freeShippingWrapper.dispatchEvent(changeEvent);
            })
        },

        updateGiftWrapper: function() {
            let debounce 
            $('#gift-wrapping').off('click').on('click', (event) => {
                event.stopPropagation()
                event.preventDefault()
                clearTimeout(debounce)
                debounce = setTimeout(() => {
                    const variantId = event.target.dataset.giftId;
                    Shopify.addItem(variantId, 1, () => {
                        Shopify.getCart((cart) => {
                            halo.updateSidebarCart(cart);
                        });
                    }); 
                }, 250)
            });

            $('#cart-gift-wrapping').off('click').on('click', (event) => {
                event.stopPropagation()
                event.preventDefault()

                var $target = $(event.currentTarget),
                    text = $target.attr('data-adding-text');
                $target.text(text);

                clearTimeout(debounce)
                debounce = setTimeout(() => {
                    const variantId = event.target.dataset.giftId;
                    Shopify.addItem(variantId, 1, () => {
                        Shopify.getCart((cart) => {
                            halo.updateCart(cart)
                        });
                    }); 
                }, 250)
            });
        },

        removeItemQuickCart: function () {
            $doc.on('click', '[data-cart-remove]', (event) => {
                event.preventDefault();
                event.stopPropagation();
                let product_id = event.target.localName == 'path' || event.target.localName == 'svg' ? event.target.closest('a')?.dataset.productId : event.target?.dataset.productId
                var $target = $(event.currentTarget),
                    productId = $target.attr('data-cart-remove-id'),
                    text = $('#cart-gift-wrapping').attr('data-add-text'),
                    productLine = $target.data('line');

                $('#cart-gift-wrapping').text(text);

                Shopify.removeItem(productLine, (cart) => {
                    if($body.hasClass('template-cart')){
                        halo.updateCart(cart, product_id);
                    } else if($body.hasClass('cart-modal-show')){
                        // halo.updateDropdownCart(cart);
                    } else if($body.hasClass('cart-sidebar-show')) {
                        halo.updateSidebarCart(cart, product_id);
                    }
                });
            });
          halo.checkExclusiveProductInCart();
        },

        updateCart: function(cart, product_id){
            if(!$.isEmptyObject(cart)){
                let count = 0;
                const $sectionId = $('#main-cart-items').data('id');
                const $cart = $('[data-cart]')
                const $cartContent = $cart.find('[data-cart-content]');
                const $cartTotals = $cart.find('[data-cart-total]');
                const $cartLoading = '<div class="loading-overlay loading-overlay--custom">\
                        <div class="loading-overlay__spinner">\
                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
                            </svg>\
                        </div>\
                    </div>';
                const loadingClass = 'is-loading';

                $cart
                    .addClass(loadingClass)
                    .prepend($cartLoading);

                $.ajax({
                    type: 'GET',
                    url: `/cart?section_id=${$sectionId}`,
                    cache: false,
                    success: function (data) {
                        var jsPreventedData = data.replaceAll('cart-coupon-discount', 'div');
                        var response = $(jsPreventedData);

                        $cart.removeClass(loadingClass);
                        $cart.find('.loading-overlay').remove();

                        if(cart.item_count > 0){
                            var contentCart =  response.find('[data-cart-content] .cart').html(),
                                subTotal = response.find('[data-cart-total] .cart-total-subtotal').html(),
                                grandTotal = response.find('[data-cart-total] .cart-total-grandtotal').html(),
                                savings = response.find('[data-cart-total] .cart-total-savings').html();

                            $cartContent.find('.cart').html(contentCart);
                            $cartTotals.find('.cart-total-subtotal').html(subTotal);
                            $cartTotals.find('.cart-total-grandtotal').html(grandTotal);
                            $cartTotals.find('.cart-total-savings').html(savings);

                            if(response.find('.haloCalculatorShipping').length > 0){
                                var calculatorShipping = response.find('.haloCalculatorShipping');

                                $cart.find('.haloCalculatorShipping').replaceWith(calculatorShipping);
                            }
                        } else {
                            var contentCart =  response.find('#main-cart-items').html(),
                                headerCart =  response.find('.page-header').html();
                                cartCountdownText1 = response.find('.cart-countdown').data('coundown-text-empty-1');
                                cartCountdownText2 = response.find('.cart-countdown').data('coundown-text-empty-2');
                                cartCountdownProductUrl = response.find('.cart-countdown').data('coundown-prd-empty-url');
                                cartCountdownProductTitle = response.find('.cart-countdown').data('coundown-prd-empty-title');
                            var cartCountdownHtml = cartCountdownText1 + ' <a href="'+ cartCountdownProductUrl +'" class="cart-countdown-product link-effect p-relative"><span class="text">'+ cartCountdownProductTitle +'</span></a> ' + cartCountdownText2;

                            $('#main-cart-items').html(contentCart);
                            $('.page-header').html(headerCart);
                            $('.cart-countdown .text-wrap').html(cartCountdownHtml);
                        }
                       cart.items.forEach(item => {
                        if((item.product_id).toString() == product_id){
                          count++;
                        }
                      });
                    },
                    error: function (xhr, text) {
                        halo.showWarning($.parseJSON(xhr.responseText).description);
                    },
                    complete: function () {
                        $body.find('[data-cart-count]').text(cart.item_count);
                        halo.dispatchChangeForShippingMessage();
                        if (halo.checkNeedToConvertCurrency()) {
                            Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                        }
                        if ($body.hasClass('template-cart')) {
                            const giftWrapping = document.getElementById('cart-gift-wrapping')
                            const isChecked = giftWrapping?.dataset.isChecked
                            const variantId = giftWrapping?.dataset.giftId
                            if (isChecked === 'true') {
                                $('#is-a-gift').hide()
                                const giftCardRemoveButton = document.querySelector(`[data-cart-remove-id="${variantId}"]`)
                                const giftCardQuantityInput = document.querySelector(`[data-cart-quantity-id="${variantId}"]`)

                                giftCardRemoveButton?.addEventListener('click', () => {
                                    giftWrapping.dataset.isChecked = 'false'
                                })

                                giftCardQuantityInput?.addEventListener('change', (e) => {
                                    const value = Number(e.target.value)
                                    if (value  <= 0) {
                                        giftWrapping.dataset.isChecked = 'false'
                                    }
                                })
                            } else {
                                $('#is-a-gift').show()
                            }
                        }
                        
                        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
                        halo.afterRemoveFromCart(count, product_id);
                        halo.checkInMainCart();
                        halo.updateGDFreeShippingBar();
                        halo.checkExclusiveProductInCart();
                        halo.removeGiftBagIfNeeded(cart);
                        halo.restrictGiftBagQuantity();
                        looklabProgressBar();
                    }
                });
            }
        },

        afterRemoveFromCart: function(count, product_id){
        
          let allAddedProducts = localStorage.getItem('addToCartProducts')?.split(',') || [];
          if(allAddedProducts.includes(product_id?.toString())){               
              if(count < 2){
                let index = allAddedProducts.findIndex(id => id == product_id?.toString());
                allAddedProducts.splice(index, 1);
              }
              let filteredBlanks = removeBlanks(allAddedProducts);
              let filteredIds = removeDuplicates(filteredBlanks);
              localStorage.setItem('addToCartProducts', filteredIds.join(','));            
          }
        },
      
        checkInMiniCart: function(){
            const ul = document.querySelector('.previewCartList');
            let localProducts = localStorage.getItem('addToCartProducts')?.split(',') || [];
            let prodictsItems = ul?.querySelectorAll('li.previewCartItem');
            prodictsItems?.forEach(li =>{    
              if(localProducts.includes(li.dataset.productId)){                
                const span = document.createElement('span');
                span.innerHTML = 'i';
                span.classList.add('already-added');
                span.style.color = 'red';
                li.querySelector('.previewCartItem-content').appendChild(span);
              }else{
                li.querySelector('.previewCartItem-content').querySelector('span.already-added')?.remove();
              }
            });
         
           halo.toggleCartMessage();
         
        },
       checkInMainCart:function (){
         let allAddedProducts = localStorage.getItem('addToCartProducts')?.split(',') || [];
         let cartItems = document?.querySelectorAll('.cart-list .cart-item');
         let productIds = [];

          Shopify.getCart((cart) => {
              cart.items.forEach(item => {
                productIds.push((item.product_id).toString());
              });
              
              // This is to show hide the Cart message at the top
              document.querySelector('span.already-added-cart')?.remove();
              if(hasDuplicates(productIds)){
                  const span = document.createElement('span');
                  span.innerHTML = cart_message;
                  span.classList.add('already-added-cart');
                  span.style.display = 'block';
                  document.querySelector('.template-cart .page-header').after(span);
              }else{
                document.querySelector('span.already-added-cart')?.remove();
              }

              // This is to show duplicate icon on each item which is duplicate
              const duplicates = findDuplicates(productIds);
              cartItems?.forEach(item =>{
                if(duplicates.includes(item.dataset.productId)){
                  const span = document.createElement('span');
                    span.innerHTML = 'i';
                    span.classList.add('already-added');
                    span.style.color = 'red';
                    item.appendChild(span);
                }else{
                    item.querySelector('span.already-added')?.remove();
                  }
             });
          });


           function hasDuplicates(arr) {
                // Convert the array to a Set to remove duplicates
                const uniqueSet = new Set(arr);
             
                // If the length remains the same, there are no duplicates
                return arr.length !== uniqueSet.size;
            }

           function findDuplicates(arr) {
                let duplicateValues = [];
                let uniqueSet = new Set();
            
                for (let value of arr) {
                    // If the value is already in the set, it's a duplicate
                    if (uniqueSet.has(value)) {
                        duplicateValues.push(value);
                    } else {
                        uniqueSet.add(value);
                    }
                }
                return duplicateValues;
            }
         
            halo.toggleCartMessage();
        },
        toggleCartMessage:function() {
               const popupWrapper = $(".popup-message_wrapper");
          
              $(document).off("click", ".already-added").on("click", ".already-added", function() {
                  console.log('toggleCartMessage showPopupButton');
                  $("body").addClass("popup-message_wrapper_added");
                  popupWrapper.css("display", "block");
              });
          
              $(document).off("click", ".cart_message_close").on("click", ".cart_message_close", function() {
                  $("body").removeClass("popup-message_wrapper_added");
                  popupWrapper.css("display", "none");
              });
              
        },

        updateQuantityItemQuickCart: function(){
            $doc.on('change', '[data-cart-quantity]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var $target = $(event.currentTarget),
                    productId = $target.attr('data-cart-quantity-id'),
                    productLine = $target.data('line'),
                    quantity = parseInt($target.val()),
                    stock = parseInt($target.data('inventory-quantity'));
                let enoughInStock = true;
               
                const giftBagVariantId = window.giftBagStatus?.variantId;
                if (giftBagVariantId && productId == giftBagVariantId && quantity > 1) {
                    halo.showWarning('You can only add 1 Gift Bag per order.');
                    $target.val(1);
                    return;
                }

                if (stock < quantity && stock > 0) {
                  var arrayInVarName = `cart_selling_array_${event.currentTarget.closest('cart-update-quantity').dataset.product}`,
                    itemInArray = window[arrayInVarName],
                    itemStatus = itemInArray[event.currentTarget.closest('cart-update-quantity').dataset.variant];
                  if(itemStatus == 'deny') {
                    quantity = stock;
                    enoughInStock = false;
                  }
                }

                Shopify.changeItem(productLine, quantity, (cart) => {
                    if($body.hasClass('template-cart')){
                        halo.updateCart(cart);
                    } else if($body.hasClass('cart-modal-show')){
                        // halo.updateDropdownCart(cart);
                    } else if($body.hasClass('cart-sidebar-show')) {
                        halo.updateSidebarCart(cart);
                    }
                    if (!enoughInStock) halo.showWarning(`${ window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', quantity) }`)
                    halo.removeGiftBagIfNeeded(cart);
                });
            });
        },

        editQuickCart: function() {
            let checkLoadEC = true; 

            $doc.on('click', '[data-open-edit-cart]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var $target = $(event.currentTarget),
                    url = $target.data('edit-cart-url'),
                    itemId = $target.data('edit-cart-id'),
                    itemLine = $target.data('line'),
                    quantity = $target.data('edit-cart-quantity'),
                    finalprice = $target.data('edit-final-price'),
                    option = $target.parents('.previewCartItem').find('previewCartItem-variant').text();

                const modal = $('[data-edit-cart-popup]'),
                    modalContent = modal.find('.halo-popup-content');

                if (checkLoadEC) {
                    checkLoadEC = false;
                    const $editCart = document.querySelector('.halo-edit-cart-popup');
                    const urlStyleEC = $editCart.dataset.urlStyleEditCart;
                    const urlScriptEC = $editCart.dataset.urlScriptEditCart;
    
                    halo.buildStyleSheet(urlStyleEC, $editCart);
                    halo.buildScript(urlScriptEC);
                }

                $.ajax({
                    type: 'get',
                    url: url,
                    cache: false,
                    dataType: 'html',
                    beforeSend: function() {
                        if($body.hasClass('template-cart')){
                            // halo.showLoading();
                        }
                    },
                    success: function(data) {
                        modalContent.html(data);
                        modalContent
                            .find('[data-template-cart-edit]')
                            .attr({
                                'data-cart-update-id': itemId,
                                'data-line': itemLine
                            });

                        var productItem = modalContent.find('.product-edit-item');
                        productItem.find('input[name="quantity"]').val(quantity);
                        if (finalprice) {
                            productItem.find('.edit-discounted-price').html(finalprice);
                            productItem.find('.price').addClass('old-price');
                        }
                    },
                    error: function(xhr, text) {
                        // alert($.parseJSON(xhr.responseText).description);
                        halo.showWarning($.parseJSON(xhr.responseText).description);
                        if($body.hasClass('template-cart')){
                            // halo.hideLoading();
                        }
                    },
                    complete: function () {
                        $body.addClass('edit-cart-show');

                        if($body.hasClass('template-cart')){
                            // halo.hideLoading();
                        }

                        if (halo.checkNeedToConvertCurrency()) {
                            Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                        };

                    }
                });
            });

            $doc.on('click', '[data-close-edit-cart]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                $body.removeClass('edit-cart-show');
            });

            $doc.on('click', (event) => {
                if ($body.hasClass('edit-cart-show')) {
                    if (($(event.target).closest('[data-edit-cart-popup]').length === 0) && ($(event.target).closest('[data-open-edit-cart]').length === 0)){
                        $body.removeClass('edit-cart-show');
                    }
                }
            });

            halo.addMoreItemEditCart();
            halo.addAllItemCartEdit();
        },

        addMoreItemEditCart: function(){
            $doc.on('click', '[data-edit-cart-add-more]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var itemWrapper = $('[data-template-cart-edit]'),
                    currentItem = $(event.target).parents('.product-edit-item'),
                    count = parseInt(itemWrapper.attr('data-count')),
                    cloneProduct = currentItem.clone().removeClass('product-edit-itemFirst');
                    cloneProductId = cloneProduct.attr('id') + count;

                cloneProduct.attr('id', cloneProductId);

                halo.updateClonedProductAttributes(cloneProduct, count);

                cloneProduct.insertAfter(currentItem);

                count = count + 1;
                itemWrapper.attr('data-count', count);
            });

            $doc.on('click', '[data-edit-cart-remove]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var currentItem = $(event.target).parents('.product-edit-item');

                currentItem.remove();
            });
        },

        updateClonedProductAttributes: function(product, count){
            var form = $('.shopify-product-form', product),
                formId = form.attr('id'),
                newFormId = formId + count;

            form.attr('id', newFormId);

            $('.product-form__radio', product).each((index, element) => {
                var formInput = $(element),
                    formLabel = formInput.next(),
                    id = formLabel.attr('for'),
                    newId = id + count,
                    formInputName = formInput.attr('name');

                formLabel.attr('for', newId);

                formInput.attr({
                    id: newId,
                    name: formInputName + count
                });
            });
        },

        addAllItemCartEdit: function() {
            $doc.on('click', '#add-all-to-cart', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var $target = $(event.currentTarget),
                    cartEdit = $('[data-template-cart-edit]'),
                    product = cartEdit.find('.product-edit-item.isChecked'),
                    productId = cartEdit.attr('data-cart-update-id');
                    productLine = cartEdit.data('line');

                if(product.length > 0){
                    $target.addClass('is-loading');

                    Shopify.removeItem(productLine, (cart) => {
                        if(!$.isEmptyObject(cart)) {
                            var productHandleQueue = [];

                            var ajax_caller = function(data) {
                                return $.ajax(data);
                            }

                            product.each((index, element) => {
                                var item = $(element),
                                    variantId = item.find('input[name="id"]').val(),
                                    qty = parseInt(item.find('input[name="quantity"]').val());

                                productHandleQueue.push(ajax_caller({
                                    type: 'post',
                                    url: window.routes.root + '/cart/add.js',
                                    data: 'quantity=' + qty + '&id=' + variantId,
                                    dataType: 'json',
                                    async: false
                                }));
                            });

                            if(productHandleQueue.length > 0) {
                                $.when.apply($, productHandleQueue).done((event) => {
                                    setTimeout(function(){ 
                                        $target.removeClass('is-loading');
                                    }, 1000);

                                    Shopify.getCart((cart) => {
                                        $body.removeClass('edit-cart-show');

                                        if($body.hasClass('template-cart')){
                                            halo.updateCart(cart);
                                        } else if($body.hasClass('cart-modal-show')){
                                            // halo.updateDropdownCart(cart);
                                        } else if($body.hasClass('cart-sidebar-show')) {
                                            halo.updateSidebarCart(cart);
                                        }
                                    });
                                });
                            }
                        }
                    });
                } else {
                    alert(window.variantStrings.addToCart_message);
                }
            });
        },

        initNotifyInStock: function() {
            $doc.on('click', '[data-open-notify-popup]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var $target = $(event.currentTarget);

                halo.notifyInStockPopup($target);
            });

            $doc.on('click', '[data-close-notify-popup]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                $body.removeClass('notify-me-show');
            });

            $doc.on('click', (event) => {
                if($body.hasClass('notify-me-show')){
                    if (($(event.target).closest('[data-open-notify-popup]').length === 0) && ($(event.target).closest('[data-notify-popup]').length === 0)){
                        $body.removeClass('notify-me-show');
                    }
                }
            });

            $doc.on('click', '[data-form-notify]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var $target = $(event.currentTarget);

                halo.notifyInStockAction($target);
            });
        },

        notifyInStockPopup: function($target){
            var variant,
                product = $target.parents('.product-item'),
                title = product.find('.card-title').data('product-title'),
                link = product.find('.card-title').data('product-url'),
                popup = $('[data-notify-popup]');

            if($target.hasClass('is-notify-me')){
                variant = product.find('.card-swatch .swatch-label.is-active').attr('title');
            } else {
                variant = $target.data('variant-id');
            }

            popup.find('[name="halo-notify-product-title"]').val($.trim(title));
            popup.find('[name="halo-notify-product-link"]').val(link);

            if(variant){
                popup.find('[name="halo-notify-product-variant"]').val(variant);
            }
            $body.addClass('notify-me-show');
        },

        notifyInStockAction: function($target){
            var proceed = true,
                $notify = $target.parents('.halo-notifyMe'),
                $notifyForm = $notify.find('.notifyMe-form'),
                $notifyText = $notify.find('.notifyMe-text'),
                notifyMail = $notify.find('input[name="email"]').val(),
                email_reg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/,
                message;

            if (!email_reg.test(notifyMail) || (!notifyMail)){
                $notify
                    .find('.form-field')
                    .removeClass('form-field--success')
                    .addClass('form-field--error');

                proceed = false;
                message = '<div class="alertBox alertBox--error"><p class="alertBox-message">'+ window.notify_me.error +'</p></div>';

                $notifyText.html(message).show();
            } else {
                $notify
                    .find('.form-field')
                    .removeClass('form-field--error')
                    .addClass('form-field--success');

                $notifyText.html('').hide();
            }

            if (proceed) {
                var notifySite = $notify.find('[name="halo-notify-product-site"]').val(),
                    notifySiteUrl = $notify.find('[name="halo-notify-product-site-url"]').val(),
                    notifyToMail = window.notify_me.mail,
                    notifySubjectMail = window.notify_me.subject,
                    notifyLabelMail = window.notify_me.label,
                    productName = $notify.find('[name="halo-notify-product-title"]').val(),
                    productUrl = $notify.find('[name="halo-notify-product-link"]').val(),
                    productVariant = $notify.find('[name="halo-notify-product-variant"]').val();

                var content = '<div style="margin:30px auto;width:650px;border:10px solid #f7f7f7"><div style="border:1px solid #dedede">\
                        <h2 style="margin: 0; padding:20px 20px 20px;background:#f7f7f7;color:#555;font-size:2em;text-align:center;">'+ notifySubjectMail +'</h2>';

                content += '<table style="margin:0px 0 0;padding:30px 30px 30px;line-height:1.7em">\
                          <tr><td style="padding: 5px 25px 5px 0;"><strong>Product Name: </strong> ' + productName + '</td></tr>\
                          <tr><td style="padding: 5px 25px 5px 0;"><strong>Product URL: </strong> ' + productUrl + '</td></tr>\
                          <tr><td style="padding: 5px 25px 5px 0;"><strong>Email Request: </strong> ' + notifyMail + '</td></tr>\
                          '+ ((productVariant != '') ? '<tr><td style="padding: 5px 25px 5px 0;"><strong>Product Variant: </strong>' + productVariant + '</td></tr>' : '') +'\
                       </table>';

                content += '<a href="'+ notifySiteUrl +'" style="display:block;padding:30px 0;background:#484848;color:#fff;text-decoration:none;text-align:center;text-transform:uppercase">&nbsp;'+ notifySite +'&nbsp;</a>';
                content += '</div></div>';

                var notify_post_data = {
                    'api': 'i_send_mail',
                    'subject': notifySubjectMail,
                    'email': notifyToMail,
                    'from_name': notifyLabelMail,
                    'email_from': notifyMail,
                    'message': content
                };

                $.post('https://themevale.net/tools/sendmail/quotecart/sendmail.php', notify_post_data, (response) => {
                    if (response.type == 'error') {
                       message = '<div class="alertBox alertBox--error"><p class="alertBox-message">'+ response.text +'</p></div>';
                    } else {
                       message = '<div class="alertBox alertBox--success"><p class="alertBox-message">'+ window.notify_me.success +'</p></div>';
                       halo.resetForm($notifyForm);
                    }

                    $notifyText.html(message).show();
                }, 'json');
            }
        },

        initAskAnExpert: function(){
            $doc.on('click', '[data-open-ask-an-expert]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var askAnExpert = $('[data-ask-an-expert-popup]'),
                    modalContent = askAnExpert.find('.halo-popup-content'),
                    url;

                if($body.hasClass('template-product')){
                    var handle = $('.productView').data('product-handle');

                    url = window.routes.root + '/products/' + handle + '?view=ajax_ask_an_expert';
                } else if($body.hasClass('quick-view-show')){
                    var handle = $('.halo-quickView').data('product-quickview-handle');

                    url = window.routes.root + '/products/' + handle + '?view=ajax_ask_an_expert';
                } else {
                    url = window.routes.root + '/search?view=ajax_ask_an_expert';
                }

                $.ajax({
                    type: 'get',
                    url: url,
                    beforeSend: function () {
                        modalContent.empty();
                    },
                    success: function (data) {
                        modalContent.html(data);
                    },
                    error: function (xhr, text) {
                        alert($.parseJSON(xhr.responseText).description);
                    },
                    complete: function () {
                        $body.addClass('ask-an-expert-show');
                    }
                });
            });

            $doc.on('click', '#halo-ask-an-expert-button', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var self = $(event.currentTarget);

                halo.askAnExpertAction(self);
            });

            $doc.on('click', '[data-close-ask-an-expert]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                $body.removeClass('ask-an-expert-show');
            });

            $doc.on('click', (event) => {
                if($body.hasClass('ask-an-expert-show')){
                    if (($(event.target).closest('[data-open-ask-an-expert]').length === 0) && ($(event.target).closest('#halo-ask-an-expert-popup').length === 0)){
                        $body.removeClass('ask-an-expert-show');
                    }
                }
            });
        },

        askAnExpertAction: function($target){
            var proceed = true,
                $askAnExpert = $target.parents('.halo-ask-an-expert'),
                $askAnExpertForm = $askAnExpert.find('.halo-ask-an-expert-form'),
                $askAnExpertMessage = $askAnExpert.find('.message'),
                askAnExpertMail = $askAnExpert.find('input[name="askAnExpertMail"]').val(),
                alertMessage,
                email_reg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

            $('input[required], textarea[required]', $askAnExpertForm).each((index, element) => {
                if (!$.trim($(element).val())) {
                    $(element)
                        .parent('.form-field')
                        .removeClass('form-field--success')
                        .addClass('form-field--error');

                    alertMessage = '<div class="alertBox alertBox--error"><p class="alertBox-message">'+ window.ask_an_expert.error_2 +'</p></div>';

                    $askAnExpertMessage.html(alertMessage).show();

                    proceed = false;
                } else {
                    $(element)
                        .parent('.form-field')
                        .removeClass('form-field--error')
                        .addClass('form-field--success');

                    $askAnExpertMessage.html('').hide();
                }

                if (($(element).attr("name") == 'askAnExpertMail') && (!email_reg.test(askAnExpertMail))){
                    $(element)
                        .parent('.form-field')
                        .removeClass('form-field--success')
                        .addClass('form-field--error');

                    alertMessage = '<div class="alertBox alertBox--error"><p class="alertBox-message">'+ window.ask_an_expert.error_1 +'</p></div>';
                    
                    $askAnExpertMessage.html(alertMessage).show();
                            
                    proceed = false;
                }
            });

            if (proceed) {
                var toMail = window.ask_an_expert.mail,
                    subjectMail =window.ask_an_expert.subject,
                    labelMail =window.ask_an_expert.label,
                    customerName = $askAnExpert.find('[name="askAnExpertName"]').val(),
                    customerMail = askAnExpertMail,
                    customerPhone = $askAnExpert.find('[name="askAnExpertPhone"]').val(),
                    typeRadio1 = $askAnExpert.find('input[name=askAnExpertRadioFirst]:checked').val(),
                    typeRadio2 = $askAnExpert.find('input[name=askAnExpertRadioSecond]:checked').val(),
                    customerMessage = $askAnExpert.find('[name="askAnExpertMessag"]').val();

                var message = "<div style='border: 1px solid #e6e6e6;padding: 30px;max-width: 500px;margin: 0 auto;'>\
                                    <h2 style='margin-top:0;margin-bottom:30px;color: #000000;'>"+ subjectMail +"</h2>\
                                    <p style='border-bottom: 1px solid #e6e6e6;padding-bottom: 23px;margin-bottom:25px;color: #000000;'>You received a new message from your online store's ask an expert form.</p>\
                                    <table style='width:100%;'>";

                if($askAnExpert.hasClass('has-product')){
                    var productName = $askAnExpert.find('[name="halo-product-title"]').val(),
                        productUrl = $askAnExpert.find('[name="halo-product-link"]').val(),
                        productImage = $askAnExpert.find('[name="halo-product-image"]').val().trim();

                    message += "<tr>\
                                    <td style='border-bottom: 1px solid #e6e6e6;padding-bottom: 25px;margin-bottom:25px;width:50%;'>\
                                        <img style='width: 100px' src='https:"+ productImage +"' alt='"+ productName +"' title='"+ productName +"'>\
                                    </td>\
                                    <td style='border-bottom: 1px solid #e6e6e6;padding-bottom: 25px;margin-bottom:25px;'>\
                                        <a href='"+ productUrl +"'>"+ productName +"</a>\
                                    </td>\
                                </tr>";
                }

                message += "<tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>"+ window.ask_an_expert.customer_name +": </strong></td><td>" + customerName + "</td></tr>\
                            <tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>"+ window.ask_an_expert.customer_mail +": </strong></td><td>" + customerMail + "</td></tr>\
                            <tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>"+ window.ask_an_expert.customer_phone +": </strong></td><td>" + customerPhone + "</td></tr>\
                            <tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>"+ window.ask_an_expert.type_radio1 +" </strong></td><td>"+ typeRadio1 +"</td></tr>\
                            <tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>"+ window.ask_an_expert.type_radio2 +": </strong></td><td>"+ typeRadio2 +"</td></tr>\
                            <tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>"+ window.ask_an_expert.customer_message +"? </strong></td><td>" + customerMessage + "</td></tr>\
                        </table></div>";

                var post_data = {
                    'api': 'i_send_mail',
                    'subject': subjectMail,
                    'email': toMail,
                    'from_name': labelMail,
                    'email_from': askAnExpertMail,
                    'message': message
                };

                $.post('https://themevale.net/tools/sendmail/quotecart/sendmail.php', post_data, (response) => {
                    if (response.type == 'error') {
                       alertMessage = '<div class="alertBox alertBox--error"><p class="alertBox-message">'+ response.text +'</p></div>';
                    } else {
                       alertMessage = '<div class="alertBox alertBox--success"><p class="alertBox-message">'+ window.ask_an_expert.success +'</p></div>';

                       halo.resetForm($askAnExpertForm);

                       $askAnExpertForm.hide();
                    }

                    $askAnExpertMessage.html(alertMessage).show();
                }, 'json');
            }
        },

        resetForm: function(form){
            $('.form-field', form).removeClass('form-field--success form-field--error');
            $('input[type=email], input[type=text], textarea', form).val('');
        },

        initCompareProduct: function() {
            var $compareLink = $('[data-compare-link]');

            if(window.compare.show){
                halo.setLocalStorageProductForCompare($compareLink);
                halo.setAddorRemoveProductForCompare($compareLink);
                halo.setProductForCompare();

                $doc.on('click', '[data-close-compare-product-popup]', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    $body.removeClass('compare-product-show');
                });

                $doc.on('click', (event) => {
                    if($body.hasClass('compare-product-show')){
                        if (($(event.target).closest('[data-compare-link]').length === 0) && ($(event.target).closest('[data-compare-product-popup]').length === 0)){
                            $body.removeClass('compare-product-show');
                        }
                    }
                });
            }
        },

        setLocalStorageProductForCompare: function($link) {
            var count = JSON.parse(localStorage.getItem('compareItem')),
                items = $('[data-product-compare-handle]');

            if(count !== null){ 
                if(items.length > 0) {
                    items.each((index, element) => {
                        var item = $(element),
                            handle = item.data('product-compare-handle');

                        if(count.indexOf(handle) >= 0) {
                            item.find('.compare-icon').addClass('is-checked');
                            item.find('.text').text(window.compare.added);
                            item.find('input').prop('checked', true);
                        } else {
                            item.find('.compare-icon').removeClass('is-checked');
                            item.find('.text').text(window.compare.add);
                            item.find('input').prop('checked', false);
                        }
                    });

                    halo.updateCounterCompare($link);
                }
            }
        },

        setAddorRemoveProductForCompare: function($link) {
            $doc.on('change', '[data-product-compare] input', (event) => {
                var $this = $(event.currentTarget),
                    item = $this.parents('.card-compare'),
                    handle = $this.val(),
                    count = JSON.parse(localStorage.getItem('compareItem'));

                count = halo.uniqueArray(count);

                if(event.currentTarget.checked) {
                    item.find('.compare-icon').addClass('is-checked');
                    item.find('.text').text(window.compare.added);
                    item.find('input').prop('checked', true);
                    halo.incrementCounterCompare(count, handle, $link);
                } else {
                    item.find('.compare-icon').removeClass('is-checked');
                    item.find('.text').text(window.compare.add);
                    item.find('input').prop('checked', false);
                    halo.decrementCounterCompare(count, handle, $link);
                }
            });
        },

        setProductForCompare: function() {
            $doc.on('click', '[data-compare-link]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var count = JSON.parse(localStorage.getItem('compareItem'));

                if (count.length <= 1) {
                    alert(window.compare.message);

                    return false;
                } else {
                    halo.updateContentCompareProduct(count);
                }
            });

            $doc.on('click', '[data-compare-remove]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var id = $(event.currentTarget).data('compare-item'),
                    compareTable = $('[data-compare-product-popup] .compareTable'),
                    item = compareTable.find('.compareTable-row[data-product-compare-id="'+ id +'"]'),
                    handle = item.data('compare-product-handle');

                if(compareTable.find('tbody .compareTable-row').length == 1){
                    // alert(window.compare.message);
                    item.remove();
                    var count = JSON.parse(localStorage.getItem('compareItem')),
                        index = count.indexOf(handle),
                        $compareLink = $('[data-compare-link]');

                    if (index > -1) {
                        count.splice(index, 1);
                        count = halo.uniqueArray(count);
                        localStorage.setItem('compareItem', JSON.stringify(count));

                        halo.setLocalStorageProductForCompare($compareLink);
                        halo.updateCounterCompare($compareLink);
                    }

                    $body.removeClass('compare-product-show');
                } else {
                    item.remove();
                    
                    var count = JSON.parse(localStorage.getItem('compareItem')),
                        index = count.indexOf(handle),
                        $compareLink = $('[data-compare-link]');

                    if (index > -1) {
                        count.splice(index, 1);
                        count = halo.uniqueArray(count);
                        localStorage.setItem('compareItem', JSON.stringify(count));

                        halo.setLocalStorageProductForCompare($compareLink);
                        halo.updateCounterCompare($compareLink);
                    }
                }
            });
        },

        updateCounterCompare: function($link) {
            var count = JSON.parse(localStorage.getItem('compareItem'));

            if (count.length > 1) {
                $link.parent().addClass('is-show');
                $link.find('span.countPill').html(count.length);
            } else {
                $link.parent().removeClass('is-show');
            }
        },

        uniqueArray: function(list) {
            var result = [];

            $.each(list, function(index, element) {
                if ($.inArray(element, result) == -1) {
                    result.push(element);
                }
            });

            return result;
        },

        incrementCounterCompare: function(count, item, $link){
            const index = count.indexOf(item);

            count.push(item);
            count = halo.uniqueArray(count);

            localStorage.setItem('compareItem', JSON.stringify(count));

            halo.updateCounterCompare($link);
        },

        decrementCounterCompare: function(count, item, $link){
            const index = count.indexOf(item);

            if (index > -1) {
                count.splice(index, 1);
                count = halo.uniqueArray(count);
                localStorage.setItem('compareItem', JSON.stringify(count));

                halo.updateCounterCompare($link);
            }
        },

        updateContentCompareProduct: function(list){
            var popup = $('[data-compare-product-popup]'),
                compareTable = popup.find('.compareTable');

            compareTable.find('tbody').empty();

            $.ajax({
                type: 'get',
                url: window.routes.root + '/collections/all',
                cache: false,
                data: {
                    view: 'ajax_product_card_compare',
                    constraint: `limit=${list.length}+sectionId=list-compare+list_handle=` + encodeURIComponent(list)
                },
                beforeSend: function () {},
                success: function (data) {
                    compareTable.find('tbody').append(data);
                },
                error: function (xhr, text) {
                    alert($.parseJSON(xhr.responseText).description);
                },
                complete: function () {
                    $body.addClass('compare-product-show');
                }
            });
        },

        initProductView: function($scope){
            halo.productImageGallery($scope);
            halo.productLastSoldOut($scope);
            halo.productCustomerViewing($scope);
            halo.productCountdown($scope);
            halo.productSizeChart($scope);
            halo.productCustomCursor($scope);
            halo.productVideoGallery($scope);
            halo.initVariantImageGroup($scope, window.variant_image_group);
        },

        initQuickView: function(){
            let checkLoadQV = true;

            $doc.on('click', '[data-open-quick-view-popup]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                if (checkLoadQV) {
                    checkLoadQV = false;
                    const $quickView = document.querySelector('.halo-quick-view-popup');
                    const urlStyleProduct = $quickView.dataset.urlStyleProduct;
                    const urlStyleQV = $quickView.dataset.urlStyleQuickView;
                    const urlVariantsQV = $quickView.dataset.urlVariantsQuickView;
                    const urlSortable = 'https://cdn.jsdelivr.net/npm/sortablejs@latest/Sortable.min.js';

                    if (!document.body.matches('.qs3-loaded')) halo.buildStyleSheet(urlStyleProduct, $quickView);
                    halo.buildStyleSheet(urlStyleQV, $quickView);
                    halo.buildScript(urlVariantsQV);
                    document.body.classList.add('qv-loaded');
                    if (!document.body.matches('.sortable-loader')) {
                        document.body.classList.add('sortable-loader');
                        halo.buildScript(urlSortable);
                    }
                }

                var handle = $(event.currentTarget).data('product-handle');

                halo.updateContentQuickView(handle);
            });

            $doc.on('click', '[data-close-quick-view-popup]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                $body.removeClass('quick-view-show');
            });
            
            $('.background-overlay').off('click.closeQuickView').on('click.closeQuickView', e => {
                if ($body.hasClass('quick-view-show') &&
                       !$body.hasClass('cart-sidebar-show') && 
                       !$body.hasClass('ask-an-expert-show') && 
                       !$body.hasClass('size-chart-show') && 
                       !$body.hasClass('compare-color-show') && 
                       !$body.hasClass('term-condition-show')
                   ) {
                    $body.removeClass('quick-view-show');
                }
            });
        },

        updateContentQuickView: function(handle){
            var popup = $('[data-quick-view-popup]'),
                popupContent = popup.find('.halo-popup-content');

            $.ajax({
                type: 'get',
                url: window.routes.root + '/products/' + handle + '?view=ajax_quick_view',
                beforeSend: function () {
                    popupContent.empty();
                    $('#halo-quickshop-popup-option-3').find('.halo-popup-content').empty()
                },
                success: function (data) {
                    popupContent.html(data);
                },
                error: function (xhr, text) {
                    alert($.parseJSON(xhr.responseText).description);
                },
                complete: function () {
                    var $scope = popup.find('.quickView');
                    const items = $('.halo-popup-content .halo-compare-color-popup li.item'),
                        tableList = $('.halo-popup-content .halo-compare-color-popup #sortTableList'),
                        compareColorPopup = $('.halo-popup-content .halo-compare-color-popup'),
                        sizeChartPopup = $('.halo-popup-content .halo-size-chart-popup');
                    
                    halo.productImageGallery($scope);
                    halo.productLastSoldOut($scope);
                    halo.productCustomerViewing($scope);
                    halo.productCountdown($scope);
                    halo.productSizeChart($scope);
                    halo.setProductForWishlist(handle);
                    halo.initVariantImageGroup($scope, window.variant_image_group_quick_view);

                    $body.addClass('quick-view-show');

                    if (window.Shopify && Shopify.PaymentButton) {
                        Shopify.PaymentButton.init();
                    }

                    tableList.attr('id', 'quickViewSortTableList');

                    items.each((index, element) => {
                        const itemInput = $(element).find('.swatch-compare-color-option'),
                            itemLabel = $(element).find('.swatch-compare-color-label'),
                            itemId = itemInput.attr('id');

                        itemInput
                            .attr('id', `quickView-${itemId}`)
                            .attr('name', `quickView-${itemId}`);
                        itemLabel.attr('for', `quickView-${itemId}`);
                    });

                    compareColorPopup.attr('id', 'quickView-halo-compare-color-popup');
                    sizeChartPopup.attr('id', 'quickView-halo-size-chart-popup');

                    if ($('.halo-productView .addthis_inline_share_toolbox').length) {
                        var html = $('.halo-productView .addthis_inline_share_toolbox').html();

                        $('.halo-popup-content .share-button__button').click(function(){
                            $('.halo-popup-content .addthis_inline_share_toolbox').append(html);
                        });
                    }

                    const thisSortTable = document.getElementById('quickViewSortTableList');
                    const thisImageList = $('.halo-popup-content .halo-compareColors-image');

                    if (window.innerWidth >= 1025 && thisSortTable) {
                        new Sortable(thisSortTable, {
                            animation: 150
                        });
                    } else {
                        onRemoveHandlerQuickView();
                    }

                    function onRemoveHandlerQuickView(){
                        thisImageList.on('click', '.item', (event) => {
                            event.preventDefault();

                            var $target = event.currentTarget,
                                itemId = $target.classList[1].replace('item-', ''),
                                optionId = `swatch-compare-color-${itemId}`,
                                item = $(document.getElementById(optionId));

                            item.trigger('click');
                        });
                    }

                    if (window.review.show_quick_view && $('.shopify-product-reviews-badge').length > 0 && window.SPR != null && typeof window.SPR.registerCallbacks === 'functions') {
                        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                    }
                }
            });
        },

        initVideoImageHeight: function() {

            const $container = $('.productView-nav.style-4');
            const $videos = $container.find('video');
            const $images = $container.find('.productView-image img');

            if (!$videos.length || !$images.length) return;

            let videoHeight = $videos.first().height();

            // If not ready yet, recheck shortly
            if (videoHeight === 0) {
                setTimeout(() => {
                this.initVideoImageHeight();
                }, 300);
                return;
            }

            //Apply consistent height to all images and videos
            $images.css({
                'height': videoHeight + 'px',
                'object-fit': 'cover'
            });

            $videos.css({
                'height': videoHeight + 'px',
                'object-fit': 'cover'
            });
        },

        productImageGallery: function($scope) {
          // var $slider = $('.productView-nav');
          //   $(document).on('click', '.bundle_image', function() {
          //       var slideIndex = $(this).data('slide') - 1; // Slick uses 0-based index
          //       $slider.slick('slickGoTo', slideIndex);
          //   });
            var sliderNav = $scope.find('.productView-nav'),
                sliderFor = $scope.find('.productView-for:not(".mobile")'),
                sliderForMobile = $scope.find('.productView-for.mobile');

            if(!sliderFor.hasClass('slick-initialized') && !sliderNav.hasClass('slick-initialized')) {
                const navArrowsDesk = sliderNav.data('arrows-desk'),
                    navArrowsMobi = sliderNav.data('arrows-mobi'),
                    navCounterMobi = sliderNav.data('counter-mobi'),
                    navMediaCount = sliderNav.data('media-count'),
                    thumbnailToShow = parseInt(sliderFor.data('max-thumbnail-to-show'));
                
                let checkNav, checkFor, navSlideCount;

                var appendTimeout;

                sliderNav.hasClass('productView-nav-gallery') ? navSlideCount = Math.round(navMediaCount / 2) : navSlideCount = navMediaCount;
                sliderNav.hasClass('productView-horizontal-tabs') && navMediaCount == 2 ? navSlideCount = 1 : navSlideCount = navMediaCount;
                const slickCounter = `<div class="slick-counter">
                    <span class="slick-counter--current">1</span>
                    <span aria-hidden="true">/</span>
                    <span class="slick-counter--total">`+navSlideCount+`</span>
                </div>`

                sliderNav.on('init', () => {
                    if (window.innerWidth < 768 && navCounterMobi) {
                        if(variant_image_group == 'false'){
                            clearTimeout(appendTimeout);
                            appendTimeout = setTimeout(() => {
                                sliderNav.append(slickCounter);
                            }, 1000)
    
                            sliderNav.on('reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                                var i = (currentSlide ? currentSlide : 0) + 1;
                                sliderNav.find('.slick-counter--current').text(i);
                            });
                        }
                    }
                });

                sliderNav.on('reInit', () => {
                    clearTimeout(appendTimeout);
                    appendTimeout = setTimeout(() => {
                        sliderNav.append(slickCounter);
                    }, 1000)
                });

                if (sliderNav.closest('.productView').is('.layout-4')) {
                    checkFor = false;
                }
                else {
                    checkFor = sliderFor;
                }

                if(sliderNav.hasClass('productView-nav-gallery')) {
                    var sliderNav2 = $scope.find('.productView-nav.productView-nav-gallery'),
                        length = sliderNav2.data('media-count'),
                        show = 2,
                        rows = 2;

                    if (length == 1) {
                      show = 1;
                      rows = 1;
                    }
                    if (length == 2) {
                      show = 2;
                      rows = 1;
                    }  

                    sliderNav2.slick({
                        dots: true,
                        rows: rows,
                        arrows: navArrowsDesk,
                        infinite: true,
                        slidesPerRow: 1,
                        slidesToShow: show,
                        focusOnSelect: false,
                        asNavFor: checkFor,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [
                            {
                                breakpoint: 767,
                                settings: {
                                    arrows: navArrowsMobi
                                }
                            }
                        ]
                    });
                } else if(sliderNav.hasClass('productView-horizontal-tabs')) {
                  
                    var sliderNav2 = $scope.find('.productView-nav.productView-horizontal-tabs'),
                        show = 2,
                        rows = 1;

                    sliderNav2.slick({
                        dots: true,
                        rows: rows,
                        arrows: navArrowsDesk,
                        infinite: true,
                        slidesPerRow: 1,
                        slidesToShow: show,
                        focusOnSelect: false,
                        asNavFor: checkFor,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [
                            {
                                breakpoint: 767,
                                settings: {
                                    arrows: navArrowsMobi
                                }
                            }
                        ]
                    });
                  
                  //fix selected variant images on load and color variant select start from here
                  function handleColorSelection(labelElement) {
                      const filterId = labelElement.getAttribute('data-filter-id');
                      if (!filterId) return;
                      
                      const slides = document.querySelectorAll(`.productView-nav .${filterId}`);
                      if (slides.length === 0) return;
                      
                      let slideIndex = parseInt(slides[0].getAttribute('data-index')) - 1;
                      if (isNaN(slideIndex)) return;
                      
                      const slider = $('.productView-nav');
                      if (!slider.length) return;

                      slider.slick('slickGoTo', slideIndex);
                     
                  }
                  document.querySelectorAll('.product-form__label[name="Color"]').forEach(label => {
                      label.addEventListener('click', function() {
                          handleColorSelection(this);
                      });
                  });
              
                  function initializeColorSlider() {
                      const checkedColorRadio = document.querySelector('.product-form__radio[name="Color"]:checked');
                      if (!checkedColorRadio) return;
                      
                      const colorLabel = checkedColorRadio.nextElementSibling;
                      if (colorLabel && colorLabel.classList.contains('product-form__label') && 
                          colorLabel.getAttribute('name') === 'Color') {
                          handleColorSelection(colorLabel);
                      }
                  }
                 initializeColorSlider(); 
                //fix selected variant images on load and color variant select ends here
                  
                }else if (sliderNav.is('.style-4')) {                  
                        
                         sliderNav.slick({
                            fade: false,
                            dots: false,
                            arrows: navArrowsDesk,
                            infinite: true,
                            asNavFor: checkFor,
                            nextArrow: window.arrows.icon_next,
                            prevArrow: window.arrows.icon_prev,
                            rtl: window.rtl_slick,     
                            responsive: [
                            {
                              breakpoint: 3840, // 4K Screens, larger screen
                              settings: {
                                 fade: true,
                                  slidesToShow: 1,
                                  slidesToScroll: 1,
                                  slidesPerRow: 2,
                                  rows: 2
                              }
                             },
                             {
                                breakpoint: 2024,
                                settings: {
                                    fade: true,
                                   slidesToShow: 1,
                                    slidesToScroll: 1,
                                    slidesPerRow: 2,
                                    rows: 2                                  
                                }
                              },                              
                              {
                                  breakpoint: 768,
                                  settings: {
                                      dots: true,
                                      rows: 1,
                                      slidesToShow: 2,
                                      slidesToScroll: 1,
                                      slidesPerRow: 1                                    
                                  }
                              },
                              {
                                  breakpoint: 576,
                                  settings: {
                                     infinite: false,
                                     dots: true,
                                     rows: 1,
                                     slidesToShow: 1.06,
                                     slidesToScroll: 1,
                                     slidesPerRow: 1                                      
                                  }
                                }
                              
                            ]
                        }); 

                        checkNav = sliderNav;
                        
                        this.initVideoImageHeight();

                        sliderNav.on('setPosition', this.initVideoImageHeight.bind(this));
                        $(window).on('resize', this.initVideoImageHeight.bind(this));
                        sliderNav.find('video').on('loadedmetadata', this.initVideoImageHeight.bind(this));

                       //video height fixed on product page start
                        // var imgheight = $('.productView-image').height();
                        // $('.productView-video.mp4').css('max-height',imgheight-4);
                        // $('.productView-video.mp4').css('overflow','hidden');
                        // $('.productView-video.mp4').css('margin-top','2px');
                       //video height fixed on product page end
                        // fix if the featured image is on first place instead of variant image start
                        var checkInterval = setInterval(function() {
                        var indexZeroElement = $('[data-slick-index="0"]');
                        if (!indexZeroElement.hasClass('slick-current') && !indexZeroElement.hasClass('slick-active')) {
                            clearInterval(checkInterval); // Stop checking
                            setTimeout(function() {
                                $('.slick-prev').click();
                            }, 500);
                        }
                      }, 10); 
                       // fix if the featured image is on first place instead of variant image end
                  
                    } else {
                      if (!sliderNav.is('.style-2, .style-3') || window.innerWidth < 768) {
                        sliderNav.slick({
                            fade: true,
                            dots: false,
                            arrows: navArrowsDesk,
                            infinite: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            asNavFor: checkFor,
                            nextArrow: window.arrows.icon_next,
                            prevArrow: window.arrows.icon_prev,
                            rtl: window.rtl_slick,
                            responsive: [
                                {
                                    breakpoint: 768,
                                    settings: {
                                        arrows: navArrowsMobi
                                    }
                                }
                            ]
                        }); 
                        checkNav = sliderNav;
                    }
                    else {
                        checkNav = false;
                    }
                }

                if($scope.hasClass('layout-1') || $scope.hasClass('layout-2')){
                    sliderFor.on('init',(event, slick) => {
                        sliderFor.find('.animated-loading').removeClass('animated-loading');
                    });

                    sliderFor.slick({
                        slidesToShow: thumbnailToShow,
                        slidesToScroll: 1,
                        asNavFor: checkNav,
                        arrows: true,
                        dots: false,
                        draggable: false,
                        adaptiveHeight: false,
                        focusOnSelect: true,
                        vertical: true,
                        verticalSwiping: true,
                        infinite: true,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        responsive: [
                            {
                                breakpoint: 1600,
                                settings: {
                                    slidesToShow: thumbnailToShow > 3 ? thumbnailToShow - 1 : thumbnailToShow,
                                    slidesToScroll: 1
                                }
                            },
                            {
                                breakpoint: 1280,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    rtl: window.rtl_slick,
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                    vertical: false,
                                    verticalSwiping: false,
                                    rtl: window.rtl_slick,
                                }
                            }
                        ]
                    });
                } else if($scope.hasClass('layout-3')){
                    sliderFor.on('init',(event, slick) => {
                        sliderFor.find('.animated-loading').removeClass('animated-loading');
                    });

                    sliderFor.slick({
                        slidesToShow: thumbnailToShow,
                        slidesToScroll: 1,
                        asNavFor: checkNav,
                        arrows: true,
                        dots: false,
                        focusOnSelect: true,
                        infinite: true,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [
                            {
                                breakpoint: 1600,
                                settings: {
                                    slidesToShow: thumbnailToShow > 3 ? thumbnailToShow - 1 : thumbnailToShow,
                                    slidesToScroll: 1
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1
                                }
                            }
                        ]
                    });
                }

                sliderForMobile.on('init',(event, slick) => {
                    sliderForMobile.find('.animated-loading').removeClass('animated-loading');
                });

                sliderForMobile.slick({
                    slidesToShow:  parseInt(sliderForMobile.data('max-thumbnail-to-show')),
                    slidesToScroll: 1,
                    asNavFor: checkNav,
                    arrows: true,
                    dots: false,
                    draggable: false,
                    adaptiveHeight: false,
                    focusOnSelect: true,
                    vertical: true,
                    verticalSwiping: true,
                    infinite: true,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                    responsive: [
                        {
                            breakpoint: 1600,
                            settings: {
                                slidesToShow: thumbnailToShow > 3 ? thumbnailToShow - 1 : thumbnailToShow,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 1280,
                            settings: {
                                vertical: false,
                                verticalSwiping: false
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2.2,
                                slidesToScroll: 1,
                                vertical: false,
                                verticalSwiping: false
                            }
                        }
                    ]
                });
                    
                if($scope.hasClass('layout-1') || $scope.hasClass('layout-2')){
                    var height_for = sliderFor.outerHeight(),
                    height_nav = sliderNav.outerHeight(),
                    pos = (height_nav - height_for)/2,
                    pos_disable = pos + 80;

                    if ($win.width() > 1279) {
                        if (sliderFor.find('.slick-arrow').length > 0) {
                            sliderFor.parent().addClass('arrows-visible');
                            sliderFor.parent().css('top', pos);
                        } else {
                            sliderFor.parent().addClass('arrows-disable');
                            sliderFor.parent().css('top', pos_disable);
                        }
                    } else {
                        if (sliderFor.find('.slick-arrow').length > 0) {
                            sliderFor.parent().css('top', 'unset');
                        } else {
                            sliderFor.parent().css('top', pos_disable);
                        }
                    }
                }

                if (sliderNav.find('[data-youtube]').length > 0) {
                    if (typeof window.onYouTubeIframeAPIReady === 'undefined') {
                        window.onYouTubeIframeAPIReady = halo.initYoutubeCarousel.bind(window, sliderNav);

                        const tag = document.createElement('script');
                        tag.src = 'https://www.youtube.com/player_api';
                        const firstScriptTag = document.getElementsByTagName('script')[0];
                        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                    } else {
                        halo.initYoutubeCarousel(sliderNav);
                    }
                }

                if (sliderNav.find('[data-vimeo]').length > 0) {
                    sliderNav.on('beforeChange', (event, slick) => {
                        var currentSlide,
                            player,
                            command;

                        currentSlide = $(slick.$slider).find('.slick-current');
                        player = currentSlide.find('iframe').get(0);

                        command = {
                            'method': 'pause',
                            'value': 'true'
                        };

                        if (player != undefined) {
                            player.contentWindow.postMessage(JSON.stringify(command), '*');
                        }
                    });

                    sliderNav.on('afterChange', (event, slick) => {
                        var currentSlide,
                            player,
                            command;

                        currentSlide = $(slick.$slider).find('.slick-current');
                        player = currentSlide.find('iframe').get(0);

                        command = {
                            'method': 'play',
                            'value': 'true'
                        };

                        if (player != undefined) {
                            player.contentWindow.postMessage(JSON.stringify(command), '*');
                        }
                    });
                }

                if (sliderNav.find('[data-mp4]').length > 0) {
                    sliderNav.on('beforeChange', (event, slick) => {
                        var currentSlide,
                            player;

                        currentSlide = $(slick.$slider).find('.slick-current');
                        player = currentSlide.find('video').get(0);

                        if (player != undefined) {
                            player.pause();
                        }
                        if($('.product-single__media .video-play').length){
                          $('.product-single__media .video-play').show();
                          $('.product-single__media .modal-close').hide();
                        }
                    });

                    sliderNav.on('afterChange', (event, slick) => {
                        var currentSlide,
                            player;

                        currentSlide = $(slick.$slider).find('.slick-current');
                        player = currentSlide.find('video').get(0);

                        // if (player != undefined) {
                        //     player.play();
                        // }
                    });
                }
            }

            var productFancybox = $scope.find('[data-fancybox]');

            if(productFancybox.length > 0){
                productFancybox.fancybox({
                    buttons: [
                        "zoom",
                        "share",
                        "slideShow",
                        "fullScreen",
                        //"download",
                        "thumbs",
                        "close"
                    ],
                    loop : true,
                    thumbs : {
                        autoStart : true,
                    }
                });
            }

            if($body.hasClass('template-product')) {
                if ($scope.closest('.quickView').length) return;
                var productZoom = $scope.find('[data-zoom-image]');

                if ($win.width() > 1024) {
                    productZoom.each((index, element) => {
                        var $this = $(element);
                        
                        if ($win.width() > 1024) {
                            $this.zoom({ url: $this.attr('data-zoom-image'), touch: false });
                        } else {
                            $this.trigger('zoom.destroy');
                        }
                    });
                }
            }

            $win.on('resize', () => {
                if($scope.hasClass('layout-1') || $scope.hasClass('layout-2')){
                    if ($win.width() > 1279) {
                        setTimeout(() => {
                            if (sliderFor.find('.slick-arrow').length > 0) {
                                var height_for = sliderFor.outerHeight(),
                                    height_nav = sliderNav.outerHeight(),
                                    pos = (height_nav - height_for)/2;

                                sliderFor.parent().addClass('arrows-visible');
                                sliderFor.parent().css('top', pos);
                            } else {
                                sliderFor.parent().addClass('arrows-disable');
                            }
                        }, 200);
                    } else {
                        setTimeout(() => {
                            if (sliderFor.find('.slick-arrow').length > 0) {
                                sliderFor.parent().css('top', 'unset');
                            }
                        }, 200);
                    }
                }
            });
        },

        productVideoGallery: function($scope) {
            const videoThumbnail = $scope.find('[data-video-thumbnail]'),
                videoThumbnailLen = videoThumbnail.length,
                productVideoLen = $('.productView-video').length;

            if (videoThumbnailLen) {
                const $imageWrapper = $scope.find('.productView-image-wrapper'),
                    videoModal = $('[data-popup-video]'),
                    sliderNav = $scope.find('.productView-nav');
                let offsetTop = $imageWrapper.offset().top + $imageWrapper.outerHeight();

                if (productVideoLen) {
                    $body.addClass('has-product-video');
                }
                
                $win.on('scroll', (event) => {
                    const $targetCur = $(event.currentTarget),
                        thisVideo = $scope.find('.slick-current .productView-video'),
                        videoType = thisVideo.data('type'),
                        videoUrl = thisVideo.data('video-url');

                    if (videoUrl != undefined) {
                        if ($targetCur.scrollTop() > offsetTop) {
                            // if (!videoModal.is('.is-show')) {
                            //     var player = sliderNav.find('.slick-slide.slick-active').data('youtube-player'),
                            //         dataTime = parseInt(player.getCurrentTime()),
                            //       //  dataTime = player ? parseInt(player.getCurrentTime()) : 0; // Check if player exists
                            //         videoContent = `<div class="fluid-width-video-wrapper" style="padding-top: 56.24999999999999%">
                            //                         ${videoType == 'youtube' ? 
                            //                             `<iframe
                            //                                 id="player"
                            //                                 type="text/html"
                            //                                 width="100%"
                            //                                 frameborder="0"
                            //                                 webkitAllowFullScreen
                            //                                 mozallowfullscreen
                            //                                 allowFullScreen
                            //                                 src="https://www.youtube.com/embed/${videoUrl}?autoplay=1&mute=1&start=${dataTime}">
                            //                             </iframe>`
                            //                             :
                            //                             `<iframe 
                            //                                 src="https://player.vimeo.com/video/${videoUrl}?autoplay=1&mute=1" 
                            //                                 class="js-vimeo" 
                            //                                 allow="autoplay; 
                            //                                 encrypted-media" 
                            //                                 webkitallowfullscreen 
                            //                                 mozallowfullscreen 
                            //                                 allowfullscreen">
                            //                             </iframe>`
                            //                         }
                            //                     </div>`;
                            
                            //     videoModal.addClass('is-show');
                            //     videoModal.find('.halo-popup-content').html(videoContent);
                            //     $body.addClass('video-show product-video-show');
                            //     player.pauseVideo();
                            // }

                          if (!videoModal.hasClass('is-show')) {
                              var currentSlide = sliderNav.find('.slick-slide.slick-active');
                              var playerElement = currentSlide.find('.js-youtube-player, .js-vimeo-player');
                          
                              if (playerElement.length > 0) {
                                  var player;
                                  var videoTypeNew = playerElement.data('video-type');
                                  var videoUrlNew = playerElement.data('video-url');
                          
                                  if (videoTypeNew === 'youtube') {
                                      player = new YT.Player('player', {
                                          videoId: videoUrlNew,
                                          events: {
                                              'onReady': onPlayerReady
                                          }
                                      });
                                  } else if (videoTypeNew === 'vimeo') {
                                      player = new Vimeo.Player(playerElement);
                                  }
                          
                                  function onPlayerReady(event) {
                                      var dataTime = parseInt(player.getCurrentTime());
                                      var videoContent = `<div class="fluid-width-video-wrapper" style="padding-top: 56.25%">
                                                          ${videoTypeNew == 'youtube' ? 
                                                              `<iframe
                                                                  id="player"
                                                                  type="text/html"
                                                                  width="100%"
                                                                  frameborder="0"
                                                                  webkitAllowFullScreen
                                                                  mozallowfullscreen
                                                                  allowFullScreen
                                                                  src="https://www.youtube.com/embed/${videoUrlNew}?autoplay=1&mute=1&start=${dataTime}">
                                                              </iframe>`
                                                              :
                                                              `<iframe 
                                                                  src="https://player.vimeo.com/video/${videoUrlNew}?autoplay=1&mute=1" 
                                                                  class="js-vimeo" 
                                                                  allow="autoplay; encrypted-media" 
                                                                  webkitallowfullscreen 
                                                                  mozallowfullscreen 
                                                                  allowfullscreen">
                                                              </iframe>`
                                                          }
                                                      </div>`;
                          
                                      videoModal.addClass('is-show');
                                      videoModal.find('.halo-popup-content').html(videoContent);
                                      $body.addClass('video-show product-video-show');
                                      player.pauseVideo();
                                  }
                              }
                          }
                        } else {
                            const player = sliderNav.find('.slick-slide.slick-active').data('youtube-player');
                            videoModal.removeClass('is-show');
                            videoModal.find('.halo-popup-content').empty();
                            $body.removeClass('video-show product-video-show');
                            player?.playVideo();
                        }
                    }
                });
            }
        },

        initVariantImageGroup: function($scope, enable = false) {
            if(enable){
                var inputChecked = $scope.find('[data-filter]:checked'),
                    sliderFor = $scope.find('.productView-for'),
                    sliderNav = $scope.find('.productView-nav');    

                if(inputChecked.length > 0){
                    var className = inputChecked.data('filter');

                    if(className !== undefined) {
                        sliderNav.slick('slickUnfilter');
                        sliderFor.slick('slickUnfilter');

                        if(sliderNav.find(className).length && sliderFor.find(className).length) {
                            sliderNav.slick('slickFilter', className).slick('refresh');
                            sliderFor.slick('slickFilter', className).slick('refresh');
                        }
                    }
                }

                $doc.on('change', 'input[data-filter]', (event) => {
                    var className = $(event.currentTarget).data('filter');

                    sliderNav.find('.slick-counter').remove();
                    sliderNav.slick('slickUnfilter');
                    sliderFor.slick('slickUnfilter');

                    if(className !== undefined) {

                        if(sliderNav.find(className).length && sliderFor.find(className).length) {
                            sliderNav.slick('slickFilter', className).slick('refresh');
                            sliderFor.slick('slickFilter', className).slick('refresh');
                        }
                    }
                });
            }
        },

        initYoutubeCarousel: function(slider) {
            slider.each((index, slick) => {
                const $slick = $(slick);

                if ($slick.find('[data-youtube]').length > 0) {
                    $slick.addClass('slick-slider--video');

                    halo.initYoutubeCarouselEvent(slick);
                }
            });
        },

        initYoutubeCarouselEvent: function(slick){
            var $slick = $(slick),
                $videos = $slick.find('[data-youtube]');

            bindEvents(slick);

            function bindEvents() {
                if ($slick.hasClass('slick-initialized')) {
                    onSlickImageInit($slick, $videos);
                }

                $doc.on('init', $slick, onSlickImageInit);
                $doc.on('beforeChange', $slick, onSlickImageBeforeChange);
                $doc.on('afterChange', $slick, onSlickImageAfterChange);
            }

            function onPlayerReady(event) {
                $(event.target.getIframe()).closest('.slick-slide').data('youtube-player', event.target);

                setTimeout(function(){
                    if ($(event.target.getIframe()).closest('.slick-slide').hasClass('slick-active')) {
                        $slick.slick('slickPause');
                        event.target.playVideo();
                    }
                }, 200);
            }

            function onPlayerStateChange(event) {
                if (event.data === YT.PlayerState.PLAYING) {
                    $slick.slick('slickPause');
                }

                if (event.data === YT.PlayerState.ENDED) {
                    $slick.slick('slickNext');
                }
            }

            function onSlickImageInit() {
                $videos.each((j, vid) => {
                    const $vid = $(vid);
                    const id = `youtube_player_${Math.floor(Math.random() * 100)}`;

                    $vid.attr('id', id);

                    const player = new YT.Player(id, {
                        host: 'http://www.youtube.com',
                        videoId: $vid.data('youtube'),
                        wmode: 'transparent',
                        playerVars: {
                            autoplay: 0,
                            controls: 0,
                            disablekb: 1,
                            enablejsapi: 1,
                            fs: 0,
                            rel: 0,
                            showinfo: 0,
                            iv_load_policy: 3,
                            modestbranding: 1,
                            wmode: 'transparent',
                        },
                        events: {
                            onReady: onPlayerReady,
                            onStateChange: onPlayerStateChange,
                        },
                    });
                });
            }

            function onSlickImageBeforeChange(){
                const player = $slick.find('.slick-slide.slick-active').data('youtube-player');

                if (player) {
                    player.stopVideo();
                    $slick.removeClass('slick-slider--playvideo');
                }
            }

            function onSlickImageAfterChange(){
                const player = $slick.find('.slick-slide.slick-active').data('youtube-player');

                if (player) {
                    $slick.slick('slickPause');
                    $slick.addClass('slick-slider--playvideo');
                    player?.playVideo();
                }
            }
        },

        productSizeChart: function($scope){
            window.sizeChart = function() {
                var sizeChartBtn =  $scope.find('[data-open-size-chart-popup]');

                sizeChartBtn.on('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    document.body.classList.add('size-chart-show');
                    if (document.body.classList.contains('quick-view-show')) {
                        $('.halo-popup-content .halo-size-chart-popup').addClass('is-show');
                    }
                    else {
                        $('#MainContent .halo-size-chart-popup').addClass('is-show');
                    }
                });

                $doc.on('click', '[data-close-size-chart-popup]', () => {
                    $body.removeClass('size-chart-show');
                    $('.halo-size-chart-popup').removeClass('is-show');
                });

                $doc.on('click', (event) => {
                    if ($body.hasClass('size-chart-show')) {
                        if (($(event.target).closest('[data-open-size-chart-popup]').length === 0) && ($(event.target).closest('[data-size-chart-popup]').length === 0)) {
                            $body.removeClass('size-chart-show');
                        }
                    }
                });
            };

            var quickViewShow = document.body.classList.contains('quick-view-show'),
                productSizeChart = $('.halo-productView .productView-sizeChart').length;

            if (document.body.classList.contains('template-product')) {
                if (!quickViewShow && productSizeChart) {
                    window.sizeChart();
                } else if (quickViewShow && productSizeChart === 0) {
                    window.sizeChart();
                }
            } else {
                window.sizeChart();
            }
        },

        productLastSoldOut: function($scope) {
            var wrapper = $scope.find('[data-sold-out-product]');

            if (wrapper.length > 0) {
                var numbersProductList = wrapper.data('item').toString().split(','),
                    numbersProductItem = Math.floor(Math.random() * numbersProductList.length),
                    numbersHoursList = wrapper.data('hours').toString().split(','),
                    numbersHoursItem = Math.floor(Math.random() * numbersHoursList.length);

                wrapper.find('[data-sold-out-number]').text(numbersProductList[numbersProductItem]);
                wrapper.find('[data-sold-out-hours]').text(numbersHoursList[numbersHoursItem]);
                wrapper.show();
            }
        },

        productCustomerViewing: function($scope) {
            var wrapper = $scope.find('[data-customer-view]');

            if (wrapper.length > 0) {
                var numbersViewer = wrapper.data('customer-view'),
                    numbersViewerList =  JSON.parse('[' + numbersViewer + ']'),
                    numbersViewerTime = wrapper.data('customer-view-time'),
                    timeViewer =  parseInt(numbersViewerTime) * 1000;
                
                setInterval(function() {
                    var numbersViewerItem = (Math.floor(Math.random() * numbersViewerList.length));

                    wrapper.find('.text').text(window.customer_view.text.replace('[number]', numbersViewerList[numbersViewerItem]));
                }, timeViewer);
            }
        },

        productCountdown: function($scope){
            var wrapper = $scope.find('[data-countdown-id]'),
                countDown = wrapper.data('countdown'),
                countDownDate = new Date(countDown).getTime(),
                countDownText = window.countdown.text;

            if(wrapper.length > 0) {
                var countdownfunction = setInterval(function() {
                    var now = new Date().getTime(),
                        distance = countDownDate - now;

                    if (distance < 0) {
                        clearInterval(countdownfunction);
                        wrapper.remove();
                    } else {
                        var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                            hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                            minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                            seconds = Math.floor((distance % (1000 * 60)) / 1000),
                            strCountDown;

                        if (wrapper.is('.style-2, .style-3')) {
                            strCountDown = '<span class="text"><span>'+ countDownText +'</span></span><span class="num">'+days+'<span>'+ window.countdown.day_2 +'</span></span>\
                                <span class="num">'+hours+'<span>'+ window.countdown.hour_2 +'</span></span>\
                                <span class="num">'+minutes+'<span>'+ window.countdown.min_2 +'</span></span>\
                                <span class="num">'+seconds+'<span>'+ window.countdown.sec_2 +'</span></span>';
                        }
                        else {
                            strCountDown = '<span class="text"><span>'+ countDownText +'</span></span><span class="num">'+days+'<span>'+ window.countdown.day +'</span></span>\
                                <span class="num">'+hours+'<span>'+ window.countdown.hour +'</span></span>\
                                <span class="num">'+minutes+'<span>'+ window.countdown.min +'</span></span>\
                                <span class="num">'+seconds+'<span>'+ window.countdown.sec +'</span></span>';
                        }

                        wrapper.html(strCountDown);
                        wrapper.addClass('show');
                    }
                }, 1000);
            }
        },

        productCustomCursor: function($scope){
            if ($('.cursor-wrapper').length == 0) return;
            const { Back } = window;

            this.cursorWrapper = document.querySelector(".cursor-wrapper");
            this.innerCursor = document.querySelector(".custom-cursor__inner");
            this.outerCursor = document.querySelector(".custom-cursor__outer");

            this.cursorWrapperBox = this.cursorWrapper.getBoundingClientRect();
            this.innerCursorBox = this.innerCursor.getBoundingClientRect();
            this.outerCursorBox = this.outerCursor.getBoundingClientRect();

            document.addEventListener("mousemove", e => {
                this.clientX = e.clientX;
                this.clientY = e.clientY;
            });

            const render = () => {
                TweenMax.set(this.cursorWrapper, {
                    x: this.clientX,
                    y: this.clientY
                });
                requestAnimationFrame(render);
            };
            requestAnimationFrame(render);

            this.fullCursorSize = 60;
            this.enlargeCursorTween = TweenMax.to(this.outerCursor, 0.3, {
                width: this.fullCursorSize,
                height: this.fullCursorSize,
                ease: this.easing,
                paused: true
            });

            const handleMouseEnter = () => {
                this.enlargeCursorTween.play();
                $('.cursor-wrapper').addClass('handleMouseEnter').removeClass('handleMouseLeave');
            };

            const handleMouseLeave = () => {
                this.enlargeCursorTween.reverse();
                $('.cursor-wrapper').addClass('handleMouseLeave').removeClass('handleMouseEnter');
            };

            const gridItems = document.querySelectorAll(".productView-image");
            gridItems.forEach(el => {
                if (el?.querySelector('.productView-video')) return;
                el.addEventListener("mouseenter", handleMouseEnter);
                el.addEventListener("mouseleave", handleMouseLeave);
            });

            this.bumpCursorTween = TweenMax.to(this.outerCursor, 0.1, {
                scale: 0.7,
                paused: true,
                onComplete: () => {
                    TweenMax.to(this.outerCursor, 0.2, {
                        scale: 1,
                        ease: this.easing
                    });
                }
            });

            $(document).on('mouseover', '[data-cursor-image]', (event) => {
                var $target = $(event.currentTarget),
                    imagesInView = new Array();

                imagesInView.push($target.attr('data-index'));
                $("#count-image").text(imagesInView[0]);
            });

            $.fn.isInViewport = function(excludePartials) {
                var elementTop = $(this).offset().top;
                var elementBottom = elementTop + $(this).height();

                var viewportTop = $(document).scrollTop();
                var viewportBottom = viewportTop + $(window).height();

                if (excludePartials) {
                    var bottomVisible = (elementBottom - viewportTop) / $(this).height();
                    var isInView = elementBottom > viewportTop && elementTop < viewportBottom;

                    return isInView && bottomVisible > 0.5;
                }

                return elementBottom > viewportTop && elementTop < viewportBottom;
            };

            
            if ($('.product-full-width').length > 0 || $('.product-full-width-2').length > 0) {
                $(window).on('resize scroll', function() {
                    var imagesInView = new Array();
                    $('.productView-image').each(function() {
                        if ($(this).isInViewport(true)) {
                            imagesInView.push($(this).attr('data-index'));
                            $("#count-image").text(imagesInView[0]);
                        }
                    });
                });
            }
        },

        initWishlist: function() {
            if(window.wishlist.show){
                halo.setLocalStorageProductForWishlist();

                $doc.on('click', '[data-wishlist]', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    if (!$(event.currentTarget).hasClass('is-in-grid')) {
                        $('[data-wishlist-items-display]').removeClass('is-loaded');
                    }

                    var $target = $(event.currentTarget),
                        id = $target.data('product-id'),
                        handle = $target.data('wishlist-handle'),
                        wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];
                        index = wishlistList.indexOf(handle),
                        wishlistContainer = $('[data-wishlist-container]');
                        wishlistLayout = wishlistContainer.attr('data-wishlist-layout');

                    if(!$target.hasClass('wishlist-added')){
                        $target
                            .addClass('wishlist-added')
                            .find('.text')
                            .text(window.wishlist.added);

                        if(wishlistContainer.length > 0) {
                            const addEvent = new CustomEvent('addwishlistitem', { detail: { handle } , bubbles: true });
                            document.dispatchEvent(addEvent);
                        }

                        wishlistList.push(handle);
                        localStorage.setItem('wishlistItem', JSON.stringify(wishlistList));
                        
                        const updateWishlistMailEvent = new CustomEvent('updatewishlistmail', { bubbles: true });
                        document.dispatchEvent(updateWishlistMailEvent); 
                    } else {
                        $target
                            .removeClass('wishlist-added')
                            .find('.text')
                            .text(window.wishlist.add);
                        if(wishlistContainer.length > 0) {
                            if($('[data-wishlist-added="wishlist-'+ id +'"]').length > 0) {
                                $('[data-wishlist-added="wishlist-'+ id +'"]').remove();
                                const icon = $(`[data-wishlist][data-product-id=${id}]`);
                                const productCard = icon.closest('.product');
                                productCard.remove();
                            }           
                        }

                        wishlistList.splice(index, 1);
                        localStorage.setItem('wishlistItem', JSON.stringify(wishlistList));

                        const updatePaginationEvent = new CustomEvent('updatepagination', { bubbles: true })
                        document.dispatchEvent(updatePaginationEvent);
                        
                        if(wishlistContainer.length > 0) {
                            wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];

                            if (wishlistList.length > 0) {
                                const updateWishlistMailEvent = new Event('updatewishlistmail', { bubbles: true })
                                document.dispatchEvent(updateWishlistMailEvent);
                            } else {
                                $('[data-wishlist-container]')
                                    .addClass('is-empty')
                                    .html(`\
                                    <div class="wishlist-content-empty text-center">\
                                        <span class="wishlist-content-text">${window.wishlist.empty}</span>\
                                        <div class="wishlist-content-actions">\
                                            <a class="button button-2 button-continue" href="${window.routes.collection_all}">\
                                                ${window.wishlist.continue_shopping}\
                                            </a>\
                                        </div>\
                                    </div>\
                                `);

                                $('[data-wishlist-footer]').hide();
                            }   
                        }
                    }
                    $('[data-wishlist-count]').text(wishlistList.length);
                    halo.setProductForWishlist(handle);
                })
            }
        },

        calculateCard06Padding() {
            if (!$body.hasClass('product-card-layout-06')) return 

            const cardAction = document.querySelector('.card .card-action.card-grid__hidden');
            cardAction.classList.remove('card-grid__hidden');
            const padding = cardAction.scrollHeight;

            document.querySelector('[data-wishlist-items-grid-display]').style.setProperty('--card-06-padding', padding + 'px');
            cardAction.classList.add('card-grid__hidden');
        },

        setProductForWishlist: function(handle){
            var wishlistList = JSON.parse(localStorage.getItem('wishlistItem')),
                item = $('[data-wishlist-handle="'+ handle +'"]'),
                index = wishlistList?.indexOf(handle);

            if (index == null || wishlistList == null) return;
            
            if(index >= 0) {
                item
                    .addClass('wishlist-added')
                    .find('.text')
                    .text(window.wishlist.added)
            } else {
                item
                    .removeClass('wishlist-added')
                    .find('.text')
                    .text(window.wishlist.add);
            }
        },

        setLocalStorageProductForWishlist: function() {
            var wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];
            localStorage.setItem('wishlistItem', JSON.stringify(wishlistList));

            if (wishlistList.length > 0) {
                wishlistList = JSON.parse(localStorage.getItem('wishlistItem'));
                
                wishlistList.forEach((handle) => {
                    halo.setProductForWishlist(handle);
                });
            }
            $('[data-wishlist-count]').text(wishlistList.length);
        },

        initCountdown: function () {
          var countdownAnnouncementElm = $('[data-countdown-announcement]'),
              countdownElm = $('[data-countdown]').not('[data-countdown-id]');

            if (countdownAnnouncementElm.length) {
                countdownAnnouncementElm.each(function () {
                    var self = $(this),
                        countdownAnnouncement = self.data('countdown-value'),
                        countdownAnnouncementDate = new Date(countdownAnnouncement).getTime();

                    var countdownAnnouncementFunction = setInterval(function() {
                        var now = new Date().getTime(),
                            distance = countdownAnnouncementDate - now;

                        if (distance < 0) {
                            clearInterval(countdownAnnouncementFunction);
                            if (self.hasClass('hide--countdown')) {
                                self.remove();
                            }
                            else {
                                const thisItem = self.parents('.announcement-bar__message'),
                                    thisBar = self.parents('[data-announcement-bar]');
                                thisBar.is('.slick-initialized') ? thisBar.slick('slickRemove', thisItem.data('slick-index')) : thisItem.remove();
                            }
                        } else {
                             var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                                hours = `0${Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))}`.slice(-2),
                                minutes = `0${Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))}`.slice(-2),
                                seconds = `0${Math.floor((distance % (1000 * 60)) / 1000)}`.slice(-2),
                                strCountDown = '';
                            
                            strCountDown = '<div class="clock-item"><span class="num">'+days+'</span><span class="text">'+ window.countdown.days +'</span></div>\
                                            <div class="clock-item"><span class="num">'+hours+'</span><span class="text">'+ window.countdown.hours +'</span></div>\
                                            <div class="clock-item"><span class="num">'+minutes+'</span><span class="text">'+ window.countdown.mins +'</span></div>\
                                            <div class="clock-item"><span class="num">'+seconds+'</span><span class="text">'+ window.countdown.secs +'</span></div>';
                          
                            self.html(strCountDown);
                        }
                    }, 1000);
                });
            }

            if (countdownElm.length) {
                countdownElm.each(function () {
                    var self = $(this),
                        countDown = self.data('countdown-value'),
                        countDownDate = new Date(countDown).getTime();
                        
                    var countdownfunction = setInterval(function() {
                        var now = new Date().getTime(),
                            distance = countDownDate - now;

                        if (distance < 0) {
                            clearInterval(countdownfunction);
                            if (self.hasClass('hide--countdown')) {
                                self.remove();
                            }
                            else {
                                self.parents('.shopify-section').remove();
                            }
                        } else {
                            var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                                hours = `0${Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))}`.slice(-2),
                                minutes = `0${Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))}`.slice(-2),
                                seconds = `0${Math.floor((distance % (1000 * 60)) / 1000)}`.slice(-2),
                                strCountDown = '';
                            if (self.hasClass('product-countdown-block')) {
                                if($('.halo-block-header').hasClass('countdown_style_2')){
                                    strCountDown = '<div class="clock-item"><span class="num">'+days+ window.countdown.d +'</span><span class="icon">:</span></div>\
                                                <div class="clock-item"><span class="num">'+hours+ window.countdown.h +'</span><span class="icon">:</span></div>\
                                                <div class="clock-item"><span class="num">'+minutes+ window.countdown.m +'</span><span class="icon">:</span></div>\
                                                <div class="clock-item"><span class="num">'+seconds+ window.countdown.s +'</span><span class="icon"></span></div>';
                                } else{
                                    strCountDown = `<div class="clock-item"><span class="num">${days}d&nbsp;</span></div>
                                    <div class="clock-item"><span class="num">${hours}:</span></div>
                                    <div class="clock-item"><span class="num">${minutes}:</span></div>
                                    <div class="clock-item"><span class="num">${seconds}</span></div>`;
                                }
                            } else {
                                strCountDown = '<div class="clock-item"><span class="num">'+days+'</span><span class="text">'+ window.countdown.days +'</span></div>\
                                                <div class="clock-item"><span class="num">'+hours+'</span><span class="text">'+ window.countdown.hours +'</span></div>\
                                                <div class="clock-item"><span class="num">'+minutes+'</span><span class="text">'+ window.countdown.mins +'</span></div>\
                                                <div class="clock-item"><span class="num">'+seconds+'</span><span class="text">'+ window.countdown.secs +'</span></div>';
                            }
                            self.html(strCountDown);
                        }
                    }, 1000);
                });
            }
        },

        collectionCountdown: function () {
            var countdownElm = $('[data-collection-countdown]');

            if (countdownElm.length) {
                countdownElm.each(function () {
                    var self = $(this);

                    var countDownCollection = (self) => {
                        var countDown = self.data('collection-countdown-value'),
                            countDownDate = new Date(countDown).getTime(),
                            countDownText = window.countdown.text,
                            now = new Date().getTime(),
                            distance = countDownDate - now;

                        if (distance < 0) {
                            clearInterval(countDownCollection);
                            if (self.hasClass('hide--countdown')) {
                                self.remove();
                            }
                        } else {
                            var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                                hours = `0${Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))}`.slice(-2),
                                minutes = `0${Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))}`.slice(-2),
                                seconds = `0${Math.floor((distance % (1000 * 60)) / 1000)}`.slice(-2),
                                strCountDown = '';
                            if (self.hasClass('collection-countdown')) {
                                strCountDown = '<div class="clock-item"><span class="num">'+days+'</span><span class="text">'+ window.countdown.days +'</span></div>\
                                                <div class="clock-item"><span class="num">'+hours+'</span><span class="text">'+ window.countdown.hours +'</span></div>\
                                                <div class="clock-item"><span class="num">'+minutes+'</span><span class="text">'+ window.countdown.mins +'</span></div>\
                                                <div class="clock-item"><span class="num">'+seconds+'</span><span class="text">'+ window.countdown.secs +'</span></div>';
                            }
                            self.html(strCountDown);
                        }
                    }

                    setInterval(() =>{
                        countDownCollection(self)
                    }, 1000);
                });
            }
        },

        handleScrollDown: function() {
            var iconSrollDownSlt = '[data-scroll-down]',
                iconSrollDown = $(iconSrollDownSlt);

            if (iconSrollDownSlt.length) {
                iconSrollDown.each(function() {
                    var self = $(this);
                    var target = self.closest('.shopify-section').next('.shopify-section').attr('id');

                    self.attr('href', '#'+ target +'');

                    iconSrollDown.on('click', function(e) {
                        e.preventDefault();
                        var scroll = $(this.getAttribute('href'));

                        if (scroll.length) {
                            $('html, body').stop().animate({
                                scrollTop: scroll.offset().top
                            }, 400);
                        };
                    });
                });
            }
        },

        toggleSidebarMobile: function() {
            $doc.on('click', '[data-sidebar]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                $body.addClass('open-mobile-sidebar');
              
            });

            $doc.on('click', '[data-close-sidebar]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                $body.removeClass('open-mobile-sidebar');
            });

            $doc.on('click', (event) => {
                if($body.hasClass('open-mobile-sidebar')){
                    if (($(event.target).closest('[data-sidebar]').length === 0) && ($(event.target).closest('#halo-sidebar').length === 0)) {
                        $body.removeClass('open-mobile-sidebar');
                    }
                }
            });
        },

        initBlogMasonry: function() {
            const $blogMasonry = $('.blog-layout-masonry .blog-block-item');
            const isRTL = $body.hasClass('layout_rtl');

            $blogMasonry.masonry({
                columnWidth: '.blog-grid-sizer',
                itemSelector: '[data-masonry-item]',
                isRTL: isRTL,
                originLeft: !isRTL
            });
        },

        articleGallery: function() {
            const $gallery = $('.articleGallery-block'),
                $gallerySlider = $('.articleGallery-slider'),
                galleryLength = $gallery.length,
                col = $gallerySlider.data('col');

            if (galleryLength > 0 && $gallerySlider.not('.slick-initialized')) {
                $gallerySlider.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: true,
                    infinite: false,
                    mobileFirst: true,
                    focusOnSelect: false,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: col,
                                slidesToScroll: col
                            }
                        },
                        {
                            breakpoint: 319,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        }
                    ]
                });
            }
        },

        initCollapseSidebarBlock: function (){
            $doc.on('click', '.sidebarBlock-headingWrapper .sidebarBlock-heading', (event) => {
                var $target = $(event.currentTarget),
                    $blockCollapse = $target.parent().siblings(),
                    $sidebarBlock = $target.parents('.sidebarBlock');

                if($target.hasClass('is-clicked')){
                    $target.removeClass('is-clicked');
                    $blockCollapse.slideUp('slow');
                } else {
                    $target.addClass('is-clicked');
                    $blockCollapse.slideDown('slow');

                    if ($sidebarBlock.hasClass('sidebar-product')) {
                        $sidebarBlock.find('.products-carousel').slick('refresh');
                    }
                }
            });
        },

        initCategoryActive: function(){
            if ($('.all-categories-list').length > 0) {
                $doc.on('click', '.all-categories-list .icon-dropdown', (event) => {
                    var $target = $(event.currentTarget).parent();

                    $target.siblings().removeClass('is-clicked current-cate');
                    $target.toggleClass('is-clicked');
                    $target.siblings().find('> .dropdown-category-list').slideUp('slow');
                    $target.find('> .dropdown-category-list').slideToggle('slow');
                });

                $('.all-categories-list li').each((index, element) =>{
                    if ($(element).hasClass('current-cate')) {
                        $(element).find('> .dropdown-category-list').slideToggle('slow');
                    }
                });
            }
        },

        productBlockSilderSidebar: function() {
            var productGrid = $('[data-product-slider-sidebar]'),
                itemToShow = productGrid.data('item-to-show'),
                itemDots = productGrid.data('item-dots'),
                itemArrows = productGrid.data('item-arrows');

            if(productGrid.length > 0) {
                if(productGrid.not('.slick-initialized')) {
                    productGrid.slick({
                        mobileFirst: true,
                        adaptiveHeight: true,
                        vertical: false,
                        infinite: false,
                        slidesToShow: itemToShow,
                        slidesToScroll: 1,
                        arrows: itemArrows,
                        dots: itemDots,
                        autoplay: true,
                        autoplaySpeed: 2000,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                    });

                  
                }
            }
        },

        productBlockSilderArticle: function() {
            var productGrid = $('[data-product-slider-article]'),
                itemToShow = productGrid.data('item-to-show'),
                itemDots = productGrid.data('item-dots'),
                itemArrows = productGrid.data('item-arrows');

            if(productGrid.length > 0) {
                if(productGrid.not('.slick-initialized')) {
                    productGrid.slick({
                        adaptiveHeight: true,
                        vertical: false,
                        infinite: false,
                        slidesToShow: itemToShow,
                        slidesToScroll: 1,
                        arrows: itemArrows,
                        dots: itemDots,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [{
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                                breakpoint: 551,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                }
                            }
                        ]
                    });
                }
            }
        },

        articleGallery: function() {
            const $gallery = $('.articleGallery-block'),
                $gallerySlider = $('.articleGallery-slider'),
                galleryLength = $gallery.length,
                col = $gallerySlider.data('col');

            if (galleryLength > 0 && $gallerySlider.not('.slick-initialized')) {
                $gallerySlider.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: true,
                    infinite: false,
                    mobileFirst: true,
                    focusOnSelect: false,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: col,
                                slidesToScroll: col
                            }
                        },
                        {
                            breakpoint: 319,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        }
                    ]
                });
            }
        },

        initInfiniteScrolling: function(){
            if ($('.pagination-infinite'.length > 0)) {
                $win.on('scroll load', () => {
                    var currentScroll = $win.scrollTop(),
                        pageInfinite = $('.pagination-infinite'),
                        linkInfinite = pageInfinite.find('[data-infinite-scrolling]'),
                        position; 

                    if(linkInfinite.length > 0 && !linkInfinite.hasClass('is-loading')){
                        position = pageInfinite.offset().top - 500;
                        
                        if (currentScroll > position) {
                            var url = linkInfinite.attr('href');

                            halo.doAjaxInfiniteScrollingGetContent(url, linkInfinite);
                        }
                    }
                });
            }

            $doc.on('click', '[data-infinite-scrolling]', (event) => {
                var linkInfinite = $(event.currentTarget),
                    url = linkInfinite.attr('href');

                event.preventDefault();
                event.stopPropagation();

                halo.doAjaxInfiniteScrollingGetContent(url, linkInfinite);
            });
        },

        doAjaxInfiniteScrollingGetContent: function(url, link){
            $.ajax({
                type: 'GET',
                url: url,
                beforeSend: function () {
                    link.text(link.attr('data-loading-more'));
                    link.addClass('is-loading');
                    // document.getElementById('CollectionProductGrid').querySelector('.collection').classList.add('is-loading');
                    // $body.addClass('has-halo-loader');
                },
                success: function (data) {
                    halo.ajaxInfiniteScrollingMapData(data);
                },
                error: function (xhr, text) {
                    alert($.parseJSON(xhr.responseText).description);
                },
                complete: function () {
                    link.text(link.attr('data-load-more'));
                    link.removeClass('is-loading');
                    // document.getElementById('CollectionProductGrid').querySelector('.collection').classList.remove('is-loading');
                    // $body.removeClass('has-halo-loader');
                    if (document.querySelector('.collection-masonry')) {
                        resizeAllGridItems();
                    }
                }
            });
        },

        ajaxInfiniteScrollingMapData: function(data){
            var currentTemplate = $('#CollectionProductGrid'),
                currentProductListing = currentTemplate.find('.productListing'),
                currentPagination = currentTemplate.find('.pagination'),
                newTemplate = $(data).find('#CollectionProductGrid'),
                newProductListing = newTemplate.find('.productListing'),
                newPagination = newTemplate.find('.pagination'),
                newProductItem = newProductListing.children('.product');
                
            if (newProductItem.length > 0) {
                currentProductListing.append(newProductItem);
                currentPagination.replaceWith(newPagination);

                $('[data-total-start]').text(1);

                if(window.compare.show){
                    var $compareLink = $('[data-compare-link]');
                    halo.setLocalStorageProductForCompare($compareLink);
                }

                if(window.wishlist.show){
                    halo.setLocalStorageProductForWishlist();
                }

                if (halo.checkNeedToConvertCurrency()) {
                    Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                }
            }
        },

        initQuickShopProductList: function() {
            $doc.on('click', '[data-open-quickshop-popup-list]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var handle = $(event.currentTarget).data('product-handle'),
                    product = $(event.currentTarget).closest('.card');

                if(!product.hasClass('quick-shop-show')){
                    halo.updateContentQuickShop(product, handle);
                }
            });

            $doc.on('click', '[data-close-quickshop-popup-list]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var product = $(event.currentTarget).closest('.card');

                product.removeClass('quick-shop-show');
                product.find('.card-popup-content').empty();
            });

            $doc.on('click', (event) => {
                if($('.card').hasClass('quick-shop-show')){
                    if (($(event.target).closest('[data-open-quickshop-popup-list]').length === 0) && ($(event.target).closest('.card-popup').length === 0)){
                        $('.card').removeClass('quick-shop-show');
                        $('.card').find('.card-popup-content').empty();
                    }
                }
            });
        },

        updateContentQuickShop: function(product, handle) {
            var popup = product.find('.card-popup'),
                popupContent = popup.find('.card-popup-content');

            $.ajax({
                type: 'get',
                url: window.routes.root + '/products/' + handle + '?view=ajax_quick_shop',
                beforeSend: function () {
                    $('.card').removeClass('quick-shop-show');
                },
                success: function (data) {
                    popupContent.append(data);
                },
                error: function (xhr, text) {
                    alert($.parseJSON(xhr.responseText).description);
                },
                complete: function () {
                    product.addClass('quick-shop-show');
                }
            });
        },

        toggleVariantsForExpressOrder: function () {
            var toggleVariant = '[data-toggle-variant]';

            $(document).on('click', toggleVariant, function (e) {
                e.preventDefault();
                e.stopPropagation();

                var self = $(this),
                    curVariants = self.data('target');

                if(self.hasClass('show-options-btn')) {
                    self.text(window.inventory_text.hide_options);
                    $(curVariants).slideDown(700, function () {
                        self.addClass('hide-options-btn').removeClass('show-options-btn');
                    });
                }
                else {
                    self.text(window.inventory_text.show_options);
                    $(curVariants).slideUp(700, function () {
                        self.addClass('show-options-btn').removeClass('hide-options-btn');
                    });
                };
            })
        },

        initExpressOrderAddToCart: function() {
            var addToCartSlt = '[data-express-addtocart]';

            $(document).off('click.addToCartExpress', addToCartSlt).on('click.addToCartExpress', addToCartSlt, function (e) {
                e.preventDefault();

                var self = $(this);

                if (self.attr('disabled') != 'disabled') {
                    var productItem = self.closest('.product-item');

                    if(productItem.length == 0) {
                        productItem = self.closest('.col-options');
                    }

                    var form = productItem.find('form');
                    var variant_id = form.find('select[name=id]').val();

                    if (!variant_id) {
                        variant_id = form.find('input[name=id]').val();
                    };

                    var quantityElm = productItem.find('input[name=quantity]');

                    if(quantityElm.length == 0) {
                        quantityElm = productItem.siblings('.col-qtt').find('input[name=quantity]');
                    }

                    var quantity = quantityElm.val();
                    if (!quantity) {
                        quantity = 1;
                    };

                    if(parseInt(quantity) !== 0) {
                        if (window.ajax_cart == 'none') {
                            form.submit();
                        } else {
                            halo.expressAjaxAddToCart(variant_id, quantity, self, form);
                            form.next('.feedback-text').show();
                        }
                    }
                    else {
                        form.next('.feedback-text').text('Quantity cannot be blank').show();
                    }
                }
                return false;
            });
        },

        expressAjaxAddToCart: function(variant_id, quantity, cartBtn, form) {
            $.ajax({
                type: "post",
                url: "/cart/add.js",
                data: 'quantity=' + quantity + '&id=' + variant_id,
                dataType: 'json',

                beforeSend: function() {
                    window.setTimeout(function() {
                        cartBtn.text(window.inventory_text.adding +"...");
                    }, 100);
                },

                success: function(msg) {
                    window.setTimeout(function() {
                        cartBtn.text(window.inventory_text.thank_you);
                        cartBtn.addClass('add_more');
                        form.next('.feedback-text').text(window.inventory_text.cart_feedback).addClass('is-added');
                    }, 600);
                    window.setTimeout(function() {
                        cartBtn.text(window.inventory_text.add_more + "...");
                    }, 1000);

                    switch (window.after_add_to_cart.type) {
                        case 'cart':
                            halo.redirectTo(window.routes.cart);

                            break;
                        case 'quick_cart':
                            if(window.quick_cart.show){
                                Shopify.getCart((cart) => {
                                    if( window.quick_cart.type == 'popup'){
                                        // $body.addClass('cart-modal-show');
                                        // halo.updateDropdownCart(cart);
                                    } else {
                                        $body.addClass('cart-sidebar-show');
                                       $body.removeClass('similar_items_added');
                                        halo.updateSidebarCart(cart);
                                    }
                                });
                            } else {
                                halo.redirectTo(window.routes.cart);
                            }

                            break;
                        case 'popup_cart_1':
                            Shopify.getCart((cart) => {
                                halo.updatePopupCart(cart, 1, variant_id);
                                halo.updateSidebarCart(cart);
                                $body.addClass('add-to-cart-show');
                            });

                            break;
                    }
                },

                error: function(xhr, text) {
                    alert($.parseJSON(xhr.responseText).description);
                    window.setTimeout(function() {
                        cartBtn.text(window.inventory_text.add_to_cart);
                    }, 400);
                }
            });
        },

        initProductBundle: function() {
            var productBundle = $('[data-product-bundle]'),
                bundleList = productBundle.find('[data-bundle-slider]'),
                dots = bundleList.data('dots'),
                arrows = bundleList.data('arrows');

            if(bundleList.length > 0){
                if(!bundleList.hasClass('slick-initialized')){
                    bundleList.slick({
                        dots: true,
                        arrows: arrows,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        infinite: false,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1,
                                    dots: dots
                                }
                            },
                            {
                                breakpoint: 551,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                    dots: dots
                                }
                            }
                        ]
                    });

                    productBundle.find('.bundle-product-wrapper').removeClass('has-halo-block-loader');

                    bundleList.on('afterChange', function(){
                        bundleList.find('.bundle-product-item').removeClass('is-open');
                    });
                }
            }
        },

        initProductReviewSection: function() {
            $doc.ready(() => {
                setTimeout(() => {
                    const $reviewTabContent = $('.productView-review .spr-content'),
                        $thisReviewSection = $('.shopify-app-block .spr-content');
        
                    if ($reviewTabContent && $thisReviewSection) {
                        const reviewContent = $reviewTabContent.html();
                        $thisReviewSection.html(reviewContent);
                    }
                }, 1000);
            });
        },

        initDynamicBrowserTabTitle: function() {
            if(window.dynamic_browser_title.show){
                var pageTitleContent = document.title,
                    newPageTitleContent = window.dynamic_browser_title.text;

                window.onblur = function () {
                    document.title = window.dynamic_browser_title.text;
                }

                window.onfocus = function () {
                    document.title = pageTitleContent;
                }
            }
        },

        initWarningPopup: function() {
            this.warningPopup = document.querySelector('[data-warning-popup]');
            this.warningPopupContent = this.warningPopup.querySelector('[data-halo-warning-content]');
            this.warningPopupCloseButton = this.warningPopup.querySelector('[data-close-warning-popup]');
            this.warningPopupCloseButton.addEventListener('click', () => {
                document.body.classList.remove('has-warning');
            })
            
            this.warningTime = 3000
            this.warningTimeout = undefined;

            window.warningTimeout = this.warningTimeout;
        },  

        showWarning: function(content, time = this.warningTime) {
            if (this.warningTimeout) {
                clearTimeout(this.warningTimeout);
            }

            this.warningPopupContent.textContent = content;
            document.body.classList.add('has-warning');
            
            if (time) {
                this.warningTimeout = setTimeout(() => {
                    document.body.classList.remove('has-warning');
                }, time);
            }
        },

        backgroundOverlayHoverEffect: function() {
            const backgroundOverlay = document.querySelector('.background-overlay')
            const backgroundCursorWrapper = backgroundOverlay.firstChild

            const enlargeCursor = () => {
                backgroundCursorWrapper.classList.add('enlarge-cursor')
            }

            const dwindleCursor = () => {
                backgroundCursorWrapper.classList.remove('enlarge-cursor')
            }

            const setCursorPosition = (clientX, clientY) => {
                requestAnimationFrame(() => {
                    backgroundCursorWrapper.style.setProperty('--translate-y', clientY)
                    backgroundCursorWrapper.style.setProperty('--translate-x', clientX)
                })
            }

            const handleMouseMove = (e) => {
                setCursorPosition(e.clientX, e.clientY)                
            }

            const handleMouseEnter = (e) => {
                setCursorPosition(e.clientX, e.clientY)
                enlargeCursor()
            }
            
            const handleMouseLeave = e => {
                setCursorPosition(e.clientX, e.clientY)
                backgroundCursorWrapper.removeEventListener('mousemove', handleMouseMove)
                dwindleCursor()
            }

            backgroundOverlay.addEventListener('mouseenter', handleMouseEnter)
            backgroundOverlay.addEventListener('mouseleave', handleMouseLeave)
            backgroundOverlay.addEventListener('mousemove', handleMouseMove)
            backgroundOverlay.addEventListener('click', dwindleCursor)
        },
        backgroundOverlayHoverEffect1: function() {
            const backgroundOverlay = document.querySelector('.background-overlay1')
            if (!backgroundOverlay) return;
          
            const backgroundCursorWrapper = backgroundOverlay.firstChild

            const enlargeCursor = () => {
                backgroundCursorWrapper.classList.add('enlarge-cursor')
            }

            const dwindleCursor = () => {
                backgroundCursorWrapper.classList.remove('enlarge-cursor')
            }

            const setCursorPosition = (clientX, clientY) => {
                requestAnimationFrame(() => {
                    backgroundCursorWrapper.style.setProperty('--translate-y', clientY)
                    backgroundCursorWrapper.style.setProperty('--translate-x', clientX)
                })
            }

            const handleMouseMove = (e) => {
                setCursorPosition(e.clientX, e.clientY)                
            }

            const handleMouseEnter = (e) => {
                setCursorPosition(e.clientX, e.clientY)
                enlargeCursor()
            }
            
            const handleMouseLeave = e => {
                setCursorPosition(e.clientX, e.clientY)
                backgroundCursorWrapper.removeEventListener('mousemove', handleMouseMove)
                dwindleCursor()
            }

            backgroundOverlay.addEventListener('mouseenter', handleMouseEnter)
            backgroundOverlay.addEventListener('mouseleave', handleMouseLeave)
            backgroundOverlay.addEventListener('mousemove', handleMouseMove)
            backgroundOverlay.addEventListener('click', dwindleCursor)
        },

        productBlockScroller: function (wrapper) {
            const { Back } = window;
            const easingEffect = Back.easeInOut.config(1.7);

            let cursorWrapper = wrapper.get(0)?.querySelector('.products-cursor');

            if(!cursorWrapper) return;

            let innerCursor = cursorWrapper.querySelector('.products-cursor__inner'),
                imageCursor = cursorWrapper.querySelector('.products-cursor__image'),
                iconCursor = cursorWrapper.querySelector('.products-cursor__icon'),
                itemTween = wrapper.get(0)?.querySelectorAll('.halo-block-content.is-scroll, .products-load.is-scroll'),
                itemNotTween = wrapper.get(0)?.querySelectorAll('.card-product__group, .card-action, .card-title, .card-swatch, .variants-popup, .card-compare, .card-quickview, .card-wishlist, .list-product-tabs'),
                clientX,
                clientY,
                scrollerBox,
                cursorSide = null,
                cursorInsideSwiper = false;

            document.addEventListener('mousemove', (event) => {
                clientX = event.clientX;
                clientY = event.clientY;
                docClientX = event.clientX;
                docClientY = event.clientY;
            });

            const render = () => {
                TweenMax.set(cursorWrapper, {
                    x: clientX,
                    y: clientY
                });
                
                requestAnimationFrame(render);
            };

            requestAnimationFrame(render);

            const wrapTween = TweenMax.to([cursorWrapper] , 0.1, {
                scale: 2.5,
                opacity: 1,
                backgroundColor: 'rgba(42,104,118,1)',
                ease: easingEffect,
                paused: true
            });

            const elementTween = TweenMax.to([imageCursor, iconCursor] , 0.1, {
                opacity: 1,
                ease: easingEffect,
                paused: true
            });

            const handleMouseEnter = (event) => {
                wrapTween.play();
                elementTween.play();
                cursorWrapper.classList.add('handleMouseEnter');
                cursorWrapper.classList.remove('handleMouseLeave');
            };

            const handleMouseLeave = (event) => {
                wrapTween.reverse();
                elementTween.reverse();
                cursorWrapper.classList.add('handleMouseLeave');
                cursorWrapper.classList.remove('handleMouseEnter');
            };

            itemTween.forEach(element => {
                element.addEventListener('mouseenter', handleMouseEnter);
                element.addEventListener('mouseleave', handleMouseLeave);
            });

            itemNotTween.forEach(element => {
                element.addEventListener('mouseenter', handleMouseLeave);
                element.addEventListener('mouseleave', handleMouseEnter);
            });
        },

        productCustomInformation() {
            const $customInfo = $('[data-custom-information]');
            const $thisPopup = $('#halo-product-custom-information');
            
            $customInfo.on('click', (event) => {
                const $this = $(event.currentTarget);
                const title = $this.find('.title')[0].innerText;
                const thisContent = $this.find('.product-customInformation__popup').html();

                if (thisContent === "" || thisContent == null) return;
                $thisPopup.addClass('is-show');
                $thisPopup.find('.halo-popup-title').text(title);
                $thisPopup.find('.halo-popup-content').html(thisContent);
                $body.addClass('is-custom-information');
            });

            $doc.on('click', '[data-close-custom-information]', () => {
                $body.removeClass('is-custom-information');
                $thisPopup.removeClass('is-show');
            });

            $doc.on('click', (event) => {
                if ($body.hasClass('is-custom-information')) {
                    if (($(event.target).closest('#halo-product-custom-information').length === 0) && ($(event.target).closest('[data-custom-information]').length === 0)) {
                        $body.removeClass('is-custom-information');
                    }
                }
            });
        },

        initLazyloadObserver(loadingImages, productGrid) {
            const setLazyLoaded = (target) => {
                const card = target.closest('.card')
                card.classList.add('ajax-loaded')
            }

            this.lazyloadedObserver = new MutationObserver((mutationList, observer) => {
                mutationList.forEach((mutation) => {
                    if (mutation.type == 'attributes') {
                        if (!mutation.target.classList.contains('lazyloaded')) return 
                        setLazyLoaded(mutation.target)
                    }
                })
            }) 
            
            // const parentObserver = new MutationObserver((mutationlist) => {
            //     mutationlist.forEach((mutation) => {
            //         if (mutation.type == 'childList') {
            //             const addedLoadingImages = [...mutation.addedNodes].map(node => node.querySelector('.media--loading-effect img'))
            //             addedLoadingImages.forEach(image => {
            //                 this.lazyloadedObserver.observe(image, { childList: true, attributes: true })
            //             })    
            //         }
            //     })
            // }) 
              const parentObserver = new MutationObserver((mutationlist) => {
                mutationlist.forEach((mutation) => {
                    if (mutation.type === 'childList') {
                        const addedLoadingImages = [...mutation.addedNodes]
                            .filter(node => node instanceof HTMLElement)  // Filter only HTMLElements
                            .map(node => node.querySelector('.media--loading-effect img'));
            
                        addedLoadingImages.forEach(image => {
                            if (image) {
                                this.lazyloadedObserver.observe(image, { childList: true, attributes: true });
                            }
                        });
                    }
                });
            });


            if (productGrid) parentObserver.observe(productGrid, { subtree: false, childList: true });
            if (loadingImages.length > 0) loadingImages.forEach(image => {
                if (image.classList.contains('lazyloaded')) {
                    setLazyLoaded(image)
                } else {
                    this.lazyloadedObserver.observe(image, { childList: true, attributes: true })
                }
            })
        },

        observeImageLazyloaded(images) {
            images.forEach(image => {
                this.lazyloadedObserver.observe(image, { childList: true, attributes: true })
            })
        },

        iconZoomClickMobile() {
            const iconZoom = $('.productView-iconZoom');
            iconZoom.on('click', (event) => {
                document.querySelector('.productView-image .productView-img-container .media').click();
            });
        },

        calculateTranslateYHeight() {
            const cardActions = document.querySelectorAll('.card .card-action:not(.variants-popup-form)');
            let heighest = 0;
          
            if (!cardActions.length) return;
            cardActions.forEach(cardAction => {
              cardAction.classList.add('temporary-show');
            
              const height = cardAction.clientHeight ;
              if (height > heighest) heighest = height;
  
              cardAction.classList.remove('temporary-show');
            })
            document.body.style.setProperty('--translate-y-height', heighest * -1 + 'px');
        },

        checkScrollLayoutForRecenlyViewed() {
            const RecentlyViewedSection = document.getElementById('recently-viewed-products-list-2');

            if (RecentlyViewedSection && RecentlyViewedSection.classList.contains('products-flex')) {
                const RecentlyViewedObserver = new MutationObserver((mutationList, observer) => {
                    const mutationRecentlyViewed = mutationList[0];

                    if (mutationRecentlyViewed.type == 'attributes' 
                        && mutationRecentlyViewed.target.classList.contains('recently-viewed-loaded')) {
                        const enableHover = $(mutationRecentlyViewed.target.closest('[data-recently-viewed-block]')).find('[data-enable-hover]').attr('data-enable-hover')
                        if (enableHover === 'true' && (RecentlyViewedSection.clientWidth < RecentlyViewedSection.scrollWidth)) {
                            halo.productBlockScroller($(mutationRecentlyViewed.target.closest('[data-recently-viewed-block]')));
                        }

                        observer.disconnect();
                    }
                })

                RecentlyViewedObserver.observe(RecentlyViewedSection, { attributes: true });
            }
        },
      
        clickIconScrollSection() {
            if (!document.querySelector('.arrow-icon-scroll')) return;
            let isScrollingDown = 'next';
            const sections = document.querySelectorAll('.wrapper-body .shopify-section'),
              sectionsLength = sections.length,
              sectionFirstHeight = sections[0]?.getBoundingClientRect().height || 0,
              sectionEndHeight = sections[sectionsLength - 1]?.getBoundingClientRect().height || 0,
              footerHeight = document.querySelectorAll('.shopify-section-group-footer-group')[0]?.getBoundingClientRect().height || 0;

              if (window.pageYOffset + sectionEndHeight >= document.documentElement.scrollHeight - footerHeight) loadRotateArrow('prev');
            
              $(window).scroll(function() {
                  if (window.pageYOffset + sectionEndHeight >= document.documentElement.scrollHeight - footerHeight) loadRotateArrow('prev');
                  else if (window.pageYOffset <= sectionFirstHeight/2) loadRotateArrow('next');
              });
            
              $doc.on('click', '.arrow-icon-scroll', (event) => {
                  let checkScroll = true;
                  const headerHeight = window.innerWidth > 1024 ? document.querySelectorAll('sticky-header')[0]?.getBoundingClientRect().height : document.querySelector('sticky-header-mobile')?.getBoundingClientRect().height || 0,
                    footerTop = document.querySelectorAll('.shopify-section-group-footer-group')[0]?.getBoundingClientRect().top || -1;
                
                  sections.forEach((element, index) => {
                      if (!checkScroll) return;
                      const thisTop = element.getBoundingClientRect().top;
                    
                      if (thisTop >= 0) {
                          checkScroll = false;
                        
                          if (isScrollingDown == 'next') {
                              if (element.nextElementSibling != null) scrollToSection(element.nextElementSibling.offsetTop - headerHeight);
                              sectionsLength == index + 2 || element.nextElementSibling == null ? loadRotateArrow('prev') : loadRotateArrow('next');
                          }
                          else {
                              if (element.previousElementSibling != null) scrollToSection(element.previousElementSibling.offsetTop - headerHeight);
                              index == 1 || element.previousElementSibling == null ? loadRotateArrow('next') : loadRotateArrow('prev');
                          }
                      }
                      else if (footerTop >= 0) scrollToSection(sections[sectionsLength - 1].offsetTop - headerHeight);
                  });
              });
            
              function scrollToSection(scope, rotate) {
                  window.scrollTo({top: scope, behavior: "smooth"});
              }
  
              function loadRotateArrow(rotate) {
                  isScrollingDown = rotate;
                  rotate == 'next' ? document.querySelector('.arrow-icon-scroll').classList.remove('rotate') : document.querySelector('.arrow-icon-scroll').classList.add('rotate');
              }
        },

        specialBanner() {
            const banners = document.querySelectorAll('[sticky-special-banner]'),
              wdWidth = window.innerWidth,
              wdHeight = window.innerHeight,
              headerHeight = wdWidth > 1024 ? document.querySelectorAll('sticky-header')[0]?.getBoundingClientRect().height : document.querySelector('sticky-header-mobile')?.getBoundingClientRect().height || 0;
          
            if (banners) {
                banners.forEach(element => {
                    const banner = element.querySelector('.special-banner__img'),
                      wrapperHeight = element.closest('.special-banner__wrapper').getBoundingClientRect().height,
                      bannerHeight = banner.getBoundingClientRect().height;
                  
                    let top = headerHeight || 0;
                    if (wdWidth >= 1200) {
                        if (wrapperHeight > bannerHeight) {
                            if (wdHeight > bannerHeight) top = (wdHeight - bannerHeight)/2;
                            calculateSticky(banner, top);
                        }
                    }
                    else if (wdWidth >= 768 && wdWidth < 1200) {
                        if (wrapperHeight > bannerHeight) {
                            calculateSticky(banner, top);
                        }
                    }
                    else {
                        banner.classList.remove('is-sticky');
                        banner.style.top = ``;
                    }
                });
            }

            function calculateSticky(banner, top) {
                banner.classList.add('is-sticky');
                banner.style.top = `${top}px`;
            }
        },

        specialBannerSlider() {
            const productGrid = $('.special-banner__products--grid'),
              wdWidth = window.innerWidth;
          
            if (productGrid) {
                productGrid.each(function(index, element) {
                    const $this = $(element),
                      $block = $this.closest('.special-banner__product');
                    
                    if (!$block.hasClass('ajax-loaded')) return;
                    
                    if (wdWidth < 1200) {
                        if (!$this.hasClass('slick-initialized')) {
                            $this.addClass('products-carousel');
                            specialProductSlider($block);
                        }
                    }
                    else {
                        if ($this.hasClass('slick-initialized')) {
                            $this.slick('unslick');
                            $this.removeClass('products-carousel');
                        }
                    }
                })
            }

            function specialProductSlider(wrapper) {
                let productGrid = wrapper.find('.products-carousel'),
                    itemToShow = productGrid.data('item-to-show'),
                    itemDots = productGrid.data('item-dots'),
                    itemDotsMb = productGrid.data('item-dots-mb'),
                    itemArrows = productGrid.data('item-arrows'),
                    itemArrowsMb = productGrid.data('item-arrows-mb');
    
                productGrid.slick({
                    mobileFirst: true,
                    adaptiveHeight: true,
                    infinite: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: itemArrowsMb,
                    dots: itemDotsMb,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                    responsive: 
                    [
                        {
                            breakpoint: 767,
                            settings: {
                                arrows: itemArrows,
                                dots: itemDots,
                                slidesToShow: itemToShow,
                                slidesToScroll: itemToShow,
                            }
                        }
                    ]
                });
            }
        },
      
        looklabCheckVariantInCart: function() {
          Shopify.getCart((cart) => {
              if(cart.items && cart.items.length > 0){
                $('.cart-message').remove();
                cart.items.forEach(item => {
                    let productId = item.product_id;
                    if($('.already-in-cart-'+productId).length > 0 && $('#product-variants-'+productId).length > 0 ){
                      let selectedVariantId = $('#product-variants-'+productId).val();
                      const item = cart.items.find(item => item.variant_id.toString() === selectedVariantId);
                      if (item) {
                        const message = `Already ${item.quantity} qty in cart`;
                        $('.already-in-cart-'+productId).html(`<div class="cart-message" style="margin-top: 10px; color: green;font-size: 14px;">${message}</div>`);
                      } else {
                        $('.already-in-cart-'+productId).html('');
                      }
                    }                  
                });
               // Update bundle product prices start here
                const productIdsText = $('.combo-progress-container').data('items');
               
                if (productIdsText){
                const productIds = productIdsText.split(',').map(id => parseInt(id, 10));
          
                if(productIds.length > 0){
                 
                    productIds.forEach(productId => {
                       
                        const bundleItem = $(`.bundle-product-item[data-bundle-product-item-id="${productId}"]`);
             
                        if (bundleItem.length > 0) { 
                            const priceElement = bundleItem.find('.combo-discounted-new-price');
                            const originalPriceElement = bundleItem.find('.combo-price');
    
                            let selectedVariantId = $('#product-variants-'+productId).val();
                            let itemExist = cart.items.find(item => item.variant_id.toString() === selectedVariantId);

                            if (itemExist) {
                                if(priceElement.length){
                                    if(itemExist.final_price != itemExist.original_price){
                                        const formattedPrice = Shopify.formatMoney(itemExist.final_price, window.money_format);
                                        priceElement.html(formattedPrice); 
                                    }else{
                                        priceElement.html(""); 
                                    }
                                }
    
                                if (originalPriceElement.length) {
                                    const originalFormattedPrice = Shopify.formatMoney(itemExist.original_price, window.money_format);
   
                                    if(itemExist.final_price != itemExist.original_price){
                                      originalPriceElement.html(`<s>${originalFormattedPrice}</s>`); 
                                    }else{
                                      originalPriceElement.html(originalFormattedPrice); 
                                    }
                                }
                            } else {
                                const originalFormattedPrice = Shopify.formatMoney(bundleItem.data('price'), window.money_format);
                                originalPriceElement.html(originalFormattedPrice); 
                                priceElement.html(""); 
                            }
                        }
                      // Update bundle product prices ends here

                      // Update looklab Product Page prices start here
                       const looklabProductPage = $(`.productView-product[data-product-id="${productId}"]`)
                        if(looklabProductPage.length > 0){
                          const priceElement = looklabProductPage.find('.looklab-product-new-price');
                          const originalPriceElement = looklabProductPage.find('.price-item');

                          let selectedVariantId = $('.productView-action input[name="id"]').val();
                          let itemExistLookLabProducts = cart.items.find(item => item.variant_id.toString() === selectedVariantId);
                          console.log('looklabProductPage',looklabProductPage);
                          if (itemExistLookLabProducts) {
                             console.log('itemExistLookLabProducts',itemExistLookLabProducts);
                                if(priceElement.length){
                                  console.log('priceElement',priceElement);
                                    if(itemExistLookLabProducts.final_price != itemExistLookLabProducts.original_price){
                                        const formattedPrice = Shopify.formatMoney(itemExistLookLabProducts.final_price, window.money_format);
                                        priceElement.html(formattedPrice); 
                                    }else{
                                        priceElement.html(""); 
                                    }
                                }
    
                                if (originalPriceElement.length) {
                                    const originalFormattedPrice = Shopify.formatMoney(itemExistLookLabProducts.original_price, window.money_format);
   
                                    if(itemExistLookLabProducts.final_price != itemExistLookLabProducts.original_price){
                                      originalPriceElement.html(`<s>${originalFormattedPrice}</s>`); 
                                    }else{
                                      originalPriceElement.html(originalFormattedPrice); 
                                    }
                                }
                            } else {
                                const originalFormattedPrice = Shopify.formatMoney(looklabProductPage.data('price'), window.money_format);
                                originalPriceElement.html(originalFormattedPrice); 
                                priceElement.html(""); 
                            }
                                                    
                          
                        }
                       // Update looklab Product Page prices ends here
                      
                    });
                }
                    // Cart drawer Message start
                      // Get product IDs from the hidden div
                    const allProductIdsText = document.querySelector('.looklab-product-ids').textContent.trim();
                    const allProductIds = allProductIdsText.split(',').map(id => parseInt(id, 10));
                    let totalQty = 0;
                    
                    // Sum up the quantity of matching products in the cart
                    cart.items.forEach(item => {
                        if (allProductIds.includes(item.product_id)) {
                            totalQty += item.quantity;
                        }
                    });
    
                    // Check if any scarf is in cart or not
                    const scarfsProductIdsText = $('.looklab-scarf-product-ids').html();
                    const scarfsProductIds = scarfsProductIdsText.split(',').map(id => parseInt(id, 10));
                    const scarfsInCart = cart.items.filter(item => scarfsProductIds.includes(item.product_id) && item.final_price == 0);
    
                    if(totalQty >= 3 && scarfsInCart.length == 0){
                        $('#add-scarf-cart').html(`<strong style="color: #FF0000;">Claim your FREE Scarf:</strong> Just add your favorite to the cart from this look or browse 
                        <a style="text-decoration: underline;" class="view-multiwear-products view-all-scarf-cart-drawer" data-original-text="View All Scarfs" data-label-text="Scarfs" 
                        data-tag="looklab_scarfs" data-title="Explore The Scarfs Collection" data-product-id="">All Scarfs</a>!<hr/>`);
                    }else{
                      $('#add-scarf-cart').html('');
                    }
                  // Cart drawer Message start ends

                }                
              } else {
                  $('.combo-discounted-new-price').html('')
                  $('.looklab-product-new-price').html('')
                  $('.cart-message').remove();
              }
          }); 
        },
      
       looklabView: function (){
        var multiweartitle = document.querySelector('.multiwear-title');
          
         document.addEventListener('click', function(e) {
            if (e.target.classList.contains('multiwear-product-close-popup')) {
                document.getElementById('multiwear-product-popup').style.display = 'none';
            }
        });

        document.body.addEventListener('click', function(event) {
          if (event.target.matches(".view-multiwear-products")) {
            const clickedElement = event.target; // this is the actual button clicked
            let tag = clickedElement.dataset.tag;
            let multiwear_title = clickedElement.dataset.title;
            let productIdToExclude = clickedElement.dataset.productId; // Get the product ID to exclude
            
            multiweartitle.textContent = multiwear_title;
            fetchProductsByTag(tag, productIdToExclude); // Pass the product ID to exclude
          }
        });
          
        /*document.querySelectorAll(".view-multiwear-products").forEach(function (btn) {
            btn.addEventListener("click", function () {
                let tag = this.dataset.tag;
                let multiwear_title = this.dataset.title;
                let productIdToExclude = this.dataset.productId; // Get the product ID to exclude
                
                multiweartitle.textContent = multiwear_title;
                fetchProductsByTag(tag, productIdToExclude); // Pass the product ID to exclude
            });
        });*/
        
        // document.getElementById("multiwear-product-popup").addEventListener("click", function (event) {
        //       if (event.target.classList.contains("previous-page") || event.target.classList.contains("next-page")) {
        //           event.preventDefault();
        //           let url = event.target.getAttribute("href");
        //           fetchPaginatedProducts(url);
        //       }
        //   });
          let multiwearproductpopup = document.getElementById("multiwear-product-popup");
            if (multiwearproductpopup) {
                multiwearproductpopup.addEventListener("click", function (event) {
                    if (event.target.classList.contains("previous-page") || event.target.classList.contains("next-page")) {
                        event.preventDefault();
                        let url = event.target.getAttribute("href");
                        fetchPaginatedProducts(url);
                    }
                });
            }
        
          // function fetchProductsByTag(tag) {
          //     let url = window.location.origin + '/search?type=product&view=looklab-view&q=tag:"' + tag + '"';
          
          //     fetch(url)
          //         .then(response => response.text())
          //         .then(html => {
          //              displayProducts(html);
          //         })
          //         .catch(error => console.error("Error fetching products:", error));
          // }

          function fetchProductsByTag(tag, productIdToExclude) {
              let url = `${window.location.origin}/search?type=product&view=looklab-view&q=tag:"${tag}"`;
              
              fetch(url)
                  .then(response => response.text())
                  .then(html => {
                      const parser = new DOMParser();
                      const doc = parser.parseFromString(html, "text/html");
                      
                      if(productIdToExclude != ""){
                          // Remove excluded product
                          doc.querySelectorAll(`.product[data-product-id="${productIdToExclude}"]`).forEach(el => el.remove());
                      }
                      
                      // Check if any products remain
                      const remainingProducts = doc.querySelectorAll('.product');
                      let filteredHtml;
                      
                      if (remainingProducts.length === 0) {
                          filteredHtml = `<p class="no-products-message">Not found</p>`;
                      } else {
                          filteredHtml = doc.querySelector(".all-multiwear-wrapper")?.innerHTML || html;
                      }
                      
                      displayProducts(filteredHtml);
                  })
                  .catch(error => console.error("Error fetching products:", error));
          }
          
          
          function fetchPaginatedProducts(url) {
              fetch(url)
                  .then(response => response.text()) 
                  .then(html => {
                      displayProducts(html);
                  })
                  .catch(error => console.error("Error fetching paginated products:", error));
          }
          
          function displayProducts(htmlContent) {
              looklabProgressBar();
              let container = document.getElementById("all-multiwear-products");
              container.innerHTML = htmlContent; // Replace existing content with fetched HTML
              document.getElementById("multiwear-product-popup").style.display = "flex";
              halo.lookLabSearchProductCard();
              halo.looklabCheckVariantInCart();
          }
      },  // function looklabView closed

      lookLabAddItem : function(){

          // Function to check if all variants for a specific product are out of stock
            function isProductOutOfStock(productItem) {
                const variantSelect = productItem.querySelector('select[id^="product-variants-"]');
                if (!variantSelect) return true;
                
                const options = variantSelect.querySelectorAll('option');
                let hasStock = false;
                
                options.forEach(option => {
                    const inventory = parseInt(option.getAttribute('data-inventory'));
                    if (inventory > 0) {
                        hasStock = true;
                    }
                });
                
                return !hasStock;
            }
            
            // Function to update button state based on selected swatch
            function updateButtonState(swatchElement, button) {
                const isSoldOut = swatchElement.classList.contains('soldout');
                const buttonText = button.querySelector('.button__text');
                const viewAllLink = button.closest('.bundle-product-item').querySelector('.view-multiwear-products');
                const sizeValue = swatchElement.getAttribute('data-value');
                
                // Check if the entire product is out of stock (all variants)
                const productItem = button.closest('.bundle-product-item');
                const productOutOfStock = isProductOutOfStock(productItem);
                
                if (isSoldOut || productOutOfStock) {
                    buttonText.textContent = 'Sold Out';
                    button.classList.add('button--disabled');
                    button.disabled = true;
                    
                    const quantityInput = productItem.querySelector('.quantity__input');
                    if (quantityInput) {
                        quantityInput.value = 1;
                        quantityInput.setAttribute('max', '1');
                        quantityInput.disabled = true;
                    }
                    
                    if (viewAllLink) {
                        const label = viewAllLink.dataset.labelText;
                        viewAllLink.innerHTML = productOutOfStock 
                            ? `This product is out of stock.<br>View alternatives ${label}!`
                            : `Size ${sizeValue} is out of stock.<br>View alternatives ${label}!`;
                        viewAllLink.style.fontSize = '10px';
                        viewAllLink.style.lineHeight = 'normal';
                    }
                } else {
                    buttonText.textContent = 'Add to Bag';
                    button.classList.remove('button--disabled');
                    button.disabled = false;
                    
                    const quantityInput = productItem.querySelector('.quantity__input');
                    if (quantityInput) {
                        quantityInput.disabled = false;
                        quantityInput.value = 1;
                    }
            
                    if (viewAllLink) {
                        viewAllLink.innerHTML = viewAllLink.dataset.originalText;
                        viewAllLink.style.fontSize = '';
                        viewAllLink.style.lineHeight = '';
                    }
                }
            }
            
            // Initialize all swatch elements
            document.querySelectorAll('.swatch-element').forEach(swatch => {
                swatch.addEventListener('click', function() {
                    const button = this.closest('.bundle-product-item').querySelector('.cobmo-btn-add');
                    if (button) {
                        updateButtonState(this, button);
                    }
                });
            });
            
            // Initialize all "Add to Bag" buttons with current state
            document.querySelectorAll('.cobmo-btn-add').forEach(button => {
                // Find the initially selected swatch
                const productItem = button.closest('.bundle-product-item');
                const selectedSwatch = productItem.querySelector('.swatch-element input[type="radio"]:checked')?.closest('.swatch-element');
                
                // Check if entire product is out of stock
                if (isProductOutOfStock(productItem)) {
                    button.querySelector('.button__text').textContent = 'Sold Out';
                    button.classList.add('button--disabled');
                    button.disabled = true;
                    
                    const viewAllLink = productItem.querySelector('.view-multiwear-products');
                    if (viewAllLink) {
                        const label = viewAllLink.dataset.labelText;
                        viewAllLink.innerHTML = `This product is out of stock.<br>View alternatives ${label}!`;
                        viewAllLink.style.fontSize = '10px';
                        viewAllLink.style.lineHeight = 'normal';
                    }
                } 
                else if (selectedSwatch) {
                    updateButtonState(selectedSwatch, button);
                }
            
                button.addEventListener('click', function(e) {
                    if (this.disabled) {
                        e.preventDefault();
                        return;
                    }
            
                    this.classList.add('button--loading');
                    
                    const productItem = this.closest('.bundle-product-item');
                    const selectElement = productItem.querySelector('select[name="group_id"]');
                    const selectedOption = selectElement.options[selectElement.selectedIndex];
                    const variantId = selectElement.value;
                    const quantityInput = productItem.querySelector('.quantity__input');
                    let quantity = parseInt(quantityInput.value) || 1;
                    
                    // Check inventory from data-inventory attribute
                    const totalInventory = parseInt(selectedOption.getAttribute('data-inventory'));
                    
                    if (totalInventory === 0) {
                        halo.showWarning('This item is out of stock');
                        this.classList.remove('button--loading');
                        return;
                    }
                    
                    // Check cart quantities ONLY when adding to cart
                    Shopify.getCart((cart) => {
                        const cartItem = cart.items.find(item => item.variant_id.toString() === variantId);
                        const quantityInCart = cartItem ? cartItem.quantity : 0;
                        const availableInventory = totalInventory - quantityInCart;
                        
                        if (quantity > availableInventory) {
                            halo.showWarning(`Error: You cannot add more of the items into the cart`);
                            this.classList.remove('button--loading');
                            return;
                        }
                        
                        addComoboItem(variantId, quantity, this);
                    });
                });
            });
            
            // Quantity selector controls (without cart checks)
            document.querySelectorAll('.qty-selector-wrapper').forEach(container => {
                const input = container.querySelector('.quantity__input');
                const minusBtn = container.querySelector('.minus');
                const plusBtn = container.querySelector('.plus');
                
                // Get the max inventory from data attribute only
                const getMaxInventory = () => {
                    const productItem = container.closest('.bundle-product-item');
                    const selectElement = productItem.querySelector('select[name="group_id"]');
                    const selectedOption = selectElement.options[selectElement.selectedIndex];
                    return parseInt(selectedOption.getAttribute('data-inventory'));
                };
                
                // Minus button - decrease quantity (minimum 1)
                minusBtn.addEventListener('click', () => {
                    if (input.disabled) return;
                    let value = parseInt(input.value) || 1;
                    input.value = Math.max(1, value - 1);
                });
                
                // Plus button - increase quantity if within total inventory
                plusBtn.addEventListener('click', () => {
                    if (input.disabled) return;
                    const maxInventory = getMaxInventory();
                    let value = parseInt(input.value) || 1;
                    
                    if (value < maxInventory) {
                        input.value = value + 1;
                    } else {
                        halo.showWarning(`You can only add ${maxInventory} of this product to your cart`);
                    }
                });
                
                // Input validation (only checks against total inventory)
                input.addEventListener('change', function() {
                    if (this.disabled) return;
                    const maxInventory = getMaxInventory();
                    let value = parseInt(this.value) || 1;
                    
                    if (value > maxInventory) {
                        halo.showWarning(`You can only add ${maxInventory} of this product to your cart`);
                        this.value = maxInventory;
                    } else if (value < 1) {
                        this.value = 1;
                    }
                });
            });
            
            function addComoboItem(variantId, quantity, button) {
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: quantity
                    })
                })
                .then(response => response.json())
                .then(data => {
                    button.classList.remove('button--loading');
                    Shopify.getCart((cart) => {
                        $body.addClass('cart-sidebar-show');
                        halo.updateSidebarCart(cart);
                    });
                })
                .catch(error => {
                    halo.showWarning(error);
                    button.classList.remove('button--loading');
                });
            }
            
            // Initialize all products on page load
            document.querySelectorAll('.bundle-product-item').forEach(productItem => {
                if (isProductOutOfStock(productItem)) {
                    const button = productItem.querySelector('.cobmo-btn-add');
                    if (button) {
                        button.querySelector('.button__text').textContent = 'Sold Out';
                        button.classList.add('button--disabled');
                        button.disabled = true;
                        
                        const viewAllLink = productItem.querySelector('.view-multiwear-products');
                        if (viewAllLink) {
                            const label = viewAllLink.dataset.labelText;
                            viewAllLink.innerHTML = `This product is out of stock.<br>View alternatives ${label}!`;
                            viewAllLink.style.fontSize = '10px';
                            viewAllLink.style.lineHeight = 'normal';
                        }
                    }
                    
                    const quantityInput = productItem.querySelector('.quantity__input');
                    if (quantityInput) {
                        quantityInput.disabled = true;
                    }
                }
            });
          
        
          // Function to update button state based on selected swatch
          // function updateButtonState(swatchElement, button) {
          //     const isSoldOut = swatchElement.classList.contains('soldout');
          //     const buttonText = button.querySelector('.button__text');
          //     const viewAllLink = button.closest('.bundle-product-item').querySelector('.view-multiwear-products');
          //     const sizeValue = swatchElement.getAttribute('data-value'); // Get the size (e.g., "16")
          //     //console.log('Selected value:', sizeValue, 'Sold out:', isSoldOut);
              
          //     if (isSoldOut) {
          //         buttonText.textContent = 'Sold Out';
          //         button.classList.add('button--disabled');
          //         button.disabled = true;
          //         const quantityInput = button.closest('.bundle-product-item').querySelector('.quantity__input');
          //         quantityInput.value = 1;
          //         quantityInput.setAttribute('max', '1');
          //          if (viewAllLink) {
          //             const label =  viewAllLink.dataset.labelText
          //               viewAllLink.innerHTML = `Size ${sizeValue} is out of stock.<br> View alternatives ${label}!`;
          //               viewAllLink.style.fontSize = '10px';
          //               viewAllLink.style.lineHeight = 'normal';
          //           }
                
          //     } else {
          //         buttonText.textContent = 'Add to Bag';
          //         button.classList.remove('button--disabled');
          //         button.disabled = false;
          //         const quantityInput = button.closest('.bundle-product-item').querySelector('.quantity__input');
          //         quantityInput.value = 1;

          //         if (viewAllLink) {
          //             viewAllLink.innerHTML = viewAllLink.dataset.originalText;
          //             viewAllLink.style.fontSize = '';
          //             viewAllLink.style.lineHeight = ''
          //         }
                
          //     }
          // }
          
          // // Initialize all swatch elements
          // document.querySelectorAll('.swatch-element').forEach(swatch => {
          //     swatch.addEventListener('click', function() {
          //         // Find the corresponding add button
          //         const button = this.closest('.bundle-product-item').querySelector('.cobmo-btn-add');
          //         if (button) {
          //             updateButtonState(this, button);
          //         }
          //     });
          // });
          
          // // Initialize all "Add to Bag" buttons with current state
          // document.querySelectorAll('.cobmo-btn-add').forEach(button => {
          //     // Find the initially selected swatch
          //     const productItem = button.closest('.bundle-product-item');
          //     const selectedSwatch = productItem.querySelector('.swatch-element input[type="radio"]:checked')?.closest('.swatch-element');
              
          //     if (selectedSwatch) {
          //         updateButtonState(selectedSwatch, button);
          //     }
          
          //     button.addEventListener('click', function() {
          //         if (this.disabled) return;
          
          //         this.classList.add('button--loading');
                  
          //        // console.log('cobmo-btn-add clicked');
          //         const productItem = this.closest('.bundle-product-item');
          //         const selectElement = productItem.querySelector('select[name="group_id"]');
          //         const selectedOption = selectElement.options[selectElement.selectedIndex];
          //         const variantId = selectElement.value;
          //         const quantityInput = productItem.querySelector('.quantity__input');
          //         let quantity = parseInt(quantityInput.value) || 1;
                  
          //         // Check inventory from data-inventory attribute
          //         const totalInventory = parseInt(selectedOption.getAttribute('data-inventory'));
                  
          //         if (totalInventory === 0) {
          //             halo.showWarning('This item is out of stock');
          //             this.classList.remove('button--loading');
          //             return;
          //         }
                  
          //         // Check cart quantities ONLY when adding to cart
          //         Shopify.getCart((cart) => {
          //             const cartItem = cart.items.find(item => item.variant_id.toString() === variantId);
          //             const quantityInCart = cartItem ? cartItem.quantity : 0;
          //             const availableInventory = totalInventory - quantityInCart;
                      
          //             if (quantity > availableInventory) {
          //                 halo.showWarning(`Error: You cannot add more of the items into the cart`);
          //                 this.classList.remove('button--loading');
          //                 return;
          //             }
                      
          //             addComoboItem(variantId, quantity, this);
          //         });
          //     });
          // });
          
          // // Quantity selector controls (without cart checks)
          // document.querySelectorAll('.quantity_selector').forEach(container => {
          //     const input = container.querySelector('.quantity__input');
          //     const minusBtn = container.querySelector('.minus');
          //     const plusBtn = container.querySelector('.plus');
              
          //     // Get the max inventory from data attribute only
          //     const getMaxInventory = () => {
          //         const productItem = container.closest('.bundle-product-item');
          //         const selectElement = productItem.querySelector('select[name="group_id"]');
          //         const selectedOption = selectElement.options[selectElement.selectedIndex];
          //         return parseInt(selectedOption.getAttribute('data-inventory'));
          //     };
              
          //     // Minus button - decrease quantity (minimum 1)
          //     minusBtn.addEventListener('click', () => {
          //         let value = parseInt(input.value) || 1;
          //         input.value = Math.max(1, value - 1);
          //     });
              
          //     // Plus button - increase quantity if within total inventory
          //     plusBtn.addEventListener('click', () => {
          //         const maxInventory = getMaxInventory();
          //         let value = parseInt(input.value) || 1;
                  
          //         if (value < maxInventory) {
          //             input.value = value + 1;
          //         } else {
          //             halo.showWarning(`You can only add ${maxInventory} of this product to your cart`);
          //         }
          //     });
              
          //     // Input validation (only checks against total inventory)
          //     input.addEventListener('change', function() {
          //         const maxInventory = getMaxInventory();
          //         let value = parseInt(this.value) || 1;
                  
          //         if (value > maxInventory) {
          //             halo.showWarning(`You can only add ${maxInventory} of this product to your cart`);
          //             this.value = maxInventory;
          //         } else if (value < 1) {
          //             this.value = 1;
          //         }
          //     });
          // });
          
          // function addComoboItem(variantId, quantity, button) {
          //     fetch('/cart/add.js', {
          //         method: 'POST',
          //         headers: {
          //             'Content-Type': 'application/json',
          //             'Accept': 'application/json'
          //         },
          //         body: JSON.stringify({
          //             id: variantId,
          //             quantity: quantity
          //         })
          //     })
          //     .then(response => response.json())
          //     .then(data => {
          //         //console.log('Item added to cart:', data);
          //         button.classList.remove('button--loading');
          //         Shopify.getCart((cart) => {
          //             $body.addClass('cart-sidebar-show');
          //             halo.updateSidebarCart(cart);
          //         });
          //     })
          //     .catch(error => {
          //        // console.error('Error adding item to cart:', error);
          //         halo.showWarning(error);
          //         button.classList.remove('button--loading');
          //     });
          // }

      }, // function lookLabAddItem closed

      lookLabSearchProductCard: function(){

            // Event delegation for dynamically loaded cards
          document.addEventListener('click', function(e) {
            // Handle radio button changes
            if (e.target.matches('.product-card-looklab-view-search input[type="radio"]')) {

               e.preventDefault(); 
              e.stopPropagation(); 
              e.stopImmediatePropagation();
              
              const card = e.target.closest('.product-card-looklab-view-search');
              
              const clickedRadio = e.target;
              const optionGroupRadios = card.querySelectorAll(`input[type="radio"][name="${clickedRadio.name}"]`);
              
              // Remove active class from all radios in this group
              optionGroupRadios.forEach(radio => {
                  radio.classList.remove('active');
                  //const label = card.querySelector(`label[for="${radio.id}"]`);
                  //if (label) label.classList.remove('active');
              });
              
              // Add active class to clicked radio and its label
              clickedRadio.classList.add('active');
             // const label = card.querySelector(`label[for="${clickedRadio.id}"]`);
             // if (label) label.classList.add('active');
              
              updateVariantSelect(card);
              checkStockStatus(card);
            }
            
            // Handle plus button
              if (e.target.matches('.product-card-looklab-view-search .plus.btn-quantity')) {
                    e.preventDefault(); 
                    e.stopPropagation(); 
                    e.stopImmediatePropagation(); 
              
                  const card = e.target.closest('.product-card-looklab-view-search');
                  if (!card) return; // Exit if card not found
              
                  const quantityInput = card.querySelector('.quantity__input');
                  if (!quantityInput) return; // Exit if input not found
              
                  const max = parseInt(quantityInput.getAttribute('max')) || Infinity;
                  const current = parseInt(quantityInput.value) || 1;
              
                  if (current < max) {
                      quantityInput.value = current + 1; // Increase by 1
                  } else {
                      halo.showWarning(`You can only add ${max} of this product to your cart`);
                  }
              }
              
              // Handle minus button 
              if (e.target.matches('.product-card-looklab-view-search .minus.btn-quantity')) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
              
                  const card = e.target.closest('.product-card-looklab-view-search');
                  if (!card) return;
              
                  const quantityInput = card.querySelector('.quantity__input');
                  if (!quantityInput) return;
              
                  const current = parseInt(quantityInput.value) || 1;
                  quantityInput.value = Math.max(current - 1, 1); // Decrease by 1 (minimum 1)
              }
            
            // Handle add to cart button
            if (e.target.matches('.product-card-looklab-view-search .looklab-view-search-add-button')) {
               e.preventDefault(); 
              e.stopPropagation(); 
              e.stopImmediatePropagation();
              const card = e.target.closest('.product-card-looklab-view-search');
              const variantSelect = card.querySelector('.variant-selector-looklab-view-search');
              const quantityInput = card.querySelector('.quantity__input');
              const variantId = variantSelect.value;
              const quantity = parseInt(quantityInput.value) || 1;
              
              if (!variantId || e.target.disabled) return;
              
              // Get inventory data from the selected variant option
              const selectedOption = variantSelect.querySelector(`option[value="${variantId}"]`);
              const totalInventory = parseInt(selectedOption.dataset.inventory) || 0;
              
              // Check cart inventory before adding
              checkCartInventoryBeforeAdd(variantId, quantity, totalInventory, e.target);
            }
          });
          
          // Also handle change events for radios (for keyboard navigation)
          // document.addEventListener('change', function(e) {
          //   if (e.target.matches('.product-card-looklab-view-search input[type="radio"]')) {
          //     const card = e.target.closest('.product-card-looklab-view-search');
          //     updateVariantSelect(card);
          //     checkStockStatus(card);
          //   }
          // });
          
          // Initialize any existing cards on page load
          document.querySelectorAll('.product-card-looklab-view-search').forEach(card => {
            updateVariantSelect(card);
            checkStockStatus(card);
          });
          
          function updateVariantSelect(card) {
            const variantSelect = card.querySelector('.variant-selector-looklab-view-search');
            const selectedOptions = [];
            
            // Get all selected options
            card.querySelectorAll('input[type="radio"]:checked').forEach(radio => {
                selectedOptions.push(radio.value);
                const fieldsetWrapper = radio.closest('.fieldset-wrapper .product-form__input');
                if (fieldsetWrapper) {
                    const legend = fieldsetWrapper.querySelector('legend.form__label');
                    if (legend) {
                        const headerOptionSpan = legend.querySelector('[data-header-option]');
                        if (headerOptionSpan) {
                            headerOptionSpan.textContent = radio.value;
                        }
                    }
                }
            });
            
            // Find matching variant
            let selectedVariant = null;
            card.querySelectorAll('.variant-selector-looklab-view-search option').forEach(option => {
              const variantTitle = option.textContent.trim();
              const matchesAllOptions = selectedOptions.every(opt => variantTitle.includes(opt));
              
              if (matchesAllOptions && !selectedVariant) {
                selectedVariant = option.value;
                selectedVariantImage = option.dataset.image;
                // Update inventory data on quantity input
                const inventory = parseInt(option.dataset.inventory) || 0;
                const quantityInput = card.querySelector('.quantity__input');
                quantityInput.setAttribute('max', inventory);
                
                // Adjust current quantity if exceeds inventory
                const currentQty = parseInt(quantityInput.value) || 1;
                if (inventory > 0 && currentQty > inventory) {
                  quantityInput.value = inventory;
                }
              }
            });
            
              // Update select value
              if (selectedVariant) {
                variantSelect.value = selectedVariant;
                  if (selectedVariantImage) {
                    const productImage = card.querySelector('.view-search-image');
                    if (productImage) {
                      productImage.src = selectedVariantImage;
                    }
                  }
              }
          }
          
          function checkStockStatus(card) {
            const addToCartBtn = card.querySelector('.looklab-view-search-add-button');
            const variantSelect = card.querySelector('.variant-selector-looklab-view-search');
            const selectedVariant = variantSelect.value;
            
            // Check if any selected radio has 'soldout' class
            const hasSoldOutOption = card.querySelector('input[type="radio"]:checked + .product-form__label.soldout');
            const isOutOfStock = !selectedVariant || hasSoldOutOption;
            
            addToCartBtn.disabled = isOutOfStock;
            addToCartBtn.textContent = isOutOfStock ? 'Sold Out' : 'Add to bag';
            
            // Update quantity input if out of stock
            if (isOutOfStock) {
              const quantityInput = card.querySelector('.quantity__input');
              quantityInput.value = 1;
              quantityInput.setAttribute('max', '1');
            }
          }
          
          function checkCartInventoryBeforeAdd(variantId, quantity, totalInventory, button) {
            // Show loading state
            const originalText = button.textContent;
            button.disabled = true;
            button.classList.add('button--loading');
            
            // First get current cart
            Shopify.getCart(function(cart) {
              const cartItem = cart.items.find(item => item.variant_id.toString() === variantId);
              const quantityInCart = cartItem ? cartItem.quantity : 0;
              const availableInventory = totalInventory - quantityInCart;
              
              // Check if we have enough inventory
              if (totalInventory > 0 && quantity > availableInventory) {
                button.textContent = originalText;
                button.classList.remove('button--loading');
                button.disabled = false;
                halo.showWarning(`Error: You cannot add more of the items into the cart`);
                return;
              }
              
              // If inventory check passes, proceed with add to cart
              addToCartWithInventoryCheck(variantId, quantity, button);
            });
          }
          
          function addToCartWithInventoryCheck(variantId, quantity, button) {
           
            
            // Shopify AJAX API call to add to cart
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                id: variantId,
                quantity: quantity
              })
            })
            .then(response => response.json())
            .then(data => {
              // Refresh cart in sidebar
              Shopify.getCart((cart) => {
                
               if($body.hasClass('template-cart')){
                halo.updateCart(cart);
                }else{
                   $body.addClass('cart-sidebar-show');
                   halo.updateSidebarCart(cart);
                }
                
              });
            })
            .catch(error => {
              //console.error('Error adding to cart:', error);
              halo.showWarning(error);
            })
            .finally(() => {
              button.textContent = 'Add to bag';
              button.classList.remove('button--loading');
              button.disabled = false;
            });
          }
            
      }, // function lookLabSearchProductCard closed

      lookLabAddAllItemInCart: function(){
        
        function areAllVariantsOutOfStock() {
            const allProductItems = document.querySelectorAll('.bundle-product-item.isChecked');
            let allOutOfStock = true;
        
            // Loop through each product item in the bundle
            allProductItems.forEach(item => {
                const variantSelect = item.querySelector('select[id^="product-variants-"]');
                
                if (variantSelect) {
                    const options = variantSelect.querySelectorAll('option');
                    let productHasStock = false;
        
                    // Check each variant option for this product
                    options.forEach(option => {
                        const inventory = parseInt(option.getAttribute('data-inventory'));
                        if (inventory > 0) {
                            productHasStock = true;
                        }
                    });
        
                    // If any product has at least one variant in stock, set flag to false
                    if (productHasStock) {
                        allOutOfStock = false;
                    }
                }
            });
        
            return allOutOfStock;
        }
        // Disable add to cart button initially if all variants are out of stock
        const addToCartButton = document.querySelector('[data-combo-addtocart]');
        if (addToCartButton && areAllVariantsOutOfStock()) {
            addToCartButton.disabled = true;
            addToCartButton.classList.add('disabled');
            //addToCartButton.title = 'All items are currently out of stock';
        }

        let datacomboaddtocartbutton = document.querySelector('[data-combo-addtocart]');
        if (datacomboaddtocartbutton){
        datacomboaddtocartbutton.addEventListener('click', async function(e) {
          e.preventDefault();
          
          const addButton = e.currentTarget; // Get the clicked button
          const originalButtonText = addButton.value; // Store original button text
          
          // Disable button and show loading state
          addButton.disabled = true;
          addButton.value = 'Adding...'; // Or use a spinner if preferred
          
          // Clear previous highlights and messages
          document.querySelectorAll('.error-highlight').forEach(el => el.classList.remove('error-highlight'));
          let errorMessages = [];
          let itemsToSkip = [];
        
          try {
            // Get current cart first
            const cart = await new Promise(resolve => Shopify.getCart(resolve));
            
            // Process each product in the combo
            const productItems = Array.from(document.querySelectorAll('.bundle-product-item.isChecked'));
            
            // First pass: Validate all items and identify which to skip
            for (const item of productItems) {
              const variantSelect = item.querySelector('select[id^="product-variants-"]');
              const variantId = variantSelect.value;
              const selectedOption = variantSelect.querySelector(`option[value="${variantId}"]`);
              const inventory = parseInt(selectedOption.getAttribute('data-inventory'));
              const quantity = parseInt(item.querySelector('input[id^="quantity-"]').value) || 1;
              const productName = item.querySelector('.card-title').textContent.trim();
          
              // Check inventory
              if (inventory <= 0) {
                errorMessages.push(`${productName} is out of stock. Please select a different variant.(skipping this item)`);
                item.classList.add('error-highlight');
                itemsToSkip.push(variantId);
                continue;
              }
          
              // Find matching cart item
              const cartItem = cart.items.find(ci => ci.variant_id.toString() === variantId.toString());
              
              if (cartItem) {
                const totalQty = cartItem.quantity + quantity;
                const availableQty = inventory - cartItem.quantity;
                
                if (cartItem.quantity >= inventory) {
                  errorMessages.push(`All available stock (${inventory}) of ${productName} is already in your cart (skipping this item)`);
                  item.classList.add('error-highlight');
                  itemsToSkip.push(variantId);
                } 
                else if (totalQty > inventory) {
                  errorMessages.push(`You cannot add more than ${availableQty} of ${productName} (skipping this item)`);
                  item.classList.add('error-highlight');
                  itemsToSkip.push(variantId);
                }
              }
            }
          
            // Prepare items to add (excluding skipped ones)
            const itemsToAdd = productItems
              .filter(item => {
                const variantId = item.querySelector('select[id^="product-variants-"]').value;
                return !itemsToSkip.includes(variantId);
              })
              .map(item => ({
                id: item.querySelector('select[id^="product-variants-"]').value,
                quantity: parseInt(item.querySelector('input[id^="quantity-"]').value) || 1
              }));
          
            // Show warnings if any (but still proceed if some items are valid)
            if (errorMessages.length > 0) {
              //console.log('Validation messages:', errorMessages);
              halo.showWarning(errorMessages.join('<br>'));
              
              // If ALL items are invalid, don't proceed
              if (itemsToAdd.length === 0) {
                addButton.disabled = false;
                addButton.value = originalButtonText;
                return;
              }
            }
          
            // Add valid items to cart
            if (itemsToAdd.length > 0) {
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: itemsToAdd })
              });
              
              // Refresh cart in sidebar
              await new Promise(resolve => {
                Shopify.getCart((cart) => {
                  $body.addClass('cart-sidebar-show');
                  halo.updateSidebarCart(cart);
                  resolve();
                });
              });
            }
          } catch (error) {
            //console.error('Error:', error);
            halo.showWarning('There was an error adding items to your cart. Please try again.');
          } finally {
            // Re-enable button in all cases
            addButton.disabled = false;
            addButton.value = originalButtonText;
          }
        });
      }
        
        
      }, //function lookLabAddAllItemInCart closed

      
      looklabProductVariantSwitch: function(){
        
        //window.pageVariantIds defined in global-script.liquid file
        
        if (!window.pageVariantIds || window.pageVariantIds.length === 0) return;

          let variantIds = window.pageVariantIds.map(id => id.trim());
        
          document.querySelectorAll(".single-option-selector.option").forEach(input => {
            let variantId = input.getAttribute("data-variant")?.trim();
        
            if (variantIds.includes(variantId)) {
              let productContainer = input.closest(".bundlePdItem-container"); // Updated selector
              if (productContainer) {
                let selectElement = productContainer.querySelector("select[name='group_id']");
                if (selectElement) {
                  //console.log("Page Variant Before update:", selectElement.value);
        
                  // Update the select value
                  selectElement.value = variantId;
        
                  //console.log("Page Variant After update:", selectElement.value);
        
                  // Get the selected option element
                  let selectedOption = selectElement.querySelector(`option[value="${variantId}"]`);
                  if (selectedOption) {
                    let variantImage = selectedOption.getAttribute("data-image");
        
                    if (variantImage) { // Skip if variantImage is null or empty
                      // console.log("Variant Image URL:", variantImage);
        
                      // Find the image inside .bundle-product-image and update src & srcset
                      let productImage = productContainer.querySelector(".bundle-product-image img");
                      if (productImage) {
                        productImage.src = `${variantImage}`;
                        productImage.srcset = `${variantImage}`;
                        // console.log("Updated Image src & srcset:", productImage.src);
                      } else {
                        // console.warn("No image found in .bundle-product-image");
                      }
                    } else {
                      // console.warn(`Skipping variant ${variantId} - No image found.`);
                    }
                  }
        
                  // Fire both 'change' and 'input' events
                  setTimeout(() => {
                    // console.log("Triggering change event for:", selectElement.value);
                    selectElement.dispatchEvent(new Event("change", { bubbles: true }));
                    selectElement.dispatchEvent(new Event("input", { bubbles: true }));
                  }, 100);
                }
              }
        
              // Now trigger the radio button click after a slight delay
              setTimeout(() => {
                input.click();
                // console.log("Clicked radio input with variant:", variantId);
              }, 100);
            }
          });
      }, //function looklabProductVariantSwitch closed

      availableInLooks: function(){
        
        var popup_heading = $('.multiwear-title');
         $(document).on('click', '.available-look-fetch', function(e) {
            e.preventDefault();
          
            let sku = $(this).data('sku');
            let title = $(this).data('title');
            const currentProductId = $(this).data('current-product-id');
           
            const url = `${window.location.origin}/search?type=product&view=available-in-looks&q=variants.sku:"${sku}"`;
           
            let combinedHeading = sku + ' - ' + title;
           
            popup_heading.html(combinedHeading);

           
            $.get(url, function(response) {
              const $response = $('<div>').html(response);          
              // Remove any product card that has a matching data-current-product-id
              $response.find(`.available-in-looks[data-product-id="${currentProductId}"]`).remove();
              
              $('#all-multiwear-products').html($response.html());
              $('.add-scarf-message-popup').html('');
              halo.lookLabSearchProductCard();
              halo.looklabCheckVariantInCart();
                            
              document.getElementById("multiwear-product-popup").style.display = "flex";

              
              
            });
          });

      }, //function availableInLooks closed

      // Gift Bag Auto Add if Cart has Goddiva seller product
      giftBagForGoddiva: function () {
        const giftBagVariantId = window.giftBagStatus.variantId;

        if (giftBagVariantId == null || giftBagVariantId === '') {
         return;
        }
        
        Shopify.getCart((cart) => {
          const allowedVendors = ['Goddiva', 'Goddiva Plus', 'City Goddess', 'Danaya', 'Cosmochic','Goddiva denim'];
          const hasGoddiva = cart.items.some(item => allowedVendors.includes(item.vendor));

          const hasGiftBag = cart.items.some(item =>
            item.variant_id === giftBagVariantId
          );

          const sameItem = cart.items.some(item =>
            item.variant_id === 55164949627255
          );

          

            $doc.on('click', `[data-cart-remove-id="${giftBagVariantId}"]`, () => {
                console.log('data-cart-remove click called');
                sessionStorage.setItem('giftBagRemoved', giftBagVariantId);
            });

            let isRemoved = sessionStorage.getItem('giftBagRemoved');
            

          if (hasGoddiva && !hasGiftBag && !sameItem && window.giftBagStatus.available && !isRemoved) {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: giftBagVariantId,
                quantity: 1
              })
            }).then(() => {
               console.log('Gift Bag Added');
                setTimeout(() => {
                 document.getElementById('gift-bag-popup').classList.add('show');
                 document.body.classList.add('modal-open');
                 
                  Shopify.getCart((updatedCart) => {
                    if ($body.hasClass('template-cart')) {
                    location.reload();
                    } else {
                    halo.updateSidebarCart(updatedCart);
                    }
                    $body.find('[data-cart-count]').text(updatedCart.item_count);
                  });
              }, 500);
            });
          } else if (!window.giftBagStatus.available) {
            halo.showWarning(`We're sorry! The Gift Bag is out of stock and wasn't added to your cart.`);
          }
        });
      },
      removeGiftBagIfNeeded: function (cartData) {
            const giftBagVariantId = window.giftBagStatus?.variantId;
            if (!giftBagVariantId) return;

            var doRemoval = function(cart) {
                const allowedVendors = ['Goddiva', 'Goddiva Plus', 'City Goddess', 'Danaya', 'Cosmochic', 'Goddiva denim'];
                const giftBagItem = cart.items.find(item => item.variant_id == giftBagVariantId);
                const hasGoddiva = cart.items.some(item => 
                    item.variant_id != giftBagVariantId && allowedVendors.includes(item.vendor)
                );

                if (!hasGoddiva && giftBagItem) {
                    fetch('/cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ 
                            id: giftBagItem.key,
                            quantity: 0 
                        })
                    }).then(() => {
                        console.log('Gift Bag Removed - no qualifying items in cart');
                        sessionStorage.removeItem('giftBagRemoved');
                        Shopify.getCart((updatedCart) => {
                            if ($body.hasClass('template-cart')) {
                                location.reload();
                            } else {
                                halo.updateSidebarCart(updatedCart);
                            }
                            $body.find('[data-cart-count]').text(updatedCart.item_count);
                        });
                    });
                }
            };

            // If cart data is passed directly, use it. Otherwise fetch fresh.
            if (cartData && cartData.items) {
                doRemoval(cartData);
            } else {
                Shopify.getCart(doRemoval);
            }
        },
        restrictGiftBagQuantity: function () {
            const giftBagVariantId = window.giftBagStatus?.variantId;
            if (!giftBagVariantId) return;

            // Cart page quantity input
            $doc.off('change.giftBagQty').on('change.giftBagQty', `[data-cart-quantity-id="${giftBagVariantId}"]`, function (e) {
                var quantity = parseInt($(this).val());
                if (quantity > 1) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    halo.showWarning('You can only add 1 Gift Bag per order.');
                    $(this).val(1);
                    return false;
                }
            });

            // Cart page plus button for gift bag
            $doc.off('click.giftBagPlus').on('click.giftBagPlus', `cart-update-quantity[data-variant="${giftBagVariantId}"] .plus`, function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                halo.showWarning('You can only add 1 Gift Bag per order.');
                return false;
            });
        }, 
      // function giftBagForGoddiva closed

        initHomeFAQ: function () {
            $('.home-faq-section').each(function () {
                var $section  = $(this);
                var sectionId = $section.data('section-id');
                if (!sectionId) return;

                var $faqList             = $section.find('.faq-list');
                var mobileBreakpoint     = 768;
                var faqSliderInitialized = false;

                var mobileAutoplay        = $section.data('mobile-autoplay') === true || $section.data('mobile-autoplay') === 'true';
                var mobileAutoplaySpeedMs = parseInt($section.data('mobile-autoplay-speed'), 10) || 3000;
                var mobileArrows          = $section.data('mobile-arrows') === true || $section.data('mobile-arrows') === 'true';
                var mobileDots            = $section.data('mobile-dots') === true || $section.data('mobile-dots') === 'true';

                function enableAccordion() {
                    $section.find('.faq-question').each(function () {
                        var $q = $(this);
                        $q.removeClass('active').attr('aria-expanded', 'false');
                        $q.next('.faq-answer').hide().attr('aria-hidden', 'true');
                        $q.find('.faq-chevron').css('transform', 'rotate(0deg)');
                    });

                    $section.find('.faq-question').off('click.faq').on('click.faq', function (e) {
                        e.preventDefault();
                        var $btn = $(this);
                        var $ans = $btn.next('.faq-answer');

                        if ($btn.hasClass('active')) {
                            $btn.removeClass('active').attr('aria-expanded', 'false');
                            $ans.stop(true, true).slideUp(220).attr('aria-hidden', 'true');
                            $btn.find('.faq-chevron').css('transform', 'rotate(0deg)');
                        } else {
                            $section.find('.faq-question.active').not($btn).each(function () {
                                var $other = $(this);
                                $other.removeClass('active').attr('aria-expanded', 'false');
                                $other.next('.faq-answer').stop(true, true).slideUp(220).attr('aria-hidden', 'true');
                                $other.find('.faq-chevron').css('transform', 'rotate(0deg)');
                            });
                            $btn.addClass('active').attr('aria-expanded', 'true');
                            $ans.stop(true, true).slideDown(220).attr('aria-hidden', 'false');
                            $btn.find('.faq-chevron').css('transform', 'rotate(180deg)');
                        }
                    });
                }

                function destroyAccordion() {
                    $section.find('.faq-question').off('click.faq').removeClass('active').attr('aria-expanded', 'false');
                    $section.find('.faq-question').next('.faq-answer').show().attr('aria-hidden', 'false');
                    $section.find('.faq-question .faq-chevron').css('transform', 'rotate(0deg)');
                }

                function initMobileSlider() {
                    if (!faqSliderInitialized) {
                        $section.find('.faq-answer').show().attr('aria-hidden', 'false');
                        $faqList.slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: mobileDots,
                            arrows: mobileArrows,
                            infinite: false,
                            adaptiveHeight: true,
                            autoplay: mobileAutoplay,
                            autoplaySpeed: mobileAutoplaySpeedMs,
                            prevArrow: mobileArrows ? window.arrows && window.arrows.icon_prev : false,
                            nextArrow: mobileArrows ? window.arrows && window.arrows.icon_next : false
                        });
                        faqSliderInitialized = true;
                    }
                }

                function destroyMobileSlider() {
                    if (faqSliderInitialized && $faqList.hasClass('slick-initialized')) {
                        $faqList.slick('unslick');
                        faqSliderInitialized = false;
                    }
                }

                function setupByWidth() {
                    var w = $win.width();
                    if (w < mobileBreakpoint) {
                        destroyAccordion();
                        initMobileSlider();
                    } else {
                        destroyMobileSlider();
                        $section.find('.faq-answer').hide().attr('aria-hidden', 'true');
                        enableAccordion();
                    }
                }
                setupByWidth();

                var resizeTimeout;
                $win.on('resize.faq-' + sectionId, function () {
                    clearTimeout(resizeTimeout);
                    resizeTimeout = setTimeout(setupByWidth, 160);
                });

                /* Popup (scoped per section) */
                var $overlay = $section.find('.faq-popup-overlay');
                var $popup   = $section.find('.faq-popup');

                function openPopup() {
                    $overlay.addClass('visible').attr('aria-hidden', 'false');
                    requestAnimationFrame(function () {
                        $popup.addClass('active').attr('aria-hidden', 'false');
                        setTimeout(function () {
                            $popup.find('a, button, [tabindex]').filter(':visible').first().focus();
                        }, 260);
                    });
                }

                function closePopup() {
                    $popup.removeClass('active').attr('aria-hidden', 'true');
                    $overlay.removeClass('visible').attr('aria-hidden', 'true');
                    $section.find('#track-order-btn').focus();
                }

                $section.find('#track-order-btn').off('click.faq').on('click.faq', function (e) {
                    e.preventDefault();
                    openPopup();
                });
                $section.find('.faq-popup-close').off('click.faq').on('click.faq', function (e) {
                    e.preventDefault();
                    closePopup();
                });
                $overlay.off('click.faq').on('click.faq', function () {
                    closePopup();
                });

                $doc.on('keydown.faq-' + sectionId, function (e) {
                    if (e.key === 'Escape') { closePopup(); }
                });
            });
        },
        initFeaturedBlogs: function () {
            $('.blog-slider-section').each(function () {
                var $section = $(this);
                var $slider  = $section.find('.blog-slider');
                if (!$slider.length) return;

                var arrowsDesktop = $section.data('arrows-desktop') === true || $section.data('arrows-desktop') === 'true';
                var dotsDesktop   = $section.data('dots-desktop')   === true || $section.data('dots-desktop')   === 'true';
                var arrowsTablet  = $section.data('arrows-tablet')  === true || $section.data('arrows-tablet')  === 'true';
                var dotsTablet    = $section.data('dots-tablet')    === true || $section.data('dots-tablet')    === 'true';
                var arrowsMobile  = $section.data('arrows-mobile')  === true || $section.data('arrows-mobile')  === 'true';
                var dotsMobile    = $section.data('dots-mobile')    === true || $section.data('dots-mobile')    === 'true';
                var autoplay      = $section.data('autoplay')       === true || $section.data('autoplay')       === 'true';
                var autoplaySpeed = parseInt($section.data('autoplay-speed'), 10) || 5000;

                $slider.slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: arrowsDesktop,
                    dots: dotsDesktop,
                    autoplay: autoplay,
                    autoplaySpeed: autoplaySpeed,
                    prevArrow: window.arrows.icon_prev,
                    nextArrow: window.arrows.icon_next,
                    responsive: [
                        {
                            breakpoint: 1199,
                            settings: {
                                slidesToShow: 3,
                                arrows: arrowsTablet,
                                dots: dotsTablet
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1,
                                arrows: arrowsMobile,
                                dots: dotsMobile
                            }
                        }
                    ]
                });
            });
        },
        initScrollingText: function () {
            $('.scrolling-text-section').each(function () {
                var $section = $(this);
                var $slider  = $section.find('.scrolling-text-slider');
                if (!$slider.length) return;

                var autoplayEnabled = $slider.data('autoplay') === true || $slider.data('autoplay') === 'true';
                var autoplaySpeed   = (parseInt($slider.data('autoplay-speed'), 10) || 1) * 1000;
                var arrowsEnabled   = $slider.data('arrows') === true || $slider.data('arrows') === 'true';

                $slider.slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    swipe: false,
                    autoplay: autoplayEnabled,
                    autoplaySpeed: autoplaySpeed,
                    arrows: arrowsEnabled,
                    prevArrow: window.arrows.icon_prev,
                    nextArrow: window.arrows.icon_next,
                    dots: false,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                autoplaySpeed: 5000
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                infinite: true,
                                slidesToShow: 1,
                                swipe: true,
                                autoplay: autoplayEnabled,
                                speed: 5000,
                                autoplaySpeed: autoplaySpeed,
                                cssEase: 'linear'
                            }
                        }
                    ]
                });

                $slider.on('beforeChange', function () {
                    $slider.find('.scrolling-text').addClass('paused');
                });
                $slider.on('afterChange', function () {
                    $slider.find('.scrolling-text').removeClass('paused');
                });

                var firstHeight = $section.find('.scrolling-text-item').first().outerHeight();
                $section.find('.scrolling-text-item').css('height', firstHeight + 'px');
            });
        },
        initFooter08: function () {
            $('.footer-08').each(function () {
                var $section    = $(this);
                var readMoreText = $section.data('read-more-text') || 'Read More';
                var readLessText = $section.data('read-less-text') || 'Read Less';

                // Newsletter validation
                $section.find('.newsletter-form').on('submit', function (e) {
                    var email = $section.find('.newsletter-input').val().trim();
                    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                        e.preventDefault();
                        alert('Please enter a valid email');
                    }
                });

                // Read More toggle
                var $desc   = $section.find('.desc-text');
                var $toggle = $section.find('.desc-toggle');
                $toggle.on('click', function () {
                    if ($desc.hasClass('expanded')) {
                        $desc.css('max-height', $desc[0].scrollHeight + 'px');
                        setTimeout(function () { $desc.css('max-height', '16px'); }, 10);
                        $desc.removeClass('expanded');
                        $toggle.text(readMoreText);
                    } else {
                        $desc.css('max-height', $desc[0].scrollHeight + 'px');
                        $desc.addClass('expanded');
                        $toggle.text(readLessText);
                    }
                });

                // Footer columns accordion (mobile only)
                function bindAccordion() {
                    if ($win.width() < 768) {
                        $section.find('.footer-column .column-title').off('click.footer').on('click.footer', function () {
                            var $col = $(this).closest('.footer-column');
                            if ($col.hasClass('active')) {
                                $col.removeClass('active');
                            } else {
                                $section.find('.footer-column').removeClass('active');
                                $col.addClass('active');
                            }
                        });
                    } else {
                        $section.find('.footer-column').removeClass('active');
                        $section.find('.footer-column .column-title').off('click.footer');
                    }
                }
                bindAccordion();
                $win.on('resize.footer08', bindAccordion);

                // Back to top
                var $backDesktop = $section.find('.back-to-top-desktop');
                $backDesktop.hide();

                $section.find('.back-to-top').on('click', function () {
                    $('html, body').animate({ scrollTop: 0 }, 400);
                });

                function updateBackToTopVisibility() {
                    if ($win.width() >= 768) {
                        if ($win.scrollTop() > 300) { $backDesktop.addClass('show'); }
                        else { $backDesktop.removeClass('show'); }
                    } else {
                        $backDesktop.removeClass('show');
                    }
                }
                updateBackToTopVisibility();

                $win.on('scroll.backToTop', function () {
                    if ($win.width() >= 768) {
                        if ($win.scrollTop() > 300) { $backDesktop.addClass('show'); }
                        else { $backDesktop.removeClass('show'); }
                    } else {
                        $backDesktop.removeClass('show');
                    }
                });

                $win.on('resize.backToTop', updateBackToTopVisibility);
            });
        },

        initChatSearchPopup: function () {
            var $searchInput = $('#Search-In-Modal-Single');
            var $popup       = $('.search-popup-for-ai');
            var $close       = $('.search-popup-for-ai-close-span');
            if (!$searchInput.length || !$popup.length) return;

            var hasUserInteracted = false;

            $popup.hide();

            $searchInput.on('mousedown keydown', function (e) {
                if (e.type === 'keydown' && e.key !== 'Tab') return;
                hasUserInteracted = true;
            });

            $searchInput.on('focusin', function () {
                if (hasUserInteracted && $searchInput.val().trim().length < 1) {
                    $popup.stop(true, true).fadeIn(150);
                }
            });

            $searchInput.on('input', function () {
                if ($searchInput.val().trim().length >= 1) {
                    $popup.stop(true, true).fadeOut(150);
                } else {
                    $popup.stop(true, true).fadeIn(150);
                }
            });

            $doc.on('click', function (e) {
                if (!$(e.target).closest('#Search-In-Modal-Single, .search-popup-for-ai').length) {
                    $popup.stop(true, true).fadeOut(150);
                    hasUserInteracted = false;
                }
            });

            $win.on('scroll', function () {
                if ($popup.is(':visible')) {
                    $popup.stop(true, true).fadeOut(150);
                }
                if ($searchInput.is(':focus')) {
                    $searchInput.blur();
                }
                hasUserInteracted = false;
            });

            if ($searchInput.is(':focus')) {
                $popup.hide();
            }

            $close.on('click', function () {
                $popup.hide();
            });
        },

        initMobileSearch: function () {
            var $container = $('.search-for-mobile-search-container');
            if (!$container.length) return;

            var $searchInput      = $('.search__input');
            var $suggestionWrapper = $container.find('.search-for-mobile-suggestions-warpper');
            var placeholders      = ($container.data('placeholder-texts') || '')
                                        .split(',')
                                        .map(function (s) { return s.trim(); })
                                        .filter(Boolean);

            /* Typewriter placeholder rotation */
            var currentIndex = 0;
            var deleting     = false;
            var charIndex    = 0;

            function typePlaceholder() {
                var text = 'Try Searching for... ' + placeholders[currentIndex];

                if (!deleting && charIndex < text.length) {
                    $searchInput.attr('placeholder', text.substring(0, ++charIndex));
                } else if (!deleting && charIndex === text.length) {
                    deleting = true;
                    setTimeout(typePlaceholder, 1000);
                    return;
                } else if (deleting && charIndex > 0) {
                    $searchInput.attr('placeholder', text.substring(0, --charIndex));
                } else if (deleting && charIndex === 0) {
                    deleting = false;
                    currentIndex = (currentIndex + 1) % placeholders.length;
                }

                setTimeout(typePlaceholder, deleting ? 40 : 100);
            }

            if (placeholders.length > 0) {
                typePlaceholder();
            }

            /* Hide/show suggestions on scroll */
            $win.on('scroll.mobileSearch', function () {
                if ($win.scrollTop() > 0) {
                    $suggestionWrapper.addClass('hide-search-suggestion');
                    $body.addClass('header-sticky-added');
                } else {
                    $suggestionWrapper.removeClass('hide-search-suggestion');
                    $body.removeClass('header-sticky-added');
                }
            });
        },

        initMobileLoginInfo: function(){
          
            const $loginBtn = $('.header-mobile-icon-login');
            const $infoBox = $('.mobile-login-info');

            $loginBtn.on('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                const $clickedBtn = $(e.currentTarget);
                const $iconContainer = $clickedBtn.closest('.header-mobile--icon');
                
                // Use getBoundingClientRect for more accurate positioning
                const iconRect = $iconContainer[0].getBoundingClientRect();
                const infoBoxWidth = $infoBox.outerWidth();
                
                // Calculate position relative to viewport, then adjust for scroll
                const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
                const leftPosition = iconRect.left + (iconRect.width / 2) - (infoBoxWidth / 2) + scrollLeft;
                
                // Boundary checking to prevent going off-screen
                const viewportWidth = window.innerWidth;
                const rightEdge = leftPosition + infoBoxWidth;
                
                let finalLeft = leftPosition;
                if (leftPosition < 10) {
                finalLeft = 10;
                } else if (rightEdge > viewportWidth - 10) {
                finalLeft = viewportWidth - infoBoxWidth - 10;
                }
                
                $infoBox.css({
                left: finalLeft + 'px' // 5px gap below the icon
                });
                
                $infoBox.stop(true, true).slideToggle(200);
            });

            $(document).on('click', (e) => {
                if (!$(e.target).closest('.header-mobile--icon').length && 
                    !$(e.target).closest('.mobile-login-info').length) {
                $infoBox.slideUp(200);
                }
            });

            $infoBox.on('click', (e) => {
                e.stopPropagation();
            });

        },
        initProductRecs: function () {
            var slickSettings = {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                prevArrow: window.arrows ? window.arrows.icon_prev : '<button type="button" class="slick-prev">Previous</button>',
                nextArrow: window.arrows ? window.arrows.icon_next : '<button type="button" class="slick-next">Next</button>',
                dots: false,
                swipeToSlide: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: { slidesToShow: 3 }
                    },
                    {
                        breakpoint: 768,
                        settings: { slidesToShow: 2, swipe: true }
                    },
                    {
                        breakpoint: 480,
                        settings: { slidesToShow: 2, swipe: true }
                    }
                ]
            };
        
            function initSlider($slider) {
                if ($slider.hasClass('slick-initialized')) return;
                if ($slider.children().length === 0) return;
                $slider.slick(slickSettings);
            }
        
            // 1. Init any slider that's currently visible on page load
            $('.product-recs-slider').each(function () {
                var $slider = $(this);
                if ($slider.is(':visible')) {
                    initSlider($slider);
                }
            });
        
            // 2. Re-init when a tab containing a slider becomes visible.
            //    Slick can't measure widths inside a display:none parent,
            //    so on tab click we either init fresh or call setPosition.
            $(document).on('click', '.product-options-tab-button', function () {
                var $btn = $(this);
                var tabId = $btn.data('tab');
        
                setTimeout(function () {
                    $('#' + tabId + ' .product-recs-slider').each(function () {
                        var $slider = $(this);
                        if (!$slider.hasClass('slick-initialized')) {
                            initSlider($slider);
                        } else {
                            $slider.slick('setPosition');
                        }
                    });
                }, 50);
            });
        
            // 3. Window resize safety net
            $(window).on('resize', function () {
                $('.product-recs-slider.slick-initialized:visible').slick('setPosition');
            });
        },
        initColorSlider: function () {
                var self = this;
            
                var slickSettings = {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: true,
                    prevArrow: window.arrows ? window.arrows.icon_prev : '<button type="button" class="slick-prev">Previous</button>',
                    nextArrow: window.arrows ? window.arrows.icon_next : '<button type="button" class="slick-next">Next</button>',
                    dots: false,
                    swipeToSlide: true,
                    // CRITICAL: don't break the radio inputs inside slides
                    // accessibility: false stops Slick from intercepting keypress
                    // that would interfere with radio focus behaviour
                    accessibility: false,
                    responsive: [
                        { breakpoint: 1024, settings: { slidesToShow: 3 } },
                        { breakpoint: 768,  settings: { slidesToShow: 2, swipe: true } },
                        { breakpoint: 480,  settings: { slidesToShow: 2, swipe: true } }
                    ]
                };
            
                function initSlider($slider) {
                    if (!$slider.length) return;
                    if ($slider.hasClass('slick-initialized')) return;
                    if ($slider.children().length === 0) return;
                    $slider.slick(slickSettings);
                }
            
                var $slider = $('.color-recs-slider').first();
                if (!$slider.length) return;
            
                // Wait for AJAX-loaded recommendations (event-based)
                // If AJAX fires - init AFTER cards are appended.
                // If AJAX never fires (no SKU recs / fetch failed) - the script
                //   itself never gets injected, so we init now with what we have.
                var hasAjaxScript = ($('script:contains("waitForJQueryLib")').length > 0);
            
                if (hasAjaxScript) {
                    $(document).one('colorRecsLoaded', function () {
                        initSlider($slider);
                    });
                } else {
                    // No AJAX - just init with the server-rendered variant cards
                    initSlider($slider);
                }
            
                // Re-init on tab switch if the Colors tab was hidden initially
                // (Slick can't measure widths inside display:none parents)
                $(document).on('click', '.product-options-tab-button[data-tab="product-options-tab1"]', function () {
                    setTimeout(function () {
                        if ($slider.hasClass('slick-initialized')) {
                            $slider.slick('setPosition');
                        } else if ($slider.children().length > 0) {
                            initSlider($slider);
                        }
                    }, 50);
                });
            
                // Resize safety net
                $(window).on('resize.colorSlider', function () {
                    if ($slider.hasClass('slick-initialized') && $slider.is(':visible')) {
                        $slider.slick('setPosition');
                    }
                });
            },
        initMoreLikeThis: function () {
            var $btn = $('#morelikethis');
            var $container = $('.morelikethis-content');
            if (!$btn.length || !$container.length) return;

            var isLoggedIn = window.customerLoggedIn === true && window.customerId;

            // Defensive check - tell developer if loading order is wrong
            if (isLoggedIn) {
                // ai-token-manager-search-collection.js
                if (typeof window.GDAuth === 'undefined') {
                    console.error('[More Like This] GDAuth not loaded - check script load order');
                    return;
                }
            } else {
                // ai-public-search-morelikethis-token-manager.js
                if (typeof window.GoddivaAiAuth === 'undefined') {
                    console.error('[More Like This] GoddivaAiAuth not loaded - check script load order');
                    return;
                }
            }

            var API_BASE = 'https://ai.mygoddiva.com';

            function formatPounds(p) {
                if (p === undefined || p === null || p === '') return '';
                var n = parseFloat(p);
                if (isNaN(n)) return '';
                return '\u00a3' + n.toFixed(2);
            }

            function escapeHtml(str) {
                if (str == null) return '';
                return String(str)
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#39;');
            }

            // Helper: extract color name from product title
            // Pattern: "Product Name - Color by Vendor"  ->  "Color"
            function extractColorName(title) {
                if (!title) return '';
                // Primary pattern: " - Color by Vendor"
                var match = title.match(/\s-\s([^-]+?)\s+by\s+/i);
                if (match && match[1]) {
                    return match[1].trim();
                }
                // Fallback pattern: " - Color" at end of string
                var match2 = title.match(/\s-\s([^-]+?)$/);
                if (match2 && match2[1]) {
                    return match2[1].trim();
                }
                return title; // last resort
            }

            function buildCard(item) {
                var rawTitle = item.title || '';
                var title = escapeHtml(rawTitle);
                var colorName = escapeHtml(extractColorName(rawTitle));
                var handle = item.handle || '';
                var url = handle ? '/products/' + handle : '#';
                var image = item.image || '';
                var priceHtml = '';
                var saleclass = '';
                if (item.sale_price !== null && item.sale_price !== undefined && item.sale_price !== '') {
                    saleclass = 'product-recs-price-sale';
                    priceHtml = '<s class="price-item price-item--regular"><span class="money">' + formatPounds(item.price) + '</span></s> ';
                    priceHtml += '<span class="price-item price-item--sale"><span class="money">' + formatPounds(item.sale_price) + '</span></span>';
                } else {
                    priceHtml = '<span class="price-item price-item--regular"><span class="money">' + formatPounds(item.price) + '</span></span>';
                }
                var imgHtml = '';
                if (image) {
                    imgHtml = '<img src="' + image + '" alt="' + title + '" loading="lazy">';
                } else {
                    imgHtml = '<img src="" alt="' + title + '" class="is-fallback" loading="lazy">';
                }
                var html = '<div class="product-recs-card">';
                html += '<a href="' + url + '" class="product-recs-link">';
                html += '<div class="product-recs-image">' + imgHtml + '<span class="variant-name-hover">' + colorName + '</span></div>';
                html += '<div class="product-recs-info">';
                html += '<div class="product-recs-price ' + saleclass + '">' + priceHtml + '</div>';
                html += '</div></a>';
                html += buildAvailableInThumbs(item.available_ins);
                html += '</div>';
                return html;
            }

            // Thumbnails linking to the other colours of the same style (available_ins).
            // Shows up to MAX_THUMBS; extras are hidden behind a "+N" toggle.
            var MAX_THUMBS = 2;

            // ------------------------------------------------------------------
            // EXPANDED LAYOUT SWITCH - change this one value to switch layouts:
            //   'overlay' - extras open in a floating panel over the product
            //               image; card height never changes.
            //   'scroll'  - extras appear in the same row, which scrolls
            //               sideways; the +N / − button stays pinned on the right.
            //   'wrap'    - extras wrap onto new rows below; the card grows taller.
            // The matching CSS lives in product-variant.css under
            // ".product-recs-thumbs--overlay / --scroll / --wrap".
            // ------------------------------------------------------------------
            var THUMBS_EXPAND_LAYOUT = 'overlay';

            function buildThumb(alt) {
                var altColor = escapeHtml(extractColorName(alt.title || ''));
                var thumbSrc = alt.image + (alt.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
                return '<a href="/products/' + encodeURIComponent(alt.handle) + '" class="product-recs-thumb" title="' + altColor + '"'
                    + ' data-image="' + escapeHtml(alt.image) + '" data-color="' + altColor + '">'
                    + '<img src="' + escapeHtml(thumbSrc) + '" alt="' + escapeHtml(alt.title || '') + '" loading="lazy">'
                    + '</a>';
            }

            function buildAvailableInThumbs(availableIns) {
                if (!Array.isArray(availableIns)) return '';
                var valid = availableIns.filter(function (alt) {
                    return alt && alt.handle && alt.image;
                });
                if (!valid.length) return '';
                // Markup: [track: thumbs + hidden extras] [+N button]
                // The button sits outside the track so it never overlaps the thumbnails.
                var html = '<div class="product-recs-thumbs product-recs-thumbs--' + THUMBS_EXPAND_LAYOUT + '">';
                html += '<div class="product-recs-thumbs-track">';
                for (var i = 0; i < Math.min(valid.length, MAX_THUMBS); i++) {
                    html += buildThumb(valid[i]);
                }
                var extra = valid.length - MAX_THUMBS;
                if (extra > 0) {
                    html += '<div class="product-recs-thumbs-extra">';
                    for (var j = MAX_THUMBS; j < valid.length; j++) {
                        html += buildThumb(valid[j]);
                    }
                    html += '</div>';
                }
                html += '</div>';
                if (extra > 0) {
                    var moreTitle = extra + ' more colour' + (extra > 1 ? 's' : '');
                    html += '<button type="button" class="product-recs-thumb product-recs-thumb-more"'
                        + ' aria-expanded="false" title="' + moreTitle + '"'
                        + ' data-more-label="+' + extra + '" data-less-label="−' + extra + '"'
                        + ' data-more-title="' + moreTitle + '">+' + extra + '</button>';
                }
                html += '</div>';
                return html;
            }

            function setThumbsExpanded($thumbs, expanded) {
                var $more = $thumbs.find('.product-recs-thumb-more');
                $thumbs.toggleClass('is-expanded', expanded);
                $more
                    .attr('aria-expanded', expanded ? 'true' : 'false')
                    .attr('title', expanded ? 'Show fewer colours' : $more.data('more-title'))
                    .text(expanded ? $more.data('less-label') : $more.data('more-label'));
                var $track = $thumbs.find('.product-recs-thumbs-track');
                if (!expanded) {
                    $track.stop().scrollLeft(0);
                } else if ($thumbs.hasClass('product-recs-thumbs--scroll')) {
                    // Scroll layout: slide the first hidden colour into view as a hint
                    var $firstExtra = $track.find('.product-recs-thumbs-extra .product-recs-thumb').first();
                    if ($firstExtra.length) {
                        var target = $firstExtra.position().left + $firstExtra.outerWidth() - $track.innerWidth();
                        if (target > 0) {
                            $track.stop().animate({ scrollLeft: target }, 250);
                        }
                    }
                }
            }

            // "+N" toggles the hidden colour thumbnails open / closed
            $container.on('click', '.product-recs-thumb-more', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var $thumbs = $(this).closest('.product-recs-thumbs');
                var expanded = !$thumbs.hasClass('is-expanded');
                // Only one card open at a time
                $container.find('.product-recs-thumbs.is-expanded').not($thumbs).each(function () {
                    setThumbsExpanded($(this), false);
                });
                setThumbsExpanded($thumbs, expanded);
            });

            // Clicking anywhere outside an open card closes it
            $(document).on('click.moreLikeThisThumbs', function (e) {
                if ($(e.target).closest('.product-recs-thumbs').length) return;
                $container.find('.product-recs-thumbs.is-expanded').each(function () {
                    setThumbsExpanded($(this), false);
                });
            });

            // Hovering a thumbnail previews that colour in the card's main image
            $container.on('mouseenter', '.product-recs-thumb:not(.product-recs-thumb-more)', function () {
                var $thumb = $(this);
                var $card = $thumb.closest('.product-recs-card');
                var $img = $card.find('.product-recs-image img');
                var $label = $card.find('.variant-name-hover');
                if ($img.attr('data-original-src') === undefined) {
                    $img.attr('data-original-src', $img.attr('src'));
                    $label.attr('data-original-text', $label.text());
                }
                $img.attr('src', $thumb.data('image'));
                $label.text($thumb.data('color'));
                $card.find('.product-recs-thumb').removeClass('is-active');
                $thumb.addClass('is-active');
            });

            $container.on('mouseleave', '.product-recs-thumbs', function () {
                var $card = $(this).closest('.product-recs-card');
                var $img = $card.find('.product-recs-image img');
                var $label = $card.find('.variant-name-hover');
                if ($img.attr('data-original-src') !== undefined) {
                    $img.attr('src', $img.attr('data-original-src'));
                    $label.text($label.attr('data-original-text'));
                }
                $card.find('.product-recs-thumb').removeClass('is-active');
            });

            function showLoader() {
                $container.html('<div class="morelikethis-loader"><div class="morelikethis-spinner"> </div><p>Finding Similar Styles...</p></div>');
            }

            function showError() {
                $container.html('<div class="morelikethis-error"><p>Could not load Similar Styles.</p><button type="button" class="morelikethis-retry">Try again</button></div>');
            }

            function showEmpty() {
                $container.html('<p class="morelikethis-empty">No Similar Styles found.</p>');
            }

            function fetchSimilarProducts(productId) {
                var url = API_BASE + '/get-simmilar-products?shopify_id=' + encodeURIComponent(productId);

                if (isLoggedIn) {
                    // Logged in: customer-scoped token via GDAuth (native fetch).
                    // Token validation, refresh, and 401 retry handled inside authFetch.
                    return window.GDAuth.authFetch(url, { method: 'GET' }, window.customerId)
                        .then(function (res) {
                            if (!res.ok) {
                                throw new Error('Request failed: ' + res.status);
                            }
                            return res.json();
                        });
                }

                // Guest: public token via GoddivaAiAuth (jQuery ajax).
                // Token management (validation, refresh, 401 retry) is delegated to
                // GoddivaAiAuth defined in ai-public-search-morelikethis-token-manager.js.
                // Wrapped in Promise.resolve so both paths return a native Promise.
                return Promise.resolve(window.GoddivaAiAuth.authAjax({
                    url: url,
                    method: 'GET',
                    dataType: 'json'
                }));
            }

            function loadAndRender() {
                var productId = $btn.data('product-id');
                if (!productId) {
                    showEmpty();
                    return;
                }
                showLoader();
                fetchSimilarProducts(productId)
                    .then(function (response) {
                        var items = [];
                        if (Array.isArray(response)) {
                            items = response;
                        } else if (response && Array.isArray(response.data)) {
                            items = response.data;
                        }
                        if (!items.length) {
                            showEmpty();
                            return;
                        }
                        $container.html(buildStrip(items));
                        $container.attr('data-loaded', 'true');
                        initStrip($container.find('.mlt-strip'));
                    })
                    .catch(function (err) {
                        console.error('More Like This error:', err);
                        showError();
                        $container.find('.morelikethis-retry').on('click', function () {
                            loadAndRender();
                        });
                    });
            }

            // ------------------------------------------------------------------
            // Swipe strip + scrubber
            //   - native horizontal scroll (touch swipe / trackpad / mouse drag)
            //   - a part-cut card at the edge hints there is more
            //   - the scrubber shows position and can be dragged
            //   - arrows jump a full page of cards, not one item
            //   - "1–6 of 54" counter shows which cards are in view
            // Cards per view are set in product-variant.css (--mlt-visible).
            // ------------------------------------------------------------------
            var CHEVRON_PREV = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            var CHEVRON_NEXT = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

            function buildStrip(items) {
                var html = '<div class="mlt-strip">';
                html += '<div class="mlt-track" tabindex="0" aria-label="Similar styles">';
                for (var i = 0; i < items.length; i++) {
                    html += buildCard(items[i]);
                }
                html += '</div>';
                html += '<div class="mlt-controls">';
                html += '<button type="button" class="mlt-arrow mlt-prev" aria-label="Previous styles">' + CHEVRON_PREV + '</button>';
                html += '<input type="range" class="mlt-scrubber" min="0" max="1000" step="1" value="0" aria-label="Scroll similar styles">';
                html += '<span class="mlt-count" aria-live="polite"></span>';
                html += '<button type="button" class="mlt-arrow mlt-next" aria-label="More styles">' + CHEVRON_NEXT + '</button>';
                html += '</div>';
                html += '</div>';
                return html;
            }

            function stripMetrics($strip) {
                var track = $strip.find('.mlt-track')[0];
                var cards = track ? track.children : [];
                var gap = track ? (parseFloat(window.getComputedStyle(track).columnGap) || 0) : 0;
                var step = cards.length ? cards[0].getBoundingClientRect().width + gap : 0;
                var perView = step ? Math.max(1, Math.floor((track.clientWidth + gap + 1) / step)) : 1;
                return {
                    track: track,
                    total: cards.length,
                    step: step,
                    perView: perView,
                    max: track ? Math.max(0, track.scrollWidth - track.clientWidth) : 0
                };
            }

            function updateStrip($strip) {
                var m = stripMetrics($strip);
                if (!m.track || !m.step || !m.track.clientWidth) return; // hidden tab
                var left = m.track.scrollLeft;
                var atEnd = left >= m.max - 2;
                var first = Math.min(m.total, Math.round(left / m.step) + 1);
                var last = Math.min(m.total, first + m.perView - 1);
                if (atEnd) {
                    last = m.total;
                    first = Math.max(1, m.total - m.perView + 1);
                }
                $strip.find('.mlt-count').text(first + '–' + last + ' of ' + m.total);

                var ratio = m.max > 0 ? left / m.max : 0;
                var scrubber = $strip.find('.mlt-scrubber')[0];
                if (!$strip.hasClass('is-scrubbing')) {
                    scrubber.value = Math.round(ratio * 1000);
                }
                scrubber.style.setProperty('--mlt-fill', (scrubber.value / 10) + '%');

                $strip.find('.mlt-prev').prop('disabled', left <= 2);
                $strip.find('.mlt-next').prop('disabled', atEnd);
                $strip.toggleClass('is-static', m.max <= 2);
            }

            function initStrip($strip) {
                if (!$strip.length) return;
                var track = $strip.find('.mlt-track')[0];
                var ticking = false;

                track.addEventListener('scroll', function () {
                    if (ticking) return;
                    ticking = true;
                    window.requestAnimationFrame(function () {
                        ticking = false;
                        updateStrip($strip);
                    });
                }, { passive: true });

                // Mouse drag to scroll (touch and trackpads scroll natively)
                var drag = { active: false, moved: false, startX: 0, startLeft: 0 };
                track.addEventListener('pointerdown', function (e) {
                    if (e.pointerType !== 'mouse' || e.button !== 0) return;
                    if ($(e.target).closest('.product-recs-thumbs').length) return;
                    drag.active = true;
                    drag.moved = false;
                    drag.startX = e.clientX;
                    drag.startLeft = track.scrollLeft;
                });
                window.addEventListener('pointermove', function (e) {
                    if (!drag.active) return;
                    var dx = e.clientX - drag.startX;
                    if (!drag.moved && Math.abs(dx) > 5) {
                        drag.moved = true;
                        $strip.addClass('is-dragging');
                    }
                    if (drag.moved) {
                        track.scrollLeft = drag.startLeft - dx;
                    }
                });
                window.addEventListener('pointerup', function () {
                    if (!drag.active) return;
                    drag.active = false;
                    $strip.removeClass('is-dragging');
                });
                // A drag must not count as a click on the card link
                track.addEventListener('click', function (e) {
                    if (drag.moved) {
                        e.preventDefault();
                        e.stopPropagation();
                        drag.moved = false;
                    }
                }, true);
                track.addEventListener('dragstart', function (e) {
                    e.preventDefault();
                });

                updateStrip($strip);
            }

            // Arrows jump a full page of cards
            $container.on('click', '.mlt-arrow', function () {
                var $strip = $(this).closest('.mlt-strip');
                var m = stripMetrics($strip);
                var dir = $(this).hasClass('mlt-next') ? 1 : -1;
                m.track.scrollBy({ left: dir * m.perView * m.step, behavior: 'smooth' });
            });

            // Dragging the scrubber scrolls the strip
            $container.on('input', '.mlt-scrubber', function () {
                var $strip = $(this).closest('.mlt-strip');
                var m = stripMetrics($strip);
                $strip.addClass('is-scrubbing');
                m.track.scrollLeft = (this.value / 1000) * m.max;
                this.style.setProperty('--mlt-fill', (this.value / 10) + '%');
            });

            $container.on('change pointerup', '.mlt-scrubber', function () {
                var $strip = $(this).closest('.mlt-strip');
                $strip.removeClass('is-scrubbing');
                updateStrip($strip);
            });

            $(document).on('click', '#morelikethis', function () {
                if ($container.attr('data-loaded') === 'true') {
                    // Tab was hidden, so re-measure now it is visible
                    setTimeout(function () {
                        updateStrip($container.find('.mlt-strip'));
                    }, 50);
                    return;
                }
                loadAndRender();
            });

            $(window).on('resize.moreLikeThis', function () {
                var $strip = $container.find('.mlt-strip');
                if ($strip.length) {
                    updateStrip($strip);
                }
            });
        }


      
    }
    window.halo = halo;
})(jQuery);
window.addEventListener("DOMContentLoaded", (event) => {
  console.log("DOM fully loaded and parsed");
});
window.addEventListener("load", (event) => {
  console.log("page is fully loaded");
});